<template>
  <div id="caseinfo">
    <loading-overlay v-if="loading"></loading-overlay>
    <div>
      <!-- <h3>案件审批详情</h3> -->
      <div class="detail">
        <el-row>
          <el-col :span="18">
            <div class="Top">
              <el-steps space="100%" align-center>
                <el-step
                  v-for="(item, i) in form.link"
                  :title="item.name"
                  :key="i"
                  :status="item.result"
                  @click.native="step_click(item.id)"
                ></el-step>
                <el-step
                  v-if="step"
                  title="+添加程序"
                  status="finish"
                  :key="form.link.length"
                  @click.native="addStep()"
                ></el-step>
              </el-steps>
            </div>
            <div class="contain">
              <el-form
                class="form"
                ref="formref"
                :model="form"
                :rules="formrules"
                label-width="120px"
              >
                <div class="text">
                  <div class="icon"></div>
                  <div>案件信息：{{ form.title }}</div>
                </div>
                <div
                  v-if="
                    numType == 1 ||
                    numType == 2 ||
                    numType == 3 ||
                    numType == 4 ||
                    numType == 5 ||
                    numType == 6
                  "
                >
                  <el-row>
                    <el-col :span="24" v-if="numType == 3">
                      <el-form-item label="公益诉讼" prop="public_welfare">
                        <el-select
                          v-if="form.bcz != null"
                          v-model="form.bcz.public_welfare"
                          placeholder="请选择"
                          class="select"
                          clearable
                          :disabled="bianji"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="案件名称" prop="title">
                        <el-input
                          v-model="form.title"
                          placeholder="请输入"
                          clearable
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="受理机构案号" prop="acceptcode">
                        <el-input
                          v-model="form.acceptcode"
                          placeholder="请输入"
                          clearable
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="案件编号" prop="code">
                        <el-input
                          v-model="form.code"
                          placeholder="自动编号"
                          disabled
                          clearable
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="numType != 4">
                      <el-form-item label="法律援助" prop="assist">
                        <el-select
                          v-model="form.assist"
                          placeholder="请选择"
                          class="select"
                          clearable
                          :disabled="bianji"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in Flyz"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="案卷状态" prop="ajstatus">
                        <el-select
                          v-model="form.ajstatus"
                          placeholder="请选择"
                          class="select"
                          clearable
                          :disabled="bianji"
                          style="width: 100%"
                          @change="inputType(form.ajstatus, null)"
                        >
                          <el-option
                            v-for="item in Ajstatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            style="width: 100%"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="6" class="date_box">
                      <el-form-item label="收案日期" prop="approvaldate">
                        <div
                          class="date_box"
                          @mouseover="onMouseOver()"
                          @mouseleave="onMouseleave()"
                        >
                          <el-date-picker
                            style="width: 100%"
                            v-model="form.approvaldate"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="请选择日期"
                            clearable
                            :disabled="bianji"
                          >
                          </el-date-picker>
                          <i class="el-icon-date" ref="iconDate"></i>
                        </div>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6">
                      <el-form-item label="案由" prop="cause">
                        <el-input
                          v-model="form.cause"
                          placeholder="请输入"
                          clearable
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="案件来源" prop="source">
                        <el-input
                          v-model="form.source"
                          placeholder="请输入"
                          clearable
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="受理机构" prop="acceptUnit">
                        <el-input
                          v-model="form.acceptUnit"
                          placeholder="请输入"
                          clearable
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="false">
                    <el-col :span="10">
                      <el-form-item label="受理状态" prop="casestatus">
                        <el-select
                          :disabled="bianji"
                          v-model="form.casestatus"
                          placeholder="请选择"
                          class="select"
                          clearable
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in CaseStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        size="small"
                        @click="Accept()"
                        style="margin-left: 10px; margin-top: 4px"
                        v-if="form.casestatus == '未受理' && bianji && form.uid"
                        type="primary"
                        plain
                        >点此受理</el-button
                      >
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="代理律师" prop="leadLawyer">
                        <el-select
                          style="width: 100%"
                          v-model="form.leadLawyer"
                          placeholder="请选择"
                          class="select"
                          clearable
                          multiple
                          :multiple-limit="1"
                          @change="LeadLawyerChange(form.leadLawyer)"
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in Lawyer"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="代理律师" prop="coCounsel">
                        <el-select
                          filterable
                          style="width: 100%"
                          v-model="form.coCounsel"
                          placeholder="请选择"
                          class="select"
                          clearable
                          multiple
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in Lawyer"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                
                    <el-col
                      :span="6"
                      v-if="
                        form.result == 1 || bianji == false || bianji == false
                      "
                    >   <el-form-item label="部门主管" prop="caseLeaderscase">
                        <el-select
                          filterable
                          style="width: 100%"
                          v-model="form.caseLeaderscase"
                          placeholder="请选择"
                          class="select"
                          clearable
                        
                          :disabled="bianji"
                          
                        >
                        <el-option
                            v-for="item in CaseLeaders"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    
                    </el-col>
                    <el-col
                      :span="6"
                      v-if="
                        numType != 7 &&
                        numType != 8 &&
                        numType != 14 &&
                        numType != 9 &&
                        (form.result == 1 || bianji == false)
                      "
                    >
                      <el-form-item label="二次审批人" prop="level">
                        <el-select
                          filterable
                          style="width: 100%"
                          v-model="form.level"
                          placeholder="请选择"
                          class="select"
                          clearable
                          multiple
                          :disabled="bianji"
                          :multiple-limit="1"
                        >
                          <el-option
                            v-for="item in Level"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="false" :span="8">
                      <el-form-item
                        label="委托事项"
                        prop="remark"
                        v-if="numType != 2"
                      >
                        <el-select
                          style="width: 100%"
                          v-model="form.remark"
                          placeholder="请选择"
                          class="select"
                          clearable
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in Entrust"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        v-if="numType == 2"
                        label="介入阶段"
                        prop="intervene"
                      >
                        <el-select
                          filterable
                          v-if="form.bcz != null"
                          style="width: 100%"
                          v-model="form.bcz.intervene"
                          placeholder="请选择"
                          class="select"
                          clearable
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in Intervene"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row
                    v-if="numType == 2 && (form.result == 1 || bianji == false)"
                  >
                    <el-form-item label="刑事风险控制人" prop="criminalrisk">
                      <el-select
                        style="width: 100%"
                        v-model="form.criminalrisk"
                        placeholder="请选择"
                        class="select"
                        clearable
                        :disabled="bianji"
                        @change="bmzgChange"
                      >
                        <el-option
                          v-for="item in Criminal"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-row>
                </div>

                <div v-else>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="项目名称" prop="title">
                        <el-input
                          v-model="form.title"
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row
                    v-if="
                      numType != 7 &&
                      numType != 8 &&
                      numType != 14 &&
                      numType != 9
                    "
                  >
                    <el-form-item label="受理机构案号" prop="acceptcode">
                      <el-input
                        v-model="form.acceptcode"
                        placeholder="请输入"
                        clearable
                        :disabled="bianji"
                      ></el-input>
                    </el-form-item>
                  </el-row>

                  <el-row>
                    <el-form-item label="项目概要" prop="cause">
                      <el-input
                        v-model="form.cause"
                        placeholder="请输入"
                        :disabled="bianji"
                      ></el-input>
                    </el-form-item>
                  </el-row>

                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="案件编号" prop="code">
                        <el-input
                          v-model="form.code"
                          placeholder="自动编号"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="案卷状态" prop="ajstatus">
                        <el-select
                          v-model="form.ajstatus"
                          placeholder="请选择"
                          class="input"
                          style="width: 100%"
                          :disabled="bianji"
                          @change="inputType(form.ajstatus, null)"
                        >
                          <el-option
                            v-for="item in Ajstatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="项目合伙人" prop="partner">
                        <el-input
                          v-if="form.bcz != null"
                          v-model="form.bcz.partner"
                          placeholder="请输入"
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="底稿资料" prop="draft">
                        <el-select
                          v-if="form.bcz != null"
                          v-model="form.bcz.draft"
                          placeholder="请选择"
                          class="select"
                          :disabled="bianji"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in Draft"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6" class="date_box">
                      <el-form-item label="立项日期" prop="approvaldate">
                        <el-date-picker
                          style="width: 100%"
                          v-model="form.approvaldate"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="请选择日期"
                          :disabled="bianji"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="项目来源" prop="source">
                        <el-input
                          v-model="form.source"
                          placeholder="请输入"
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        :label="numType == 10 ? '代理机构' : '受理机构'"
                        prop="acceptUnit"
                        v-if="numType == 10"
                      >
                        <el-input
                          v-model="form.acceptUnit"
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="numType == 10 ? '代理机构' : '受理机构'"
                        v-if="numType != 10"
                      >
                        <el-input
                          v-model="form.acceptUnit"
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col
                      :span="6"
                      v-if="
                        numType == 7 ||
                        numType == 8 ||
                        numType == 14 ||
                        numType == 9 ||
                        numType == 11 ||
                        numType == 15
                      "
                    >
                      <el-form-item label="项目分类" prop="classification">
                        <el-input
                          v-if="form.bcz != null"
                          v-model="form.bcz.classification"
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="numType == 10">
                      <el-form-item label="项目类型" prop="projecttype">
                        <el-select
                          v-if="form.bcz != null"
                          style="width: 100%"
                          v-model="form.bcz.projecttype"
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in Projecttype"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row v-if="false">
                    <el-col :span="12">
                      <el-form-item label="受理状态" prop="casestatus">
                        <el-select
                          :disabled="bianji"
                          v-model="form.casestatus"
                          placeholder="请选择"
                          class="select"
                          clearable
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in CaseStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        size="small"
                        @click="Accept()"
                        style="margin-left: 20px"
                        v-if="form.casestatus == '未受理' && bianji && form.uid"
                        type="primary"
                        plain
                        >点此受理</el-button
                      >
                    </el-col>
                  </el-row>
                  <!-- <div class="divider"></div> -->
                  <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
                  <div v-if="numType == 10">
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="开放时间" prop="opentime">
                          <el-date-picker
                            v-if="form.bcz != null"
                            style="width: 100%"
                            v-model="form.bcz.opentime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            :disabled="bianji"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="采购方式" prop="procuremethod">
                          <el-input
                            v-if="form.bcz != null"
                            v-model="form.bcz.procuremethod"
                            placeholder="请输入"
                            :disabled="bianji"
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col :span="6">
                        <el-form-item label="预算金额" prop="budgetmoney">
                          <el-input
                            v-if="form.bcz != null"
                            v-model="form.bcz.budgetmoney"
                            placeholder="请输入"
                            :disabled="bianji"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="采购编号" prop="procurecode">
                          <el-input
                            v-if="form.bcz != null"
                            v-model="form.bcz.procurecode"
                            placeholder="请输入"
                            :disabled="bianji"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        :label="numType == 10 ? '服务律师' : '代理律师'"
                        prop="leadLawyer"
                      >
                        <el-select
                          filterable
                          style="width: 100%"
                          v-model="form.leadLawyer"
                          class="select"
                          multiple
                          :multiple-limit="1"
                          @change="LeadLawyerChange(form.leadLawyer)"
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in Lawyer"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="代理律师" prop="coCounsel">
                        <el-select
                          filterable
                          style="width: 100%"
                          v-model="form.coCounsel"
                          placeholder="请选择"
                          class="select"
                          clearable
                          multiple
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in Lawyer"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col
                      :span="6"
                      v-if="
                        form.result == 1 || bianji == false || bianji == false
                      "
                    >
                      <el-form-item label="部门主管" prop="caseLeaderscase">
                        <el-select
                          filterable
                          style="width: 100%"
                          v-model="form.caseLeaderscase"
                          placeholder="请选择"
                          class="select"
                          clearable
                          @change="bmzgChange"
                        >
                          <el-option
                            v-for="item in CaseLeaders"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col
                      :span="6"
                      v-if="
                        (numType == 7 || numType == 8 || numType == 14) &&
                        (form.result == 1 || bianji == false)
                      "
                    >
                      <el-form-item label="风控委" prop="level">
                        <el-select
                          filterable
                          style="width: 100%"
                          v-model="form.level"
                          class="select"
                          multiple
                          :multiple-limit="2"
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in FKW"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col
                      v-if="
                        numType == 9 && (form.result == 1 || bianji == false)
                      "
                      :span="6"
                    >
                      <el-form-item label="风控委" prop="level">
                        <el-select
                          filterable
                          style="width: 100%"
                          v-model="form.level"
                          class="select"
                          multiple
                          :multiple-limit="1"
                          :disabled="bianji"
                        >
                          <el-option
                            v-for="item in FKW"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
                  <el-row
                    v-if="
                      numType != 7 &&
                      numType != 8 &&
                      numType != 14 &&
                      numType != 9 &&
                      (form.result == 1 || bianji == false)
                    "
                  >
                    <el-form-item label="二次审批人" prop="level">
                      <el-select
                        style="width: 100%"
                        v-model="form.level"
                        class="select"
                        multiple
                        filterable
                        :multiple-limit="1"
                        :disabled="bianji"
                        @change="bmzgChange"
                      >
                        <el-option
                          v-for="item in Level"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-row>

                  <!-- 专项服务合同独有字段 -->
                  <div v-if="numType == 11 || numType == 15">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="合同服务类型" prop="contracttype">
                          <el-input
                            v-if="form.bcz != null"
                            v-model="form.bcz.contracttype"
                            placeholder="请输入"
                            :disabled="bianji"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="服务期限" prop="servicetime">
                          <el-date-picker
                            v-if="form.bcz != null"
                            style="width: 100%"
                            v-model="form.bcz.servicetime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            :disabled="bianji"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <!-- <div class="divider"></div> -->

                  <el-row v-if="numType != 9&&numType!=11">
                    <el-col :span=24 v-if="numType == 10">
                      <el-form-item  v-if="numType!=11"
                       label="采购单位"
                        prop="bcz.procureunit"
                        :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'blur'
                          }
                        ]"
                      >
                        <el-input
                          v-if="form.bcz != null"
                          v-model="form.bcz.procureunit"
                          placeholder="请输入"
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="14" v-if="numType != 10 ">
                      <el-form-item  v-if="numType!=11"
                        label="客户名称"
                        prop="bcz.procureunit"
                        :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'blur'
                          }
                        ]"
                      >
                        <el-input
                          v-if="form.bcz != null"
                          v-model="form.bcz.procureunit"
                          placeholder="请输入"
                          :disabled="bianji"
                        ></el-input>
                      </el-form-item>
                      <el-form-item  v-if="numType==11"
                        label="客户名称"
                        prop="bcz.procureunit"
                        :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'blur'
                          }
                        ]"
                      > <el-autocomplete
                          class="input_autocomplete"
                          @input="filterComma2(form.bcz)"
                          v-model="form.bcz.procureunit"
                          :fetch-suggestions="querySearchName2
                          "
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @select="handleSelectName2
                          "
                           :disabled="bianji"
                        ></el-autocomplete>
                        <!-- <el-input
                          v-if="form.bcz != null"
                          v-model="form.bcz.procureunit"
                          placeholder="请输入"
                          @input="filterComma2(form.bcz)"
                          :disabled="bianji"
                        ></el-input> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="10" v-if="numType != 10">
                
                <el-form-item
                  label="身份证号/社会信用代码/护照号" label-width="260px"
                  prop="bcz.idnumber"
                  :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'blur'
                          }
                        ]"
                > 
                  <el-input
                    v-model="form.bcz.idnumber" :disabled="bianji"
                    placeholder="请输入"
                    @input="filterComma2(form.bcz)"
                  ></el-input>
                </el-form-item>
              </el-col>
                  </el-row>

                   <el-row v-if="numType==11" v-for="(item ,index) in form.bcz.tableData" >
                      <el-col :span="bianji === false ? 12 : 14" >
                        <el-form-item 
                          label="客户名称"
                          :prop="`bcz.tableData[${index}].name`"
                          :rules="[
                            {
                              required: true,
                              message: '不能为空',
                              trigger: 'blur'
                            }
                          ]"
                        > <el-autocomplete
                            class="input_autocomplete"
                            @input="filterComma3(form.bcz.tableData[index])"
                            v-model="form.bcz.tableData[index].name"
                            :fetch-suggestions="querySearchName3
                            "
                            placeholder="请输入内容"
                            :trigger-on-focus="false"
                            @select="(selected) => handleSelectName3(selected, index)"
                            :disabled="bianji"
                          ></el-autocomplete>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10" >
                  
                  <el-form-item
                    label="身份证号/社会信用代码/护照号" label-width="260px"
                    :prop="`bcz.tableData[${index}].idnumber`"
                    :rules="[
                            {
                              required: true,
                              message: '不能为空',
                              trigger: 'blur'
                            }
                          ]"
                  > 
                    <el-input
                      v-model="form.bcz.tableData[index].idnumber" :disabled="bianji"
                      placeholder="请输入"
                      @input="filterComma3(form.bcz.tableData[index])"
                    ></el-input>
                  </el-form-item>
                      </el-col>
                      <el-col :span="2" style="text-align:right" v-if="bianji == false">
                          <el-button type="primary" @click="addParty3()" size="mini">
                                <div class="copy">+</div>
                              </el-button>
                              <el-button size="mini"
                                type="danger" 
                                @click="reduceParty3(index)"
                              >
                                <div class="del_btn">-</div>
                              </el-button>
                        </el-col>
                  </el-row>
                </div>

                <!-- 案件当事人 -->
                <div
                  v-if="
                    numType == 1 ||
                    numType == 2 ||
                    numType == 3 ||
                    numType == 4 ||
                    numType == 5 ||
                    numType == 6
                  "
                >
                  <div class="divider"></div>
                  <div class="top">
                    <div class="icon"></div>
                    <div>案件当事人</div>
                    <div class="addrow" v-if="bianji == false">
                      <el-select v-model="addTableData" clearable filterable>
                        <el-option
                          v-for="item in ArrtibuteOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-button
                        size="mini"
                        type="primary"
                        @click="addParty(null, null)"
                      >
                        添加当事人
                      </el-button>
                    </div>
                  </div>

                  <el-row>
                    <el-table
                      class="party"
                      :data="form.tableData"
                      style="width: calc(100% - 61px);"
                      :header-cell-style="{ textAlign: 'center' }"
                      :cell-style="{ textAlign: 'center' }"
                      :row-class-name="tableRowClassName"
                    >
                      <el-table-column
                        label="属性"
                        prop="attribute"
                        :render-header="addRedStar"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <el-form-item label-width="0">
                            <el-select
                              size="mini"
                              v-model="scope.row.attribute"
                              filterable
                              :disabled="bianji"
                              @change="dsrOrder(scope.row)"
                            >
                              <el-option
                                v-for="item in ArrtibuteOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="类型"
                        prop="isUnit"
                        :render-header="addRedStar"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <el-select
                            size="mini"
                            v-model="scope.row.isUnit"
                            clearable
                            :disabled="bianji"
                          >
                            <el-option
                              v-for="item in typeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="姓名/单位名称"
                        prop="name"
                        :render-header="addRedStar"
                        :show-overflow-tooltip="true"
                      >
                        <template slot-scope="scope">
                          <el-autocomplete v-if="scope.row.isUnit==false"  :disabled="bianji"
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.name"
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearchName(item1, item2, scope.row)
                            }
                          "
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @select="
                            (item) => {
                              handleSelectName(item, scope.row)
                            }
                          "
                        ></el-autocomplete>
                        <el-input  :disabled="bianji" v-else
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.name"
                          clearable
                          placeholder="请输入内容"
                        ></el-input>
                          <!-- <el-autocomplete
                            :disabled="bianji"
                            class="input_autocomplete"
                            @input="filterComma(scope.row)"
                            v-model="scope.row.name"
                            clearable
                            :fetch-suggestions="
                              (item1, item2) => {
                                querySearch(item1, item2, scope.row)
                              }
                            "
                            @select="
                              (item) => {
                                handleSelect(item, scope.row, null)
                              }
                            "
                          ></el-autocomplete> -->
                        </template>
                      </el-table-column>
                      <el-table-column
                    label="身份证号/社会信用代码/护照号"
                    prop="idnumber" :show-overflow-tooltip="true" :render-header="addRedStar"
                  >
                    <template slot-scope="scope">
                      <!-- <el-autocomplete
                          class="input_autocomplete"
                          v-model="scope.row.idnumber"
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearchId(item1, item2, scope.row)
                            }
                          "
                          placeholder="请输入内容"
                          @select="
                            (item) => {
                              handleSelectId(item, scope.row)
                            }
                          "
                        ></el-autocomplete> -->
                      <el-input  :disabled="bianji" 
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.idnumber"
                          clearable
                          placeholder="请输入内容"
                        ></el-input>
                    </template>
                  </el-table-column>
                  
                      <el-table-column v-if="!bianji" label="操作" width="200">
                        <template slot-scope="scope">
                          <el-button
                            type="primary"
                            @click="addParty(scope.row, null)"
                            ><div class="copy">+</div></el-button
                          >
                          <el-button
                            type="danger"
                            @click="reduceParty(scope.row.count, 0)"
                          >
                            <div class="del_btn">-</div></el-button
                          >
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="委托方"
                        prop="isClient"
                        :render-header="addRedStar"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <el-checkbox
                            v-model="scope.row.isClient"
                            @change="clientChange(scope.row)"
                            :disabled="bianji"
                          ></el-checkbox>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </div>

                <div v-if="numType == 9">
                  <div class="divider"></div>
                  <div class="top">
                    <div class="icon"></div>
                    <div>案件当事人</div>
                    <div class="addrow" v-if="bianji == false">
                      <el-select v-model="addTableData" clearable filterable>
                        <el-option
                          v-for="item in ArrtibuteOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-button
                        size="mini"
                        type="primary"
                        @click="addParty09(null, null)"
                      >
                        添加当事人
                      </el-button>
                    </div>
                  </div>

                  <el-row>
                    <el-table
                      class="party"
                      :data="form.tableData"
                      style="width: calc(100% - 61px);"
                      :header-cell-style="{ textAlign: 'center' }"
                      :cell-style="{ textAlign: 'center' }"
                      :row-class-name="tableRowClassName"
                    >
                      <el-table-column
                        label="属性"
                        prop="Attribute"
                        :render-header="addRedStar"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <el-form-item
                            :rules="rules.attribute"
                            label-width="0"
                          >
                            <el-select
                              size="mini"
                              v-model="scope.row.attribute"
                              filterable
                              @change="dsrOrder(scope.row)"
                              disabled
                            >
                              <el-option
                                v-for="item in ArrtibuteOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="姓名/单位名称"
                        prop="name"
                        :render-header="addRedStar"
                      >
                        <template slot-scope="scope">
                          <el-form-item :rules="rules.name" label-width="0">
                            <el-autocomplete :disabled="bianji" v-if="scope.row.isUnit==false"
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.name"
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearchName(item1, item2, scope.row)
                            }
                          "
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @select="
                            (item) => {
                              handleSelectName(item, scope.row)
                            }
                          "
                        ></el-autocomplete>
                        <el-input  :disabled="bianji" v-else
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.name"
                          clearable
                          placeholder="请输入内容"
                        ></el-input>
                            <!-- <el-autocomplete
                              :disabled="bianji"
                              class="input_autocomplete"
                              v-model="scope.row.name"
                              @input="filterComma(scope.row)"
                              clearable
                              :fetch-suggestions="
                                (item1, item2) => {
                                  querySearch(item1, item2, scope.row)
                                }
                              "
                              @select="
                                (item) => {
                                  handleSelect(item, scope.row, null)
                                }
                              "
                            ></el-autocomplete> -->
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="身份证号/社会信用代码/护照号"
                        prop="idnumber"
                        :render-header="addRedStar"
                      >
                        <template slot-scope="scope">
                          <el-form-item  label-width="0">
                            <!-- <el-autocomplete
                          class="input_autocomplete"
                          v-model="scope.row.idnumber"
                          :trigger-on-focus="false"
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearchId(item1, item2, scope.row)
                            }
                          "
                          placeholder="请输入内容"
                          @select="
                            (item) => {
                              handleSelectId(item, scope.row)
                            }
                          "
                        ></el-autocomplete> -->
                        <el-input  :disabled="bianji" 
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.idnumber"
                          clearable
                          placeholder="请输入内容"
                        ></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" v-if="!bianji" width="200">
                        <template slot-scope="scope">
                          <el-button
                            type="primary"
                            @click="addParty09(scope.row, null)"
                          >
                            <div class="copy">+</div></el-button
                          >
                          <el-button
                            type="danger"
                            @click="reduceParty(scope.row.count, 0)"
                          >
                            <div class="del_btn">-</div></el-button
                          >
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="委托方"
                        prop="IsClient"
                        :render-header="addRedStar"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <el-form-item label-width="0">
                            <el-checkbox
                              disabled
                              v-model="scope.row.isClient"
                              @change="clientChange(scope.row)"
                            ></el-checkbox>
                          </el-form-item>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </div>

                <!-- 附件信息 -->
                <div class="divider"></div>
                <div class="top">
                  <div class="icon"></div>
                  <div>附件信息</div>
                </div>

                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="普通附件"
                      prop="ordinaryFiles"
                      v-if="numType != 10"
                    >
                      <el-upload
                        class="upload_file"
                        :show-file-list="false"
                        v-model="form.ordinaryFiles"
                        action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=附件"
                        :before-upload="(file) => beforeUpload(file, 2)"
                        :on-change="(file) => onChange(file, 2)"
                        :on-progress="
                          (event, file) => onProgress(event, file, 2)
                        "
                        multiple
                        :file-list="FileList2"
                        :on-success="
                          (response, file, fileList) =>
                            uploadSuccess(response, file, fileList, 2)
                        "
                        :on-remove="(file) => handleRemove(file, 2)"
                      >
                        <el-button
                          v-if="form.status != 3"
                          size="small"
                          class="fj_text"
                          >请选择附件</el-button
                        >
                        <span slot="tip" class="el-upload__tip"
                          >单个上传50mb</span
                        >
                      </el-upload>
                      <!-- 附件回显 -->
                      <div
                        v-for="(item, index) in FileList2"
                        :key="item.uid"
                        class="file_show"
                        style="margin-top: 10px"
                      >
                        <div class="fj" v-if="!item.isShow">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="
                                item.ftype == 'doc' ||
                                item.ftype == 'docx' ||
                                item.ftype == 'DOC' ||
                                item.ftype == 'DOCX'
                              "
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="
                                item.ftype == 'xlsx' ||
                                item.ftype == 'xls' ||
                                item.ftype == 'XLSX' ||
                                item.ftype == 'XLS'
                              "
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png' ||
                                item.ftype == 'JPG' ||
                                item.ftype == 'JPEG' ||
                                item.ftype == 'PNG'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                            />
                          </div>
                          <div class="name" style="flex: 9">
                            <div>
                              {{ item.name }}
                            </div>
                            <div class="word">
                              <span @click="look(item)" class="look">预览</span>
                              <span class="down" @click="down(item)">下载</span>
                              <span
                                @click="del(index, 2, item)"
                                class="del"
                                v-if="
                                  NewFile.includes(item.uid) ||
                                  (form.status == 0 &&
                                    (form.result == 1 || bianji == false))
                                "
                                >删除</span
                              >
                            </div>
                          </div>
                        </div>
                        <!--文件上传进度条-->
                        <div class="uploadprocess" v-else>
                          <div>
                            <div class="jdtext">
                              <div class="uploadname">{{ item.name }}</div>
                              <div class="per">{{ item.curPercentage }}%</div>
                            </div>
                            <el-progress
                              :percentage="item.curPercentage"
                              :show-text="false"
                            ></el-progress>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>

                  <el-col :span="8" style="display: flex">
                    <el-form-item
                      :label="numType == 10 ? '招标文件' : '合同上传'"
                      prop="biddingSchemes"
                    >
                      <el-upload
                        class="upload_file"
                        :show-file-list="false"
                        v-model="form.biddingSchemes"
                        action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=合同"
                        :before-upload="(file) => beforeUpload(file, 1)"
                        :on-change="(file) => onChange(file, 1)"
                        :on-progress="
                          (event, file) => onProgress(event, file, 1)
                        "
                        multiple
                        :file-list="FileList1"
                        :on-success="
                          (response, file, fileList) =>
                            uploadSuccess(response, file, fileList, 1)
                        "
                        :on-remove="(file) => handleRemove(file, 1)"
                      >
                        <el-button
                          v-if="form.status != 3"
                          size="small"
                          class="fj_text"
                          >请选择附件</el-button
                        >
                        <span slot="tip" class="el-upload__tip"
                          >单个上传50mb</span
                        >
                      </el-upload>
                      <!-- 附件回显 -->
                      <div
                        v-for="(item, index) in FileList1"
                        :key="item.uid"
                        class="file_show"
                        style="margin-top: 10px"
                      >
                        <div class="fj" v-if="!item.isShow">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="
                                item.ftype == 'doc' ||
                                item.ftype == 'docx' ||
                                item.ftype == 'DOC' ||
                                item.ftype == 'DOCX'
                              "
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="
                                item.ftype == 'xlsx' ||
                                item.ftype == 'xls' ||
                                item.ftype == 'XLSX' ||
                                item.ftype == 'XLS'
                              "
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png' ||
                                item.ftype == 'JPG' ||
                                item.ftype == 'JPEG' ||
                                item.ftype == 'PNG'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                            />
                          </div>
                          <div class="name" style="flex: 9">
                            <div>
                              {{ item.name }}
                            </div>
                            <div class="word">
                              <span @click="look(item)" class="look">预览</span>
                              <span class="down" @click="down(item)">下载</span>
                              <span
                                @click="del(index, 1, item)"
                                class="del"
                                v-if="
                                  NewFile.includes(item.uid) ||
                                  (form.status == 0 &&
                                    (form.result == 1 || bianji == false))
                                "
                                >删除</span
                              >
                            </div>
                          </div>
                        </div>
                        <!--文件上传进度条-->
                        <div class="uploadprocess" v-else>
                          <div>
                            <div class="jdtext">
                              <div class="uploadname">{{ item.name }}</div>
                              <div class="per">{{ item.curPercentage }}%</div>
                            </div>
                            <el-progress
                              :percentage="item.curPercentage"
                              :show-text="false"
                            ></el-progress>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" style="display: flex">
                    <el-form-item
                      label="普通附件"
                      prop="ordinaryFiles"
                      v-if="numType == 10"
                    >
                      <el-upload
                        class="upload_file"
                        :show-file-list="false"
                        v-model="form.ordinaryFiles"
                        action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=附件"
                        :before-upload="(file) => beforeUpload(file, 2)"
                        :on-change="(file) => onChange(file, 2)"
                        :on-progress="
                          (event, file) => onProgress(event, file, 2)
                        "
                        multiple
                        :file-list="FileList2"
                        :on-success="
                          (response, file, fileList) =>
                            uploadSuccess(response, file, fileList, 2)
                        "
                        :on-remove="(file) => handleRemove(file, 2)"
                      >
                        <el-button
                          v-if="form.status != 3"
                          size="small"
                          class="fj_text"
                          >请选择附件</el-button
                        >
                        <span slot="tip" class="el-upload__tip"
                          >单个上传50mb</span
                        >
                      </el-upload>
                      <!-- 附件回显 -->
                      <div
                        v-for="(item, index) in FileList2"
                        :key="item.uid"
                        class="file_show"
                        style="margin-top: 10px"
                      >
                        <div class="fj" v-if="!item.isShow">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="
                                item.ftype == 'doc' ||
                                item.ftype == 'docx' ||
                                item.ftype == 'DOC' ||
                                item.ftype == 'DOCX'
                              "
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="
                                item.ftype == 'xlsx' ||
                                item.ftype == 'xls' ||
                                item.ftype == 'XLSX' ||
                                item.ftype == 'XLS'
                              "
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png' ||
                                item.ftype == 'JPG' ||
                                item.ftype == 'JPEG' ||
                                item.ftype == 'PNG'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                            />
                          </div>
                          <div class="name" style="flex: 9">
                            <div>
                              {{ item.name }}
                            </div>
                            <div class="word">
                              <span @click="look(item)" class="look">预览</span>
                              <span class="down" @click="down(item)">下载</span>
                              <span
                                @click="del(index, 2, item)"
                                class="del"
                                v-if="
                                  NewFile.includes(item.uid) ||
                                  (form.status == 0 &&
                                    (form.result == 1 || bianji == false))
                                "
                                >删除</span
                              >
                            </div>
                          </div>
                        </div>
                        <!--文件上传进度条-->
                        <div class="uploadprocess" v-else>
                          <div>
                            <div class="jdtext">
                              <div class="uploadname">{{ item.name }}</div>
                              <div class="per">{{ item.curPercentage }}%</div>
                            </div>
                            <el-progress
                              :percentage="item.curPercentage"
                              :show-text="false"
                            ></el-progress>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                
                </el-row>
               <el-row>
                <el-col :span="8">
                    <el-form-item
                      label="拟出具文件"
                      prop="chujuFiles"
                      v-if="numType == 7||numType == 8||numType == 9"
                    >
                      <el-upload
                        class="upload_file"
                        :show-file-list="false"
                        v-model="form.chujuFiles"
                        action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=拟出具文件"
                        :before-upload="(file) => beforeUpload(file, 7)"
                        :on-change="(file) => onChange(file, 7)"
                        :on-progress="
                          (event, file) => onProgress(event, file, 7)
                        "
                        multiple
                        :file-list="FileList7"
                        :on-success="
                          (response, file, fileList) =>
                            uploadSuccess(response, file, fileList, 7)
                        "
                        :on-remove="(file) => handleRemove(file, 7)"
                      >
                        <el-button
                          v-if="form.status != 3"
                          size="small"
                          class="fj_text"
                          >请选择附件</el-button
                        >
                        <span slot="tip" class="el-upload__tip"
                          >单个上传50mb</span
                        >
                      </el-upload>
                      <!-- 附件回显 -->
                      <div
                        v-for="(item, index) in FileList7"
                        :key="item.uid"
                        class="file_show"
                        style="margin-top: 10px"
                      >
                        <div class="fj" v-if="!item.isShow">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="
                                item.ftype == 'doc' ||
                                item.ftype == 'docx' ||
                                item.ftype == 'DOC' ||
                                item.ftype == 'DOCX'
                              "
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="
                                item.ftype == 'xlsx' ||
                                item.ftype == 'xls' ||
                                item.ftype == 'XLSX' ||
                                item.ftype == 'XLS'
                              "
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png' ||
                                item.ftype == 'JPG' ||
                                item.ftype == 'JPEG' ||
                                item.ftype == 'PNG'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                            />
                          </div>
                          <div class="name" style="flex: 9">
                            <div>
                              {{ item.name }}
                            </div>
                            <div class="word">
                              <span @click="look(item)" class="look">预览</span>
                              <span class="down" @click="down(item)">下载</span>
                              <span
                                @click="del(index, 7, item)"
                                class="del"
                                v-if="
                                  NewFile.includes(item.uid) ||
                                  (form.status == 0 &&
                                    (form.result == 1 || bianji == false))
                                "
                                >删除</span
                              >
                            </div>
                          </div>
                        </div>
                        <!--文件上传进度条-->
                        <div class="uploadprocess" v-else>
                          <div>
                            <div class="jdtext">
                              <div class="uploadname">{{ item.name }}</div>
                              <div class="per">{{ item.curPercentage }}%</div>
                            </div>
                            <el-progress
                              :percentage="item.curPercentage"
                              :show-text="false"
                            ></el-progress>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
               </el-row>


                <el-row>
                  <el-col :span="8" style="display: flex">
                    <el-form-item
                      label="免费凭证"
                      prop="freeFiles"
                      v-if="sfxz.mfpz == true"
                    >
                      <el-upload
                        class="upload_file"
                        :show-file-list="false"
                        v-model="form.freeFiles"
                        action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=免费"
                        :before-upload="(file) => beforeUpload(file, 5)"
                        :on-change="(file) => onChange(file, 5)"
                        :on-progress="
                          (event, file) => onProgress(event, file, 5)
                        "
                        multiple
                        :file-list="FileList5"
                        :on-success="
                          (response, file, fileList) =>
                            uploadSuccess(response, file, fileList, 5)
                        "
                        :on-remove="(file) => handleRemove(file, 5)"
                      >
                        <el-button size="small" class="fj_text"
                          >请选择附件</el-button
                        >
                        <span slot="tip" class="el-upload__tip"
                          >单个上传50mb</span
                        >
                      </el-upload>
                      <!-- 附件回显 -->
                      <div
                        v-for="(item, index) in FileList5"
                        :key="item.uid"
                        class="file_show"
                        style="margin-top: 10px"
                      >
                        <div class="fj" v-if="!item.isShow">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="
                                item.ftype == 'doc' ||
                                item.ftype == 'docx' ||
                                item.ftype == 'DOC' ||
                                item.ftype == 'DOCX'
                              "
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="
                                item.ftype == 'xlsx' ||
                                item.ftype == 'xls' ||
                                item.ftype == 'XLSX' ||
                                item.ftype == 'XLS'
                              "
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png' ||
                                item.ftype == 'JPG' ||
                                item.ftype == 'JPEG' ||
                                item.ftype == 'PNG'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                            />
                          </div>
                          <div class="name" style="flex: 9">
                            <div>
                              {{ item.name }}
                            </div>
                            <div class="word">
                              <span @click="look(item)" class="look">预览</span>
                              <span class="down" @click="down(item)">下载</span>
                              <span
                                v-if="
                                  NewFile.includes(item.uid) ||
                                  (form.status == 0 &&
                                    (form.result == 1 || bianji == false))
                                "
                                @click="del(index, 5)"
                                class="del"
                                >删除</span
                              >
                            </div>
                          </div>
                        </div>
                        <!--文件上传进度条-->
                        <div class="uploadprocess" v-else>
                          <div>
                            <div class="jdtext">
                              <div class="uploadname">{{ item.name }}</div>
                              <div class="per">{{ item.curPercentage }}%</div>
                            </div>
                            <el-progress
                              :percentage="item.curPercentage"
                              :show-text="false"
                            ></el-progress>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="form.status == 2 || form.status == 3" :span="8">
                    <el-form-item label="发票管理" prop="invoiceFile">
                      <el-upload
                        class="upload_file"
                        :show-file-list="false"
                        v-model="form.invoiceFile"
                        action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=发票"
                        :before-upload="(file) => beforeUploadfp(file, 3)"
                        :on-change="(file) => onChange(file, 3)"
                        :on-progress="
                          (event, file) => onProgress(event, file, 3)
                        "
                        multiple
                        :file-list="FileList3"
                        :on-success="
                          (response, file, fileList) =>
                            uploadSuccess(response, file, fileList, 3)
                        "
                        :on-remove="(file) => handleRemove(file, 3)"
                      >
                        <el-button
                          v-if="form.status != 3"
                          size="small"
                          class="fjchoose"
                          >请选择附件</el-button
                        >
                        <span slot="tip" class="el-upload__tip">结案必填</span>
                      </el-upload>
                      <!-- 附件回显 -->
                      <div
                        v-for="(item, index) in FileList3"
                        :key="item.uid"
                        class="file_show"
                        style="margin-top: 10px"
                      >
                        <div class="fj" v-if="!item.isShow">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="
                                item.ftype == 'doc' ||
                                item.ftype == 'docx' ||
                                item.ftype == 'DOC' ||
                                item.ftype == 'DOCX'
                              "
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="
                                item.ftype == 'xlsx' ||
                                item.ftype == 'xls' ||
                                item.ftype == 'XLSX' ||
                                item.ftype == 'XLS'
                              "
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png' ||
                                item.ftype == 'JPG' ||
                                item.ftype == 'JPEG' ||
                                item.ftype == 'PNG'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                            />
                          </div>
                          <div class="name" style="flex: 9">
                            <div>
                              {{ item.name }}
                            </div>
                            <div class="word">
                              <span @click="look(item)" class="look">预览</span>
                              <span class="down" @click="down(item)">下载</span>
                              <span
                                @click="del(index, 3, item)"
                                class="del"
                                v-if="
                                  NewFile.includes(item.uid) ||
                                  (form.status == 0 &&
                                    (form.result == 1 || bianji == false))
                                "
                                >删除</span
                              >
                            </div>
                          </div>
                        </div>
                        <!--文件上传进度条-->
                        <div class="uploadprocess" v-else>
                          <div>
                            <div class="jdtext">
                              <div class="uploadname">{{ item.name }}</div>
                              <div class="per">{{ item.curPercentage }}%</div>
                            </div>
                            <el-progress
                              :percentage="item.curPercentage"
                              :show-text="false"
                            ></el-progress>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- 收费信息 -->
                <div class="divider"></div>
                <div class="top">
                  <div class="icon"></div>
                  <div>收费信息</div>
                </div>
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="收费方式" prop="chargingMethod">
                      <el-select
                        style="width: 100%"
                        v-model="form.chargingMethod"
                        placeholder="请选择"
                        class="select"
                        @change="SF_chargingMethodstatus(form.chargingMethod)"
                        :disabled="bianji"
                      >
                        <el-option
                          v-for="item in Chargestatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" v-if="numType != 10">
                    <el-form-item label="案件标的" prop="subjectMatter ">
                      <el-input
                        v-model="form.subjectMatter"
                        placeholder="请输入"
                        :disabled="bianji"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6" class="date_box" style="display: flex">
                    <el-form-item
                      :label="numType == 10 ? '投标价格' : '标的金额'"
                      prop="amountOfSubject"
                    >
                      <el-input
                        v-model="form.amountOfSubject"
                        placeholder="请输入"
                        clearable
                        :disabled="bianji"
                      ></el-input>
                    </el-form-item>
                    <span style="margin: 1% 0 0 0.5%">元</span>
                  </el-col>
                  <el-col
                    :span="6"
                    class="date_box"
                    style="display: flex"
                    v-if="sfxz.fixed"
                  >
                    <el-form-item label="收费金额" prop="fixed">
                      <el-input
                        v-model="form.fixed"
                        placeholder="请输入"
                        clearable
                        :disabled="bianji"
                      ></el-input>
                    </el-form-item>
                    <span style="margin: 1% 0 0 0.5%">元</span>
                  </el-col>
                  <!-- <el-col :span="12" v-if="sfxz.fixed_times"> </el-col> -->
                </el-row>
                <el-row>
                  <el-col
                    :span="12"
                    class="date_box"
                    style="display: flex"
                    v-if="sfxz.riskFixed"
                  >
                    <el-form-item label="半风险定额收费金额" prop="riskFixed">
                      <el-input
                        v-model="form.riskFixed"
                        placeholder="请输入"
                        clearable
                        :disabled="bianji"
                      ></el-input> </el-form-item
                    ><span style="margin: 1% 0 0 0.5%">元</span>
                  </el-col>
                  <el-col
                    :span="12"
                    style="display: flex"
                    v-if="sfxz.riskRatio"
                  >
                    <el-form-item label="风险收费比例" prop="riskRatio ">
                      <el-input
                        v-model="form.riskRatio"
                        placeholder="请输入"
                        clearable
                        :disabled="bianji"
                      ></el-input> </el-form-item
                    ><span style="margin: 1% 0 0 0.5%">%</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12" class="date_box">
                    <el-form-item label="简介" prop="introduction">
                      <el-input
                        v-model="form.introduction"
                        placeholder="请输入"
                        clearable
                        :disabled="bianji"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="备注" prop="bcb_Remark ">
                      <el-input
                        v-model="form.bcb_Remark"
                        placeholder="请输入"
                        clearable
                        :disabled="bianji"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- 收费明细 -->

                <div v-if="false">
                  <div v-if="sfxz.detail">
                    <div class="divider"></div>
                    <div class="top">
                      <div class="icon"></div>
                      <div>收费明细</div>
                    </div>
                    <el-row class="addrow">
                      <i
                        class="el-icon-plus"
                        v-if="!this.bianji"
                        @click="addCharge"
                        >添加明细</i
                      >
                    </el-row>
                    <el-row>
                      <el-table
                        class="party"
                        border
                        :data="form.bcbdTable"
                        style="width: 100%"
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                      >
                        <el-table-column
                          label="款项名称"
                          prop="name"
                          :render-header="addRedStar"
                        >
                          <template slot-scope="scope">
                            <el-form-item
                              :prop="'bcbdTable.' + scope.$index + '.name'"
                              :rules="{
                                required: true,
                                message: '不能为空',
                                trigger: 'blur'
                              }"
                              label-width="0"
                            >
                              <el-input
                                v-model="scope.row.name"
                                placeholder="请输入"
                                clearable
                                :disabled="bianji"
                              ></el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="应收金额"
                          prop="amount"
                          :render-header="addRedStar"
                        >
                          <template slot-scope="scope">
                            <el-form-item
                              :prop="'bcbdTable.' + scope.$index + '.amount'"
                              :rules="{
                                required: true,
                                message: '不能为空',
                                trigger: 'blur'
                              }"
                              label-width="0"
                            >
                              <el-input
                                v-model="scope.row.amount"
                                placeholder="请输入"
                                clearable
                                :disabled="bianji"
                              ></el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="约定收款日期"
                          prop="paymentDate"
                        >
                          <template slot-scope="scope">
                            <el-form-item
                              :prop="
                                'bcbdTable.' + scope.$index + '.paymentDate'
                              "
                              label-width="0"
                            >
                              <el-date-picker
                                style="width: 100%"
                                v-model="scope.row.paymentDate"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="请选择日期"
                                :clearable="false"
                                :disabled="bianji"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </template>
                        </el-table-column>

                        <el-table-column label="备注" prop="remark">
                          <template slot-scope="scope">
                            <el-form-item
                              :prop="'bcbdTable.' + scope.$index + '.remark'"
                              label-width="0"
                            >
                              <el-input
                                v-model="scope.row.remark"
                                placeholder="请输入"
                                :disabled="bianji"
                              ></el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="状态"
                          prop="status"
                          :render-header="addRedStar"
                        >
                          <template slot-scope="scope">
                            <el-form-item
                              :prop="'bcbdTable.' + scope.$index + '.status'"
                              label-width="0"
                              :rules="{
                                required: true,
                                message: '不能为空 ',
                                trigger: 'blur'
                              }"
                            >
                              <el-select
                                style="width: 100%"
                                v-model="scope.row.status"
                                placeholder="请选择"
                                :disabled="bianji"
                              >
                                <el-option
                                  v-for="item in Bcbd_status"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column v-if="!this.bianji" label="操作">
                          <template slot-scope="scope">
                            <el-button
                              class="copy"
                              @click="copyCharge(scope.row)"
                              >复制</el-button
                            >
                            <el-button
                              class="del_btn"
                              v-if="form.bcbdTable.length > 0"
                              @click="reduceCharge(scope.row.count)"
                              >删除</el-button
                            >
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-row>
                  </div>
                </div>
                <!-- 用章申请 -->
                <div class="divider"></div>
                <div class="top">
                  <div class="icon"></div>
                  <div>用章申请</div>
                </div>
                <el-row>
                  <!-- <el-col
                    :span="24"
                    v-if="form.bs_Result == 1 || form.bs_Result == null"
                  > -->
                  <el-col :span="24">
                    <el-form
                      class="form"
                      ref="sealForm"
                      :model="sealForm"
                      :rules="sealRules"
                      label-width="200px"
                    >
                      <el-col :span="12">
                        <el-form-item label="申请人" prop="applicant">
                          <el-select
                            v-model="sealForm.applicant"
                            placeholder="请选择"
                            class="input"
                            filterable
                            @change="SealLawyer()"
                            :disabled="sealbianji"
                          >
                            <el-option
                              v-for="item in Lawyer"
                              :key="item.id"
                              :label="item.nikename"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="用章事由" prop="reason">
                          <el-input
                            placeholder="请输入"
                            v-model="sealForm.reason"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-form-item
                        v-if="false"
                        label="二次审批人"
                        prop="leadLawyer2"
                      >
                        <el-select
                          v-model="sealForm.leadLawyer2"
                          style="width: 100%"
                          placeholder="请选择"
                          class="select"
                          clearable
                          filterable
                          :disabled="sealbianji"
                          @change="bmzgChange"
                        >
                          <el-option
                            v-for="item in SealLevel"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        v-if="false"
                        label="部门主管"
                        prop="sealLeaders"
                      >
                        <el-select
                          style="width: 100%"
                          v-model="sealForm.sealLeaders"
                          placeholder="请选择"
                          class="select"
                          clearable
                          filterable
                          :disabled="sealbianji"
                        >
                          <el-option
                            v-for="item in SealLeaders"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item v-if="false" label="附件" prop="sealFile">
                        <el-select
                          v-model="sealForm.sealFile"
                          placeholder="请选择"
                          class="input"
                          style="width: 100%"
                          multiple
                          filterable
                          :disabled="sealbianji"
                        >
                          <el-option
                            v-for="item in FileList"
                            :key="item.uid"
                            :label="item.name"
                            :value="item.uid"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </el-col>
                  <el-col :span="14" v-show="false">
                    <div style="margin-left: 10%">
                      <div>支持导出的材料：</div>
                      <div style="display: flex">
                        <div>
                          <el-checkbox-group
                            v-model="checkedCities"
                            @change="handleCheckedCitiesChange"
                          >
                            <el-checkbox
                              style="display: block; padding-top: 20px"
                              v-for="city in cities"
                              :label="city.name"
                              :key="city.name"
                              :disabled="sealbianji"
                              >{{ city.name }}</el-checkbox
                            >
                          </el-checkbox-group>
                        </div>
                        <div>
                          <div
                            style="margin-left: 15%; padding-top: 12px"
                            v-for="city in cities"
                          >
                            <el-select
                              size="mini"
                              v-model="city.stype"
                              placeholder="请选择用章类型"
                              class="yz_input"
                              @change="GetSealLevel()"
                              clearable
                              filterable
                              multiple
                              :disabled="sealbianji"
                            >
                              <el-option
                                v-for="item in Seal"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <div class="divider"></div>
                <div class="top">
                  <div class="icon"></div>
                  <div>关联案件</div>
                </div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="关联案件" prop="linkId">
                      <el-select
                        popperClass="custom-popper"
                        style="width: 100%"
                        v-model="form.linkId"
                        placeholder="请选择"
                        class="select"
                        clearable
                        filterable
                        multiple
                        :disabled="bianji"
                        :remote-method="GetCaseLink"
                        remote
                        :loading="caseLinkloading"
                      >
                        <el-option
                          v-for="item in Caselevel"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="right">
              <el-timeline :reverse="false">
                <el-timeline-item
                  v-for="(item, index) in logs"
                  :key="index"
                  color="#3077E6"
                  :timestamp="item.reason"
                >
                  <div style="display: flex; justify-content: space-between">
                    <div>{{ item.content }}</div>

                    <!-- <div class="time">
                      {{ formatTime(item.timestamp, 1) }}
                    </div> -->
                    <div class="time">
                      {{ handle(item.timestamp) }}
                    </div>
                  </div>
                  <div style="color: #909399">{{ item.type }}</div>
                </el-timeline-item>
              </el-timeline>
            </div>
            <div class="right" v-if="processlogs.length > 0">
              <div style="margin-bottom: 10px; font-weight: 600">
                已审核流程
              </div>
              <el-timeline :reverse="false">
                <el-timeline-item
                  v-for="(item, index) in processlogs"
                  :key="index"
                  color="#3077E6"
                  :timestamp="item.reason"
                >
                  <div style="display: flex; justify-content: space-between">
                    <div>{{ item.type }}</div>

                    <div class="time">
                      {{ item.timestamp }}
                    </div>
                  </div>
                  <div style="color: #909399">
                    {{ item.name }} {{ item.con }}
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
            <div class="right" v-if="Process.length > 0">
              <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
              <el-timeline :reverse="false">
                <el-timeline-item
                  v-for="(item, index) in Process"
                  :key="index"
                  :timestamp="item.type"
                >
                  {{ item.name }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="footer">
        <!-- <el-button
          type="success"
          plain
          v-if="
            form.status == 0 &&
            form.result == 0 &&
            form.bs_Result == 0 &&
            form.bs_Status == 0 &&
            Detail_litigant &&
            form.uid &&
            (numType == 1 ||
              numType == 2 ||
              numType == 3 ||
              numType == 4 ||
              numType == 5 ||
              numType == 6 ||
              numType == 9) &&
            bianji != false
          "
          @click="changeLitigantclick"
          >更换当事人</el-button
        > -->
        <el-button
          v-if="
            (form.result == 0 || form.result == -1) &&
            Detail_update &&
            form.uid &&
            form.status != 3 &&
            form.status != -1
          "
          class="fileUpdate"
          @click="fileUpdate()"
          >附件更新</el-button
        >
        <el-button
          @click="closecase()"
          type="warning"
          plain
          v-if="
            form.status == 0 &&
            form.result == 0 &&
            timeGuidang&&
            Detail_ja &&
            form.uid
          "
        >
          结案
        </el-button>

        <el-button
          v-if="
            form.status >= 2 &&
            timeGuidang&&
            Detail_ja &&
            form.uid
          "
          @click="etext()"
          type="warning"
          plain
        >
          电子归档
        </el-button>

        <el-button
          @click="guidang()"
          type="primary"
          plain
          v-if="
            form.status == 2 &&
            Detail_gd &&
            form.uid &&
            numType != 7 &&
            numType != 8 &&
            numType != 14 &&
            numType != 9 &&
            numType != 10 &&
            numType != 11 &&
            numType != 15
          "
        >
          归档
        </el-button>
        <el-button
          v-if="
            form.status != -1 &&
            (form.result == 1 || bianji == false) &&
            Detail_enter &&
            form.uid
          "
          class="submit"
          @click="editCase('formref')"
          :disabled="dianji"
          >案件提交</el-button
        >
        <!-- <el-button
          v-if="form.bs_Result == 1 && form.uid"
          class="submit"
          @click="addEnter()"
          >重新申请用章</el-button
        > -->
        <!-- <el-button
          type="primary"
          plain
          @click="updateLawyer()"
          v-if="
            form.status == 0 &&
            form.result == 0 &&
            Detail_ja &&
            form.uid &&
            Detail_lawyer
          "
          >更换律师</el-button
        > -->

        <el-button class="history" @click="history()">返回</el-button>
      </div>
      <br />
      <br />
      <br />

      <div class="top">
        <div class="icon"></div>
        <div>
          顾问冲突<span style="color: black; font-size: 14px; margin-left: 10px"
            >(<span style="color: blue">蓝色</span>为代理方,
            <span style="color: red; font-weight: 900">!</span
            >橙色代表冲突方，灰色背景是导入数据)</span
          >
        </div>
      </div>
      <div class="conflictTable">
        <el-table
          :data="lvShiConflictTable"
          style="width: 100%"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          :row-class-name="tableRowClass"
        >
          <el-table-column prop="unitName" label="顾问单位">
            <template slot-scope="scope">
              <span
                style="color: red; font-weight: 900"
                v-if="scope.row.isClient == 1"
                >!</span
              >
              <span
                :style="{
                  color: getRandomColor1(scope.row.isClient)
                }"
              >
                {{ scope.row.unitName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="idnumber" label="身份证号/社会信用代码/护照号"> </el-table-column>
          <el-table-column prop="lawyer" label="承办律师"> </el-table-column>

          <el-table-column prop="unitType" label="单位性质"> </el-table-column>
          <el-table-column prop="endTime" label="到期时间">
            <template slot-scope="scope">
              {{ formatTime(scope.row.endTime) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <br />
      <br />
      <br />
      <br />
      <div class="top">
        <div class="icon"></div>
        <div>
          案件冲突<span style="color: black; font-size: 14px; margin-left: 10px"
            >(<span style="color: blue">蓝色</span>为代理方,
            <span style="color: red; font-weight: 900">!</span
            >橙色代表冲突方,灰色背景是导入数据)</span
          >
        </div>
      </div>
      <div class="conflictTable">
        <el-table
          :data="conflictTable"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
         
          class="ct_table"
          :row-class-name="tableRowClass"
        >
          <el-table-column prop="code" label="案件编号" width="150">
          </el-table-column>
          <el-table-column prop="title" label="案件名称" width="300">
          </el-table-column>
          <el-table-column prop="litigant" label="当事人">
            <template slot-scope="scope">
              <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
              <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
                {{ scope.row.litigant[0].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[0].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[0].all.length - 1"
                    >,
                  </span>
                </span>
              </div>

              <div v-if="scope.row.litigant[1]" class="litigant-container">
                {{ scope.row.litigant[1].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[1].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[1].all.length - 1"
                    >,
                  </span>
                </span>
              </div>
              <div v-if="scope.row.litigant[2]" class="litigant-container">
                {{ scope.row.litigant[2].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[2].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[2].all.length - 1"
                    >,
                  </span>
                </span>
              </div>
              <div v-if="scope.row.litigant[3]" class="litigant-container">
                {{ scope.row.litigant[3].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[3].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[3].all.length - 1"
                    >,
                  </span>
                </span>
              </div>
              <div v-if="scope.row.litigant[4]" class="litigant-container">
                {{ scope.row.litigant[4].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[4].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[4].all.length - 1"
                    >,
                  </span>
                </span>
              </div>
              <div v-if="scope.row.litigant[5]" class="litigant-container">
                {{ scope.row.litigant[5].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[5].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[5].all.length - 1"
                    >,
                  </span>
                </span>
              </div> -->
            </template>
          </el-table-column>
          <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
          <el-table-column prop="entrustmentTime" label="委托时间" width="150">
            <template slot-scope="scope">
              {{ formatTime(scope.row.entrustmentTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button class="chakanCase" @click="conflictClick(scope.row)" v-if="!scope.row.isOther"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div v-if="hasMore" style="text-align: center;">
          <el-button  type="text" @click="showAllCaseClick" >
            {{ showAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>
       
      </div>
       <br />
      <br />
      <br />
      <br />
       <div class="top">
        <div class="icon"></div>
        <div>
          破产管理人冲突<span style="color: black; font-size: 14px; margin-left: 10px"
            >(<span style="color: blue">蓝色</span>为代理方,
            <span style="color: red; font-weight: 900">!</span
            >橙色代表冲突方，灰色背景是导入数据)</span
          >
        </div>
      </div>
      <div class="conflictTable">
        <el-table
          :data="BanruptcykConflictTable"
          style="width: 100%"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          :row-class-name="tableRowClass"
        >
           <el-table-column prop="name" label="破产企业名称">
          <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900"
              v-if="scope.row.isClient == 1"
              >!</span
            >
            <span
              :style="{
                color: getRandomColor1(scope.row.isClient)
              }"
            >
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumber" label="身份证号/社会信用代码/护照号"> </el-table-column>
        <el-table-column prop="soure" label="破产项目来源"> </el-table-column>
         <el-table-column prop="mainName" label="代理律师(主)"> </el-table-column>
          <el-table-column prop="deputyName" label="代理律师(副)">
             <template slot-scope="scope">
    {{ scope.row.deputyName ? scope.row.deputyName.join('、') : '' }}
  </template>
   </el-table-column>
        
        <el-table-column prop="collectionDate" label="收案日期">
          <template slot-scope="scope">
            {{ formatTime(scope.row.collectionDate) }}
          </template>
        </el-table-column>
      </el-table>
      </div>
    </div>

    <!-- 案件冲突 -->
    <el-dialog
      title="案件冲突"
      :visible.sync="caseConflict"
      width="80%"
      style="text-align: center"
      @close="edit"
    >
    <el-form  ref="formConflict" :model="formConflict" label-width="150px" :rules="rulesConflict">
        <el-row v-if="conflictShow" >
        <el-col :span="8">
          <el-form-item label="二次利冲审批人" prop="conflictApproval" >
              <el-select
                v-model="formConflict.conflictApproval"
                clearable
                placeholder="请选择二次利冲审批人"
                filterable
                style=" width: 100%;"
              >
                <el-option
                  v-for="item in OptiomConflict"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="OptiomConflict.length<1&&allConflictCount>0" style="color:red;font-size:18px; margin-bottom:12px;">暂无二次利冲审批人，无法录入</div>
      <div>
        顾问冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>
      <el-table
        :data="lvShiConflict"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
      >
        <el-table-column prop="unitName" label="顾问单位">
          <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900"
              v-if="scope.row.isClient == 1"
              >!</span
            >
            <span
              :style="{
                color: getRandomColor1(scope.row.isClient)
              }"
            >
              {{ scope.row.unitName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumber" label="身份证号/社会信用代码/护照号"> </el-table-column>
        
        <el-table-column prop="lawyer" label="承办律师"> </el-table-column>

        <el-table-column prop="unitType" label="单位性质"> </el-table-column>
        <el-table-column prop="endTime" label="到期时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.endTime) }}
          </template>
        </el-table-column>
      </el-table>

      <div>
        案件冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>
      <el-table
        :data="conflictList"
        style="width: 100%; height: 200"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
        max-height="380px"
      >
        <el-table-column prop="code" label="案件编号" width="100">
        </el-table-column>
        <el-table-column prop="title" label="案件名称" width="240">
        </el-table-column>
        <el-table-column prop="litigant" label="当事人" min-width="300">
          <template slot-scope="scope">
            <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
            <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
              {{ scope.row.litigant[0].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[0].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[0].all.length - 1"
                  >,
                </span>
              </span>
            </div>

            <div v-if="scope.row.litigant[1]" class="litigant-container">
              {{ scope.row.litigant[1].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[1].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[1].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[2]" class="litigant-container">
              {{ scope.row.litigant[2].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[2].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[2].all.length - 1"
                  >,
                </span>
              </span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
        <el-table-column prop="entrustmentTime" label="委托时间" width="150">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button  @click="conflictClick(scope.row)" v-if="!scope.row.isOther"
              >查看</el-button 
            >
          </template>
        </el-table-column>
        
      </el-table>

      <div v-if="dialoghasMore" style="text-align: center;">
          <el-button  type="text" @click="dialogshowAllCaseClick" >
            {{ dialogshowAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>

 <div>
        破产管理人冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>
      <el-table
        :data="BanruptcykConflict"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
      >
        <el-table-column prop="name" label="破产企业名称">
          <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900"
              v-if="scope.row.isClient == 1"
              >!</span
            >
            <span
              :style="{
                color: getRandomColor1(scope.row.isClient)
              }"
            >
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumber" label="身份证号/社会信用代码/护照号"> </el-table-column>
        <el-table-column prop="soure" label="破产项目来源"> </el-table-column>
         <el-table-column prop="mainName" label="代理律师(主)"> </el-table-column>
          <el-table-column prop="deputyName" label="代理律师(副)">
             <template slot-scope="scope">
    {{ scope.row.deputyName ? scope.row.deputyName.join('、') : '' }}
  </template>
   </el-table-column>
        
        <el-table-column prop="collectionDate" label="收案日期">
          <template slot-scope="scope">
            {{ formatTime(scope.row.collectionDate) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="conflic_btn">
        <el-button @click="conflict('formConflict')" type="primary" :disabled="dianji" v-if="!(allConflictCount>0&&OptiomConflict.length<=0)"
          >继续提交</el-button
        >
        <el-button type="warning" @click="edit()">取消录入</el-button>
      </div>
    </el-dialog>

    <!-- 结案申请 -->
    <el-dialog title="结案" center :visible.sync="closeCaseDialog" width="40%">
      <el-form
        class="form"
        label-width="120px"
        :model="dialogclose"
        :rules="ruleclosecase"
        ref="closecase"
      >
        <el-form-item label="发票管理" prop="invoiceFile">
          <el-upload
            class="upload_file"
            :show-file-list="false"
            v-model="dialogclose.invoiceFile"
            width="100%"
            action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=发票"
            :before-upload="(file) => beforeUploadfp(file, 4)"
            multiple
            :file-list="FileList4"
            :on-success="
              (response, file, fileList) =>
                uploadSuccess(response, file, fileList, 4)
            "
            :on-change="(file) => onChange(file, 4)"
            :on-progress="(event, file) => onProgress(event, file, 4)"
            :on-remove="(file) => handleRemove(file, 4)"
          >
            <el-button v-if="form.status != 3" size="small" class="fjchoose"
              >请选择附件</el-button
            >
          </el-upload>
          <!-- 附件回显 -->
          <div
            v-for="(item, index) in FileList4"
            :key="item.uid"
            class="file_show"
            style="margin-top: 10px"
          >
            <div class="fj" v-if="!item.isShow">
              <div style="flex: 1">
                <img
                  src="../../assets/file/word.svg"
                  v-if="
                    item.ftype == 'doc' ||
                    item.ftype == 'docx' ||
                    item.ftype == 'DOC' ||
                    item.ftype == 'DOCX'
                  "
                />
                <img
                  src="../../assets/file/xls.svg"
                  v-if="
                    item.ftype == 'xlsx' ||
                    item.ftype == 'xls' ||
                    item.ftype == 'XLSX' ||
                    item.ftype == 'XLS'
                  "
                />
                <img
                  src="../../assets/file/png.svg"
                  v-if="
                    item.ftype == 'jpg' ||
                    item.ftype == 'jpeg' ||
                    item.ftype == 'png' ||
                    item.ftype == 'JPG' ||
                    item.ftype == 'JPEG' ||
                    item.ftype == 'PNG'
                  "
                />
                <img
                  src="../../assets/file/PDF.svg"
                  v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                />
              </div>
              <div class="name" style="flex: 9">
                <div>
                  {{ item.name }}
                </div>
                <div class="word">
                  <span @click="look(item)" class="look">预览</span>
                  <span class="down" @click="down(item)">下载</span>

                  <span @click="del(index, 4, item)" class="del">删除</span>
                </div>
              </div>
            </div>
            <!--文件上传进度条-->
            <div class="uploadprocess" v-else>
              <div>
                <div class="jdtext">
                  <div class="uploadname">{{ item.name }}</div>
                  <div class="per">{{ item.curPercentage }}%</div>
                </div>
                <el-progress
                  :percentage="item.curPercentage"
                  :show-text="false"
                ></el-progress>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <!-- 上传发票 -->
          <el-button @click="AddInvoiceFile('closecase')" type="primary"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--归档-->
    <el-dialog title="归档" center :visible.sync="archiveDialog" width="40%">
      <el-form
        class="form"
        label-width="120px"
        :model="dialogarchive"
        :rules="rulearchive"
        ref="archive"
      >
        <el-form-item label="受理机构案号" prop="acceptCode">
          <el-input
            v-model="dialogarchive.acceptCode"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="卷宗数量" prop="quantity">
          <el-input
            placeholder="请输入卷宗数量"
            v-model="dialogarchive.quantity"
            width="60%"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <el-button @click="AddArchive('archive')" type="primary"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 冲突预览 -->
    <el-dialog
      center
      title="预览"
      :visible.sync="isChong"
      append-to-body
      class="file-dialog"
      width="85%"
      @close="closChong"
    >
      <el-form class="form" ref="formrefCT" :model="CTform" label-width="200px">
        <!-- 案件当事人 -->
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6||chongCaseType == 9
          "
          style="width: 90%"
        >
          <div class="divider"></div>
          <div class="top">
            <div class="icon"></div>
            <div>案件当事人</div>
          </div>
          <!-- <el-row class="addrow" v-if="bianji == false">
            <el-select v-model="addTableData" clearable filterable>
              <el-option
                v-for="item in ArrtibuteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button size="mini" type="primary" @click="addParty(null, null)">
              添加当事人
            </el-button>
          </el-row> -->
          <el-row>
            <el-table
              class="party"
              border
              :data="CTform.tableData"
              style="width: calc(100% - 61px);"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="属性"
                prop="attribute"
                :render-header="addRedStar"
                width="160"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.attribute"
                    clearable
                    filterable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column v-if="chongCaseType !=9"
                label="类型"
                prop="isUnit"
                :render-header="addRedStar"
                width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.isUnit"
                    clearable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="姓名/单位名称"
                prop="name"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              ></el-table-column>
              <el-table-column
                label="身份证号/社会信用代码/护照号"
                prop="idnumber"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="委托方"
                prop="isClient"
                :render-header="addRedStar"
                width="80"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="bianji"
                    v-model="scope.row.isClient"
                    @change="clientChange(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column>

           
            </el-table>
          </el-row>
        </div>

        <div class="text">
          <div style="width: 90%">案件信息：{{ CTform.title }}</div>
        </div>
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6
          "
          style="width: 90%"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="案件名称" prop="title">
                <el-input
                  v-model="CTform.title"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="chongCaseType == 3">
              <el-form-item label="公益诉讼" prop="public_welfare">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.public_welfare"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构案号" prop="acceptcode">
                <el-input
                  v-model="CTform.acceptcode"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="chongCaseType != 4">
              <el-form-item label="法律援助" prop="assist">
                <el-select
                  v-model="CTform.assist"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Flyz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案卷状态" prop="ajstatus">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    style="width: 100%"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="10">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 10px; margin-top: 4px"
                v-if="CTform.casestatus == '未受理' && bianji && form.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="date_box">
              <el-form-item label="收案日期" prop="approvaldate">
                <div
                  class="date_box"
                  @mouseover="onMouseOver()"
                  @mouseleave="onMouseleave()"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="CTform.approvaldate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="系统自动生成"
                    clearable
                    disabled
                  >
                  </el-date-picker>
                  <!-- <i class="el-icon-date" ref="iconDate"></i> -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构" prop="acceptUnit">
                <el-input
                  v-model="CTform.acceptUnit"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案由" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="leadLawyer">
                <el-select
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="false">
              <el-form-item
                label="委托事项"
                prop="remark"
                v-if="chongCaseType != 2"
              >
                <el-select
                  style="width: 100%"
                  v-model="CTform.remark"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Entrust"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="chongCaseType == 2"
                label="介入阶段"
                prop="intervene"
              >
                <el-select
                  filterable
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.intervene"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Intervene"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="chongCaseType == 2">
            <el-col :span="12" v-if="CTform.result == 1">
              <el-form-item label="刑事风险控制人" prop="criminalrisk">
                <el-select
                  style="width: 100%"
                  v-model="CTform.criminalrisk"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Criminal"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="
                chongCaseType != 7 &&
                chongCaseType != 8 &&
                chongCaseType != 14 &&
                chongCaseType != 9 &&
                CTform.result == 1
              "
            >
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  multiple
                  :multiple-limit="1"
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                placeholder="请选择"
                clearable
                v-model="CTform.caseLeaderscase"
                @change="bmzgChange"
              >
              
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </div>

        <div v-else style="width: 90%">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="title">
                <el-input v-model="CTform.title" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="受理机构案号" prop="acceptcode">
              <el-input
                v-model="CTform.acceptcode"
                placeholder="请输入"
                clearable
                disabled
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="项目概要" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="案卷状态" prop="ajstatus" v-if="chongCaseType != 12 && chongCaseType !=13">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="input"
                  style="width: 100%"
                  disabled
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="破产案件类型" prop="bcz.projecttype" v-if="chongCaseType == 12">
                    <el-select
                      style="width: 100%"
                      v-model="CTform.bcz.projecttype"
                      placeholder="请选择"
                      class="select"
                      disabled
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 20px"
                v-if="CTform.casestatus == '未受理' && bianji && CTform.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="项目合伙人" prop="partner">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.partner"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="底稿资料" prop="draft">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.draft"
                  placeholder="请选择"
                  class="select"
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Draft"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
          <el-row
            v-if="
              chongCaseType != 7 &&
              chongCaseType != 8 &&
              chongCaseType != 14 &&
              chongCaseType != 9 &&
              (form.result == 1 || bianji == false)
            "
            style="width: 90%"
          >
            <el-col :span="14">
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="divider"></div>
          <el-row>
            <el-col :span="14" class="date_box">
              <el-form-item label="立项日期" prop="approvaldate">
                <el-date-picker
                  style="width: 100%"
                  v-model="CTform.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="系统自动生成"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="项目来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '代理机构' : '受理机构'"
                prop="acceptUnit"
                v-if="chongCaseType == 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
              <el-form-item
                :label="chongCaseType == 12 ? '管辖法院' : '受理机构'"
                v-if="chongCaseType != 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="10"
              v-if="
                chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9 ||
                chongCaseType == 11
              "
            >
              <el-form-item label="项目分类" prop="classification">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.classification"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 10">
              <el-form-item label="项目类型" prop="projecttype">
                <el-select
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.projecttype"
                  disabled
                >
                  <el-option
                    v-for="item in Projecttype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 12">
              <el-form-item label="案件级别" >
                <el-select style="width: 100%" v-model="CTform.bcz.caselevel" placeholder="请选择" class="select" disabled>
                    <el-option v-for="item in Level" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '服务律师' : '代理律师'"
                prop="leadLawyer"
              >
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              (chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9) &&
              CTform.result == 1
            "
          >
            <el-col :span="14">
              <el-form-item label="风控委" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="2"
                  disabled
                >
                  <el-option
                    v-for="item in FKW"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                style="width: 100%"
                v-model="CTform.caseLeaderscase"
                placeholder="请选择"
                class="select"
                clearable
                @change="bmzgChange"
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
          <div v-if="chongCaseType == 10">
            <el-row>
              <el-col :span="14">
                <el-form-item label="开放时间" prop="opentime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.opentime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购方式" prop="procuremethod">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procuremethod"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="预算金额" prop="budgetmoney">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.budgetmoney"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购编号" prop="procurecode">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procurecode"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 专项服务合同独有字段 -->
          <div v-if="chongCaseType == 11">
            <el-row>
              <el-col :span="14">
                <el-form-item label="合同服务类型" prop="contracttype">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.contracttype"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="服务期限" prop="servicetime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.servicetime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="chongCaseType == 12">
            <el-row>
                <el-col :span="14">
                  <el-form-item label="项目负责人" >
                    <el-input v-model="CTform.bcz.porjectleader" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="委托人摇号" >
                    <el-input v-model="CTform.bcz.lottery" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="管理人账号" >
                    <el-select style="width: 100%" v-model="CTform.bcz.administrator" placeholder="请选择"
                      class="select" disabled>
                      <el-option v-for="item in Administrator" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!CTform.bcz.administrator">
                  <el-col :span="14">
                    <el-form-item label="开户账号" >
                      <el-input v-model="CTform.bcz.account" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="开户银行" >
                      <el-input v-model="CTform.bcz.bank" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
          </div>
          <div class="divider"></div>

          <el-row v-if="chongCaseType!=9&&chongCaseType!=11">
            <el-col :span="14">
              <el-form-item v-if="chongCaseType!=12"
                :label="chongCaseType == 10 ? '采购单位' : '客户名称'"
                prop="bcz.procureunit"
              >
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.procureunit"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="债务人名称" prop="bcz.debtorName" v-if="chongCaseType==12">
                      <el-input
                        v-model="CTform.bcz.debtorName"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType != 10">
                    <el-form-item label="身份证号/社会信用代码/护照号" >
                      <el-input v-model="CTform.bcz.idnumber" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
          </el-row>
           <el-row v-if="chongCaseType==11" v-for="(item,index) in CTform.bcz.tableData">
            <el-col :span="12">
              <el-form-item label="客户名称" :prop="`bcz.tableData[${index}].name`">
                      <el-input
                        v-model="CTform.bcz.tableData[index].name"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
            <el-col :span="12">
                    <el-form-item label="身份证号/社会信用代码/护照号"  :prop="`bcz.tableData[${index}].idnumber`" label-width="260px">
                      <el-input v-model="CTform.bcz.tableData[index].idnumber" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- 预览dialog -->
    <el-dialog
      center
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>

    <!--更换律师-->
    <el-dialog title="更换律师" center :visible.sync="lawyerDialog" width="40%">
      <el-form class="form" label-width="120px" :model="dialoglawyer">
        <el-form-item label="代理律师" prop="coCounsel">
          <el-select
            style="width: 100%"
            v-model="dialoglawyer.coCounsel"
            placeholder="请选择"
            filterable
            class="select"
            multiple
          >
            <el-option
              v-for="item in updateDifferenceSet(dialoglawyer.coCounsel)"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <el-button @click="UpdateCo()" type="primary">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 更换当事人 -->
    <el-dialog
      title="更换当事人"
      center
      :visible.sync="litigantDialog"
      width="80%"
      @close="litigantClose"
    >
      <!-- 案件当事人 -->
      <div
        v-if="
          numType == 1 ||
          numType == 2 ||
          numType == 3 ||
          numType == 4 ||
          numType == 5 ||
          numType == 6
        "
      >
        <div class="top">
          <div class="dialog_addrow">
            <el-select v-model="addTableData" clearable filterable>
              <el-option
                v-for="item in ArrtibuteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              size="mini"
              type="primary"
              @click="addParty(null, 'dialog1_6')"
            >
              添加当事人
            </el-button>
          </div>
        </div>
        <el-row>
          <el-table
            class="party"
            :data="dialogLitigant"
            style="width: calc(100% - 61px);"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              label="属性"
              prop="attribute"
              :render-header="addRedStar"
              width="150"
              v-if="numType == 2"
            >
              <template slot-scope="scope">
                <el-select
                  size="mini"
                  v-model="scope.row.attribute"
                  filterable
                  @change="dsrOrder(scope.row)"
                  v-if="
                    scope.row.attribute == '被告人' ||
                    scope.row.attribute == '上诉人' ||
                    scope.row.attribute == '犯罪嫌疑人'
                  "
                >
                  <el-option
                    v-for="item in xingshiArrtibute1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>

                <el-select
                  size="mini"
                  v-model="scope.row.attribute"
                  filterable
                  @change="dsrOrder(scope.row)"
                  v-if="
                    scope.row.attribute == '公诉机关' ||
                    scope.row.attribute == '自诉人'
                  "
                >
                  <el-option
                    v-for="item in xingshiArrtibute2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column
              label="属性"
              prop="attribute"
              :render-header="addRedStar"
              width="150"
              v-else
            >
              <template slot-scope="scope">
                <el-select
                  size="mini"
                  v-model="scope.row.attribute"
                  filterable
                  @change="dsrOrder(scope.row)"
                  v-if="
                    ((numType == 1 && form.ajstatus == '二审') ||
                      (numType == 3 && form.ajstatus == '二审')) &&
                    (scope.row.attribute == '第三人' ||
                      scope.row.attribute == '原审第三人')
                  "
                >
                  <el-option
                    v-for="item in ershenArrtibute"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  size="mini"
                  v-model="scope.row.attribute"
                  filterable
                  @change="dsrOrder(scope.row)"
                  v-else
                >
                  <el-option
                    v-for="item in ArrtibuteOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column
              label="姓名/单位名称"
              prop="name"
              :render-header="addRedStar"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-autocomplete
                  class="input_autocomplete"
                  v-model="scope.row.name"
                  clearable
                  :fetch-suggestions="
                    (item1, item2) => {
                      querySearch(item1, item2, scope.row)
                    }
                  "
                  @select="
                    (item) => {
                      handleSelect(item, scope.row, 'dialog')
                    }
                  "
                ></el-autocomplete>
              </template>
            </el-table-column>

            <el-table-column
              label="类型"
              prop="isUnit"
              :render-header="addRedStar"
              width="120"
            >
              <template slot-scope="scope">
                <el-select size="mini" v-model="scope.row.isUnit" clearable>
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  @click="addParty(scope.row, 'dialog1_6')"
                  ><div class="copy">+</div></el-button
                >
                <el-button
                  type="danger"
                  @click="reduceParty(scope.row.count, 1)"
                >
                  <div class="del_btn">-</div></el-button
                >
              </template>
            </el-table-column>

            <el-table-column
              label="委托方"
              prop="isClient"
              :render-header="addRedStar"
              width="100"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.isClient"
                  @change="clientChangeDialog(scope.row)"
                ></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>

      <div v-if="numType == 9">
        <div class="top">
          <div class="dialog_addrow">
            <el-select v-model="addTableData" clearable filterable>
              <el-option
                v-for="item in ArrtibuteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              size="mini"
              type="primary"
              @click="addParty09(null, 'dialog9')"
            >
              添加当事人
            </el-button>
          </div>
        </div>

        <el-row>
          <el-table
            class="party"
            :data="dialogLitigant"
            style="width: calc(100% - 61px);"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              label="属性"
              prop="Attribute"
              :render-header="addRedStar"
              width="150"
            >
              <template slot-scope="scope">
                <el-select
                  size="mini"
                  v-model="scope.row.attribute"
                  filterable
                  @change="dsrOrder(scope.row)"
                  disabled
                >
                  <el-option
                    v-for="item in ArrtibuteOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="姓名/单位名称"
              prop="Name"
              :render-header="addRedStar"
            >
              <template slot-scope="scope">
                <el-autocomplete
                  class="input_autocomplete"
                  v-model="scope.row.name"
                  clearable
                  :fetch-suggestions="
                    (item1, item2) => {
                      querySearch(item1, item2, scope.row)
                    }
                  "
                  @select="
                    (item) => {
                      handleSelect(item, scope.row, 'dialog')
                    }
                  "
                ></el-autocomplete>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  @click="addParty09(scope.row, 'dialog9')"
                >
                  <div class="copy">+</div></el-button
                >
                <el-button
                  type="danger"
                  @click="reduceParty(scope.row.count, 1)"
                >
                  <div class="del_btn">-</div></el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              label="委托方"
              prop="IsClient"
              :render-header="addRedStar"
              width="100"
            >
              <template slot-scope="scope">
                <el-checkbox
                  disabled
                  v-model="scope.row.isClient"
                  @change="clientChangeDialog(scope.row)"
                ></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>

      <div class="footer">
        <el-button type="primary" @click="enterChange" :disabled="dianji"
          >确 认</el-button
        >
        <el-button @click="litigantClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
<script>
import {
  getCaseInfoLinkApi,
  getCaseLinkApi,
  allCaseApi,
  caseUpdateApi,
  caseLogApi,
  caseSealApi,
  fileUpdateApi,
  caseConflictApi,
  caseLawyerApi,
  caseAdviserApi,
  caseDepartmentLeadersApi,
  UpdateLawyer,
  CaseAppect,
  getEText,
  getLitigant,
  changeLitigant,
  ConflictMember,
  GetAllLitigant,
  BanruptcykConflictApi,
} from '../../api/case'
import { CaseProcess, CaseApprover } from '../../api/bankrupt'

import { ClosingCase, Archive } from '../../api/bankrupt'
import { requestDownLoadFile } from '../../api/seal.js'
import {
  requestDownLoadFile as YuLan,
  requestReview
} from '../../api/counsel.js'
import mammoth from 'mammoth'
import axios from 'axios'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
export default {
  name: 'caseinfo',
  data() {
    var quantity = (rule, value, callback) => {
      var number = /^[1-9][0-9]*$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (!number.test(value)) {
        callback(new Error('请输入正确数字')) //只能输入整数
      } else {
        callback()
      }
    }
    var Price = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var newPrice = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var riskRatio = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value < 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (value > 100) {
        callback(new Error('不能大于100'))
      } else if (!price.test(value)) {
        callback(new Error('最多输入两位小数')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var ajstatusCheck = (rule, value, callback) => {
      if (
        value == null ||
        value === undefined ||
        value == [] ||
        value.length == 0
      ) {
        // console.log('check', value)
        callback(new Error('请输入或选择！'))
      }
      callback()
    }
    var filecheck = (rule, value, callback) => {
      if (
        value == null ||
        value === undefined ||
        value == '' ||
        value == [] ||
        value.length <= 0
      ) {
        callback(new Error('至少要上传一个合同附件！'))
      }
      callback()
    }
    return {
      AllLit:[],
      timeGuidang:false,
      Level: [
        { value: 1, label: '一级' },
        { value: 2, label: '二级' },
        { value: 3, label: '三级' }
      ], //案件级别
      // 案件审核主管
      CaseLeaders: [],
      Administrator: [
        { value: false, label: '未开设' },
        { value: true, label: '已开设' }
      ], //管理人
  ProjectType:[{label:"重整案件",value:"重整案件"},{label:"预重整",value:"预重整"},{label:"公益案件",value:"公益案件"}],  
      // 用章审核主管
      SealLeaders: [],
      loading: true,
      // 表单验证
      formrules: {
        title: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        // acceptcode: [
        //   { required: true, validator: ajstatusCheck, trigger: 'blur' },
        //   { required: true, validator: ajstatusCheck, trigger: 'change' }
        // ],
        casestatus: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        cause: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        acceptUnit: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        ajstatus: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        approvaldate: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        leadLawyer: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        chargingMethod: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        level: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        leadLawyer2: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        criminalrisk: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        caseLeaderscase: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        amountOfSubject: [
          { required: true, validator: newPrice, trigger: 'change' }
        ], //投标价格
        fixed: [{ required: true, validator: newPrice, trigger: 'change' }], //定额收费金额
        riskFixed: [{ required: true, validator: newPrice, trigger: 'change' }], //半风险中的定额收费金额
        riskRatio: [{ required: true, validator: newPrice, trigger: 'change' },
        { validator: riskRatio, trigger: 'change' }], //风险收费比例
        //风险收费比例
        applicant: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        seal: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        reason: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        biddingSchemes: [
          { required: true, validator: filecheck, trigger: 'blur' }
        ],
        chujuFiles:[
          { required: true, validator: filecheck, trigger: 'blur' }
        ],
        freeFiles: [{ required: true, validator: filecheck, trigger: 'blur' }]
        // procureunit: [{ required: true, message: '不能为空', trigger: 'blur' }]
      },
      sealRules: {
        applicant: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        // sealType: [
        //   { required: true, validator: ajstatusCheck, trigger: 'blur' },
        //   { required: true, validator: ajstatusCheck, trigger: 'change' }
        // ],
        leadLawyer2: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        reason: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        sealLeaders: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        sealFile: [
          // { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ]
      },
      // 案件操作日志
      logs: [],

      // 表单验证
      rules: {
        name: [
          { required: true, validator: quantity, trigger: 'blur' },
          { required: true, validator: quantity, trigger: 'change' }
        ]
        // { required: true, validator: zt, trigger: 'change' }
      },
      // 法律援助
      Flyz: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      // 案卷状态
      Ajstatus: [
        { label: '一审', value: '一审' },
        { label: '二审', value: '二审' },
        { label: '再审', value: '再审' },
        { label: '破产申报', value: '破产申报' },
        { label: '破产申请', value: '破产申请' },
        { label: '再审听证', value: '再审听证' },
        { label:'强制清算',value:'强制清算'},
        { label: '行政裁决', value: '行政裁决' },
        { label: '行政复议', value: '行政复议' },
        { label: '首次执行', value: '首次执行' },
        { label: '恢复执行', value: '恢复执行' },
        { label: '执行异议', value: '执行异议' },
        { label: '仲裁阶段', value: '仲裁阶段' },
        { label: '侦查阶段', value: '侦查阶段' },
        { label: '审查起诉', value: '审查起诉' },
        { label: '无', value: '无' },
        { label: '申请撤销裁决', value: '申请撤销裁决' },
        // { label: '受理', value: '受理' },
        // { label: '未受理', value: '未受理' }
      ],
      CaseStatus: [
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' }
      ],
      // 委托事项
      Entrust: [
        { value: '特别授权', label: '特别授权' },
        { value: '一般授权', label: '一般授权' }
      ],

      // 收费方式
      Chargestatus1: [
        { value: '免费', label: '免费' },
        { value: '固定收费', label: '固定收费' },
        { value: '风险收费', label: '风险收费' }
      ],
      Chargestatus2: [
        { value: '免费', label: '免费' },
        { value: '固定收费', label: '固定收费' }
      ],
      Chargestatus:[],
      // 用章类型
      Seal: [
        { value: 'contract_seal', label: '合同章' },
        { value: 'corporate_seal', label: '法人章' },
        { value: 'official_seal', label: '公章' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ],
      SealYJChange: [
        { value: 'contract_seal', label: '合同章' },
        { value: 'corporate_seal', label: '法人章' },
        { value: 'official_seal', label: '公章' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' }
        // { label:"律师函专用章",value:"legal_letter_seal"}
      ],

      SealChange: [
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ],
      // 公益诉求
      options: [
        { value: 0, label: '是' },
        { value: 1, label: '否' }
      ],
      //委托方
      IsClient: [
        { value: true, label: '是' },
        { value: false, label: '否' }
      ],
      // 单位/个人
      typeOptions: [
        { value: true, label: '个人' },
        { value: false, label: '单位' }
      ],
      ArrtibuteOptions: [
        // { value: '原告', label: '原告' },
        // { value: '被告', label: '被告' },
        // { value: '第三人', label: '第三人' },
        // { value: '上诉人', label: '上诉人' },
        // { value: '被上诉人', label: '被上诉人' },
        // { value: '原审第三人', label: '原审第三人' },
        // { value: '原审原告', label: '原审原告' },
        // { value: '原审被告', label: '原审被告' },
        // { value: '申请人', label: '申请人' },
        // { value: '被申请人', label: '被申请人' },
        // { value: '债务人', label: '债务人' },
        // { value: '债权人', label: '债权人' },
        // { value: '公诉机关', label: '公诉机关' },
        // { value: '犯罪嫌疑人', label: '犯罪嫌疑人' },
        // { value: '自诉人', label: '自诉人' },
        // { value: '复议申请人', label: '复议申请人' },
        // { value: '复议被申请人', label: '复议被申请人' },
        // { value: '申请执行人', label: '申请执行人' },
        // { value: '被执行人', label: '被执行人' },
        // { value: '执行异议人', label: '执行异议人' }
      ],

      xingshiArrtibute1: [
        { value: '被告人', label: '被告人', order: 100 },
        { value: '上诉人', label: '上诉人', order: 200 },
        { value: '犯罪嫌疑人', label: '犯罪嫌疑人', order: 300 }
      ],

      xingshiArrtibute2: [
        { value: '公诉机关', label: '公诉机关', order: 400 },
        { value: '自诉人', label: '自诉人', order: 500 }
      ],

      ershenArrtibute: [
        { value: '第三人', label: '第三人', order: 300 },
        { value: '原审第三人', label: '原审第三人', order: 400 }
      ],

      // 介入阶段
      Intervene: [
        { value: '0', label: '全程' },
        { value: '1', label: '侦查阶段' },
        { value: '2', label: '审查起诉阶段' },
        { value: '3', label: '审判阶段' }
      ],
      // 项目类型
      Projecttype: [ { label: '政府采购', value: 0 },
        { label: '国企采购', value: 1 },
        { label: '其他社会采购', value: 2 }],
      // 风控委
      Risk: [],
      // 收费明细状态
      Bcbd_status: [
        // { value: -1, label: '已删除' },
        { value: 0, label: '已完成' },
        // { value: 1, label: '已禁用' },
        { value: 2, label: '已提醒' },
        { value: 3, label: '待提醒' }
      ],
      // 底稿资料
      Draft: [
        { label: '已归档', value: true },
        { label: '未归档', value: false }
      ],
      // 代理律师/申请人/代理律师
      Lawyer: [],
      // 案件二次审批人
      Level: [],
      //用章二次审批人
      SealLevel: [],
      // 风控委
      FKW: [],
      // 刑事风险控制人
      Criminal: [],
      Caselevel: [],
      // 表单
      form: {
        casestatus: null,
        acceptcode: null, // 受理机构案号/受理案号
        id: null,
        assist: null, //法律援助(true是，false否）
        typeId: null, // 录入类型
        title: null, //案件名称
        code: null, //案件编号
        ajstatus: null, //案卷状态(节点名称)***
        approvaldate: null, //收案日期(委托时间)***
        source: null, // 项目概要/案件来源
        acceptUnit: null, //受理机构(受理单位)
        cause: null, //案由/项目来源
        leadLawyer: [], //代理律师(主办律师)***List
        remark: null, //委托事项
     
        coCounsel: [], //代理律师 List
        biddingSchemes: [], //合同上传 List
        ordinaryFiles: [], //普通附件 List
        invoiceFile: [], //发票
        chujuFiles:[],//拟出具文件
        linkId: null, // 关联案件ID*** Guid
        status: null,
       

        link: [],
        criminalrisk: null, //刑事风险控制人  Guid
        result: null,
        bs_Result: null,
        // 不复存在的
        bcz: {
          client: null, //委托人
          intervene: null, //介入阶段(0全程，1侦查阶段，2审查起诉阶段，3审判阶段）

          public_welfare: null, //是否是公益诉讼

          //------全都是<非诉案件>------
          partner: null, //项目合伙人
          draft: null, //底稿资料
          classification: null, //项目分类
          projecttype: null, //项目类型***  Guid
          opentime: null, //开放时间
          procuremethod: null, //采购方式
          budgetmoney: null, //预算金额
          procurecode: null, //采购编号
          contracttype: null, //合同服务类型
          servicetime: null, //服务期限
          procureunit: null ,//采购单位/客户名称
          idnumber:null,//身份证号/社会信用代码
          tableData:[
            // {
            //   id:null,
            //   name: null, //姓名/单位名称***
            //   attribute: "客户名称", //当事人属性（原告被告等）***
            //   count: 1,
            //   idnumber:null,
            //   isClient:true,
            //   isUnit:false,
            //   order:0,
            //   }
          ],//只有专项服务合同才有
        },

        // 收费
        chargingMethod: '固定收费', //收费方式***
        subjectMatter: null, //案件标的
        amountOfSubject: 0, //标的金额***
        introduction: null, //简介
        bcb_Remark: null, //备注
        fixed: 0, //固定收费金额***
        riskFixed: null, //半风险定额收费金额***
        riskRatio: null, //风险收费比例***

        // 收费明细
        bcbdTable: [
          {
            id: null,
            name: null, // 款项名称***
            amount: null, // 应收金额***
            paymentDate: null, //约定收款日期
            remark: null, //备注
            status: null, // 状态***
            count: 1
          }
        ],
        // 案件当事人
        tableData: [
          {
            id: null,
            isUnit: null, //是否是个人***
            name: null, //姓名/单位名称***
            isClient: false, //是否委托人***
            attribute: null, //当事人属性（原告被告等）***
            count: 1
          }
        ]
      },
      sealForm: {
        // ------用章申请------
        sealFile: [], //附件
        applicant: null, //申请人******
        leadLawyer2: null, //二次审批人
        sealType: null, //用章类型******
        reason: '申请立项', //用章事由******
        sealLeaders: null // 用章部门主管
      },

      newtableData: [],

      newbcbdTable: [],

      sfxz: {
        // 定额收费金额
        fixed: true,

        // 半风险中的定额收费金额
        riskFixed: false,

        // 风险收费比例
        riskRatio: false,

        // 收费明细
        detail: true,

        // 免费凭证
        mfpz: false
      },
      FileList1: [],
      FileList2: [],
      FileList3: [], //发票
      FileList5: [], //免费凭证
      FileList7: [],
      closeCaseDialog: false, //结案弹出框
      dialogclose: { invoiceFile: [] },
      FileList4: [], //弹出框的发票
      ruleclosecase: {
        invoiceFile: { required: true, message: '不能为空 ', trigger: 'change' }
      },
      archiveDialog: false, //归档弹出框
      dialogarchive: {
        quantity: null,
        acceptCode: null
      },
      rulearchive: {
        quantity: { required: true, message: '不能为空 ', trigger: 'change' },
        acceptCode: [
          { required: true, message: '不能为空 ', trigger: 'change' }
        ]
      },
      isShowJinDuTiao: false, //上传进度招标文件
      isShowother: false, //上传进度普通文件
      curPercentage: 0, //进度百分比
      uploadname: null, //正在上传的文件名称
      type: [], //项目类型

      titleType: null, // 录入类型标题

      numType: null, // 类型判断参数
      FileList: [], //用章附件
      Arr: [], //律师冲突变量
      caseConflict: false, //案件冲突状态
      conflictList: [], //录入案件冲突列表
      conflictTable: [], //查看案件冲突列表
      lvShiConflict: [], //录入顾问冲突列表
      lvShiConflictTable: [], //查看顾问冲突列表
      YongZhang: null,
      ProcessType: ['case_entry'],
      add: true, // 是否可以添加（true可，false不能）
      bianji: true, // 只允许不通过的时候编辑（false可编辑，true不能）
      NewFile: [], // 新上传的File

      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数

      Detail_caseinput: false, // 添加步骤
      Detail_update: false, // 附件更新
      Detail_down: false, // 附件下载
      Detail_enter: false, // 案件提交
      Detail_ja: false, // 结案
      Detail_gd: false, // 归档
      Detail_look: false, // 预览
      Detail_lawyer: false, // 更换律师
      Detail_litigant: false, // 更换当事人

      // 协理律师修改
      lawyerDialog: false,
      dialoglawyer: {
        coCounsel: [] //代理律师
      },
      Process: {}, //未审核
      processlogs: {},

      //冲突详情
      chongCaseType: '',
      isChong: false,
      CTform: {
        casestatus: null,
        acceptcode: null, // 受理机构案号/受理案号
        id: null,
        assist: null, //法律援助(true是，false否）
        typeId: null, // 录入类型
        title: null, //案件名称
        code: null, //案件编号
        ajstatus: null, //案卷状态(节点名称)***
        approvaldate: null, //收案日期(委托时间)***
        source: null, // 项目概要/案件来源
        acceptUnit: null, //受理机构(受理单位)
        cause: null, //案由/项目来源
        leadLawyer: [], //代理律师(主办律师)***List
        remark: null, //委托事项
        level: [], //二次审批人/风控委
        coCounsel: [], //代理律师 List
        biddingSchemes: [], //合同上传 List
        ordinaryFiles: [], //普通附件 List
        chujuFiles:[],//拟出具文件
        invoiceFile: [], //发票
        linkId: null, // 关联案件ID*** Guid
        status: null,
        caseLeaderscase: null, // 案件部门主管
        link: [],
        criminalrisk: null, //刑事风险控制人  Guid
        result: null,
        bs_Result: null,
        // 不复存在的
        bcz: {
          client: null, //委托人
          intervene: null, //介入阶段(0全程，1侦查阶段，2审查起诉阶段，3审判阶段）

          public_welfare: null, //是否是公益诉讼

          //------全都是<非诉案件>------
          partner: null, //项目合伙人
          draft: null, //底稿资料
          classification: null, //项目分类
          projecttype: null, //项目类型***  Guid
          opentime: null, //开放时间
          procuremethod: null, //采购方式
          budgetmoney: null, //预算金额
          procurecode: null, //采购编号
          contracttype: null, //合同服务类型
          servicetime: null, //服务期限
          procureunit: null,//采购单位/客户名称
          idnumber:null,//身份证号/社会信用代码
        },
        // 案件当事人
        tableData: [
          {
            id: null,
            isUnit: null, //是否是个人***
            name: null, //姓名/单位名称***
            isClient: false, //是否委托人***
            attribute: null, //当事人属性（原告被告等）***
            idnumber:null,//身份证号/社会信用代码
            count: 1
          }
        ]
      },

      step: true, //添加程序
      loading: true,
      addTableData: null,

      checkedCities: [],
      cities: null,
      sealbianji: true,
      bsNewType: true,
      caseLinkloading: false,

      allrestaurants: null,
      restaurants: [],
      dianji: false,
      litigantDialog: false,
      // 案件当事人
      dialogLitigant: [],

      //二次利冲审批人
      conflictShow:false,//是否显示选择框，若无利冲或只有一个审批人的情况下不显示
      allConflictCount:0,//总冲突数量
      OptiomConflict:[],//所有二次利冲审批人
      formConflict:{
        conflictApproval:null,
      },
      rulesConflict:{
        conflictApproval: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },

      showAllCase:false,//是否显示全部冲突案件
      hasMore:false,
      allConflictCase:[],//所有的冲突案件

      dialogshowAllCase:false,//是否显示全部冲突案件
      dialoghasMore:false,
      dialogallConflictCase:[],//所有的冲突案件
      
      idnumbers:[],

      BanruptcykConflictTable:[],

      BanruptcykConflict:[],//弹出框的破产管理人
    }
  },

  methods: {
     filterComma3(row) {
      if (row.name&&row.name.includes('、')) {
        row.name = row.name.replace(/、/g, '');
      }
      if (row.idnumber&&row.idnumber.includes('、')) {
        row.idnumber = row.idnumber.replace(/、/g, '');
      }
    },
    //客户名称
    querySearchName3(queryString, cb) {
     
     var restaurants =[]
     if(queryString.length>4){
      restaurants = this.AllLit;
     }
     var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
   
     if(results.length==0){
      this.idnumbers=[];
      
     }
        // 调用 callback 返回建议列表的数据
     cb(results);
    },
  handleSelectName3(item,index){
   this.form.bcz.tableData[index].name=item.value
    const unique1 = [...new Set(item.idnumber)];
    this.idnumbers = unique1;
    if(unique1&&unique1.length>=1){
      this.form.bcz.tableData[index].idnumber=unique1[0]
    }
  },
     // 身份证号搜索逻辑：基于当前行的候选证件号
     querySearchId3(queryString, cb) {
     
      // 候选源为当前姓名对应的证件号（若未选姓名则为空）
      var idCandidates = this.idnumbers.map(id => ({ value: id }));
    // console.log(this.idnumbers)
      
      var results = queryString ? idCandidates.filter(this.createFilterName(queryString)) : idCandidates;
      cb(results);
    },

   // 添加当事人
    addParty3() {
      // 当前已有的最大count
      let c = Math.max.apply(
        Math,
        this.form.bcz.tableData.map(function (f) {
          return f.count
        })
      )
      var td=this.form.bcz.tableData.length
      // console.log(c,td)
      if (c === undefined) {
        if (td == 0) {
          this.form.bcz.tableData.push({
            // 表格
            isUnit: false,
            name: null,
            idnumber:null,
            isClient: true,
            attribute: "客户名称",
            count: 0,
            order: 0
          })
        } else {
          this.form.bcz.tableData.splice(td, 0, {
            // 表格
             isUnit: false,
              name: null,
              idnumber:null,
              isClient: true,
              attribute: "客户名称",
              count: c + 1,
              order: 0,
          })
        }
      } else {
        this.form.bcz.tableData.splice(td, 0, {
          // 表格
           isUnit: false,
              name: null,
              idnumber:null,
              isClient: true,
              attribute: "客户名称",
              count: c + 1,
              order: 0,
        })
      }
    // console.log(this.form.bcz.tableData,td)
      // this.form.tableData.sort((a, b) => {
      //   return a.order - b.order
      // })

      // this.getLitigants()
    },

    // 减少当事人
    reduceParty3(c) {
     
      // 最少保留1行，防止删空
      if (this.form.bcz.tableData.length <= 1) {
        this.$message.warning('至少保留一条数据');
        return;
      }
      // splice(起始下标, 删除个数)
      this.form.bcz.tableData.splice(c, 1);

    },
    GetLit(){//获取所有当事人
      GetAllLitigant({}).then((res)=>{
        if(res.data.status=='success'){
          this.AllLit=res.data.data
        }else{
          this.AllLit=[]
        }
       })
    },
   //客户名称
   querySearchName2(queryString, cb) {
     
     var restaurants =[]
     if(queryString.length>4){
      restaurants = this.AllLit;
     }
     var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
   
     if(results.length==0){
      this.idnumbers=[];
      
     }
        // 调用 callback 返回建议列表的数据
     cb(results);
    },
  handleSelectName2(item){
    this.form.bcz.procureunit=item.value
    const unique1 = [...new Set(item.idnumber)];
    this.idnumbers = unique1;
    if(unique1&&unique1.length>=1){
      this.form.bcz.idnumber=unique1[0]
    }
  },
     // 身份证号搜索逻辑：基于当前行的候选证件号
     querySearchId2(queryString, cb) {
     
      // 候选源为当前姓名对应的证件号（若未选姓名则为空）
      var idCandidates = this.idnumbers.map(id => ({ value: id }));
      
      var results = queryString ? idCandidates.filter(this.createFilterName(queryString)) : idCandidates;
      cb(results);
    },

    // 选中证件号的处理（可选）
    handleSelectId2(id) {
      this.form.bcz.idnumber = id.value; // 赋值选中的证件号
    },
    
    querySearchName(queryString, cb,row) {
     
       var restaurants =[]
       if((row.isUnit==false&&this.numType!=9)||(queryString.length>4&&this.numType==9)){
        restaurants = this.AllLit;
       }
      //  if(row.isUnit==true){
      //   restaurants=
      //  }
       var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
          // 调用 callback 返回建议列表的数据
      if(results.length==0&&row&&row.availableIdnumbers){
          row.availableIdnumbers=[]
       }
       cb(results);
      },
      createFilterName(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
    handleSelectName(item, row){
      row.name = item.value
      const unique1 = [...new Set(item.idnumber)];
      row.availableIdnumbers = unique1;
      if(unique1&&unique1.length>=1){
        row.idnumber=unique1[0]
      }
    },
     // 身份证号搜索逻辑：基于当前行的候选证件号
     querySearchId(queryString, cb, row) {
      // 候选源为当前姓名对应的证件号（若未选姓名则为空）
      var idCandidates = [];
      if(row.availableIdnumbers){
        idCandidates=row.availableIdnumbers.map(id => ({ value: id }))
        var results = queryString ? idCandidates.filter(this.createFilterName(queryString)) : idCandidates;
        cb(results);
      }else{
        cb(idCandidates);
      }
    },

    // 选中证件号的处理（可选）
    handleSelectId(id, row) {
      row.idnumber = id.value; // 赋值选中的证件号
    },

    GetNameIdnumber(data){
      const filtered = data.flatMap(item => 
        item.all
          .filter(person => person.isshow)
          .map(person => ({ 
            name: person.name, 
            idnumber: person.idnumber 
          }))
      );

      // 步骤2：格式化为"姓名(身份证号)"格式，多个用逗号隔开
      const resultStr = filtered.map(item => {
        // 处理身份证号为空或不存在的情况，显示"无"
        const idStr = item.idnumber || "无";
        return `${item.name}(${idStr})`;
      }).join(',');
      return resultStr
    },
     //禁止顿号的输入
     filterComma(row) {
      if (row.name && row.name.includes('、')) {
        row.name = row.name.replace(/、/g, '');
      }
    },
    filterComma2(row) {
      if (row.procureunit&&row.procureunit.includes('、')) {
        row.procureunit = row.procureunit.replace(/、/g, '');
      }
    },
    showAllCaseClick(){
      if(this.showAllCase){
        this.showAllCase=false
        this.conflictTable = this.allConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
        if(this.conflictTable.length==0){//没有冲突案件
          this.conflictTable.push(this.allConflictCase[0])
        } 
       
      }else{
        this.conflictTable=this.allConflictCase
        this.showAllCase=true
      }
    },
    dialogshowAllCaseClick(){
      if(this.dialogshowAllCase){
        this.dialogshowAllCase=false
        this.conflictList = this.dialogallConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
        if(this.conflictList.length==0){//没有冲突案件
          this.conflictList.push(this.dialogallConflictCase[0])
        } 
       
      }else{
        this.conflictList=this.dialogallConflictCase
        this.dialogshowAllCase=true
      }
    },
    async GetConflictMember(){
      ConflictMember().then((res) => {
        if(res.data.status=="success"){
          this.OptiomConflict=res.data.data
          this.caseConflict = true
                 
          if(this.OptiomConflict.length>1){
            this.conflictShow=true
          }else if(this.OptiomConflict.length==1){
             this.conflictShow=false
             this.formConflict.conflictApproval=this.OptiomConflict[0].value
          }
            console.log( this.conflictShow)
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
    //已经不用了
    async enterChange() {
      this.loading = true
      this.dianji = true
      var arrbt = this.dialogLitigant
      if (
        this.numType == 1 ||
        this.numType == 2 ||
        this.numType == 3 ||
        this.numType == 4 ||
        this.numType == 5 ||
        this.numType == 6
      ) {
        if (this.dialogLitigant.length == 0) {
          this.loading = false
          this.dianji = false
          return this.$message.error('请录入案件当事人!')
        }

        var bitian = true

        var clientBool = false
        arrbt.forEach((v) => {
          if (v.isClient == true) {
            clientBool = true
            return
          }
        })
        // console.log('clientBool:', clientBool)
        if (!clientBool) {
          this.loading = false
          this.dianji = false
          return this.$message.error('请选择代理方！')
        }
        if (this.numType == 1) {
          if (this.form.ajstatus == '一审') {
            if (!this.dialogLitigant.some((item) => item.attribute == '原告')) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加原告！')
            }
            if (!this.dialogLitigant.some((item) => item.attribute == '被告')) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加被告！')
            }
            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                if (arrbt[i].attribute == '原告') {
                  bitian = false
                  this.$message.error('请完善原告信息！')

                  break
                } else if (arrbt[i].attribute == '被告') {
                  bitian = false
                  this.$message.error('请完善被告信息！')

                  break
                }
              }
            }
          } else if (this.form.ajstatus == '二审') {
            if (
              !this.dialogLitigant.some((item) => item.attribute == '上诉人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加上诉人！')
            }
            if (
              !this.dialogLitigant.some((item) => item.attribute == '被上诉人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加被上诉人！')
            }
            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                if (arrbt[i].attribute == '上诉人') {
                  bitian = false
                  this.$message.error('请完善上诉人信息！')

                  break
                } else if (arrbt[i].attribute == '被上诉人') {
                  bitian = false
                  this.$message.error('请完善被上诉人信息！')

                  break
                }
                // else if (
                //   arrbt[i].attribute == '第三人' ||
                //   arrbt[i].attribute == '原审第三人' ||
                //   arrbt[i].attribute == '原审原告' ||
                //   arrbt[i].attribute == '原审被告'
                // ) {
                //   if (
                //     (arrbt[i].name == '' || arrbt[i].name == null) &&
                //     (arrbt[i].isClient === '' ||
                //       arrbt[i].isClient == null) &&
                //     (arrbt[i].isUnit === '' || arrbt[i].isUnit == null)
                //   ) {
                //   } else {
                //     bitian = false
                //     this.$message.error(
                //       '请完善其他案件当事人信息或从列表中移除！'
                //     )
                //     this.loading = false
                //     break
                //   }
                // }
              }
            }
          } else if (this.form.ajstatus == '再审'||this.form.ajstatus == '申请撤销裁决') {
            if (
              !this.dialogLitigant.some((item) => item.attribute == '申请人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加申请人！')
            }
            if (
              !this.dialogLitigant.some((item) => item.attribute == '被申请人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加被申请人！')
            }

            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                if (arrbt[i].attribute == '申请人') {
                  bitian = false
                  this.$message.error('请完善申请人信息！')

                  break
                } else if (arrbt[i].attribute == '被申请人') {
                  bitian = false
                  this.$message.error('请完善被申请人信息！')

                  break
                }
              }
            }
          } else if (this.form.ajstatus == '再审听证'|| this.form.ajstatus =='强制清算') {
            if (
              !this.form.tableData.some((item) => item.attribute == '申请人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加申请人！')
            }
            if (
              !this.form.tableData.some((item) => item.attribute == '被申请人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加被申请人！')
            }

            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                if (arrbt[i].attribute == '申请人') {
                  this.$message.error('请完善申请人信息！')
                  bitian = false

                  break
                } else if (arrbt[i].attribute == '被申请人') {
                  this.$message.error('请完善被申请人信息！')
                  bitian = false

                  break
                }
                // else if (arrbt[i].attribute == '第三人') {
                //   if (
                //     (arrbt[i].name == '' || arrbt[i].name == null) &&
                //     (arrbt[i].isClient === '' ||
                //       arrbt[i].isClient == null) &&
                //     (arrbt[i].isUnit === '' || arrbt[i].isUnit == null)
                //   ) {
                //   } else {
                //     this.$message.error(
                //       '请完善第三人信息或从列表中移除！'
                //     )
                //     bitian = false
                //     this.loading = false
                //     break
                //   }
                // }
              }
            }
          } else if (this.form.ajstatus == '破产申报') {
            // if (
            //   !this.dialogLitigant.some((item) => item.attribute == '申请人')
            // ) {
            //   this.loading = false
            //   this.dianji = false
            //   return this.$message.error('请添加申请人！')
            // }
            if (
              !this.dialogLitigant.some((item) => item.attribute == '债务人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加债务人！')
            }

            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                // if (arrbt[i].attribute == '申请人') {
                //   this.$message.error('请完善申请人信息！')
                //   bitian = false

                //   break
                // } else
                 if (arrbt[i].attribute == '债务人') {
                  this.$message.error('请完善债务人信息！')
                  bitian = false

                  break
                }
                // else if (arrbt[i].attribute == '第三人') {
                //   if (
                //     (arrbt[i].name == '' || arrbt[i].name == null) &&
                //     (arrbt[i].isClient === '' ||
                //       arrbt[i].isClient == null) &&
                //     (arrbt[i].isUnit === '' || arrbt[i].isUnit == null)
                //   ) {
                //   } else {
                //     this.$message.error(
                //       '请完善第三人信息或从列表中移除！'
                //     )
                //     bitian = false
                //     this.loading = false
                //     break
                //   }
                // }
              }
            }
          }
          else if (this.form.ajstatus == '破产申请') {
            if (
              !this.dialogLitigant.some((item) => item.attribute == '申请人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加申请人！')
            }

            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                 if (arrbt[i].attribute == '申请人') {
                  this.$message.error('请完善申请人信息！')
                  bitian = false

                  break
                }
              }
            }
          }
        } else if (this.numType == 2) {
          for (let i = 0; i < arrbt.length; i++) {
            if (
              arrbt[i].name == '' ||
              arrbt[i].name == null ||
              arrbt[i].isClient === '' ||
              arrbt[i].isClient == null ||
              arrbt[i].isUnit === '' ||
              arrbt[i].isUnit == null
            ) {
              if (arrbt[i].attribute == '被告人') {
                this.$message.error('请完善被告人信息！')
                bitian = false

                break
              } else if (arrbt[i].attribute == '上诉人') {
                this.$message.error('请完善上诉人信息！')
                bitian = false

                break
              } else if (arrbt[i].attribute == '犯罪嫌疑人') {
                this.$message.error('请完善犯罪嫌疑人信息！')
                bitian = false

                break
              } else if (arrbt[i].attribute == '自诉人') {
                this.$message.error('请完善自诉人信息！')
                bitian = false

                break
              } else if (arrbt[i].attribute == '公诉机关') {
                this.$message.error('请完善公诉机关信息！')
                bitian = false

                break
              }
            }
          }
        } else if (this.numType == 3) {
          if (this.form.ajstatus == '一审') {
            if (!this.dialogLitigant.some((item) => item.attribute == '原告')) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加原告！')
            }
            if (!this.dialogLitigant.some((item) => item.attribute == '被告')) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加被告！')
            }
            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                if (arrbt[i].attribute == '原告') {
                  this.$message.error('请完善原告信息！')
                  bitian = false

                  break
                } else if (arrbt[i].attribute == '被告') {
                  this.$message.error('请完善被告信息！')
                  bitian = false

                  break
                }
              }
            }
          } else if (this.form.ajstatus == '二审') {
            if (
              !this.dialogLitigant.some((item) => item.attribute == '上诉人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加上诉人！')
            }
            if (
              !this.dialogLitigant.some((item) => item.attribute == '被上诉人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加被上诉人！')
            }
            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                if (arrbt[i].attribute == '上诉人') {
                  this.$message.error('请完善上诉人信息！')
                  bitian = false

                  break
                } else if (arrbt[i].attribute == '被上诉人') {
                  this.$message.error('请完善被上诉人信息！')
                  bitian = false

                  break
                }
              }
            }
          } else if (this.form.ajstatus == '再审') {
            if (
              !this.dialogLitigant.some((item) => item.attribute == '申请人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加申请人！')
            }
            if (
              !this.dialogLitigant.some((item) => item.attribute == '被申请人')
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加被申请人！')
            }
            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                if (arrbt[i].attribute == '申请人') {
                  this.$message.error('请完善申请人信息！')
                  bitian = false

                  break
                } else if (arrbt[i].attribute == '被申请人') {
                  this.$message.error('请完善被申请人信息！')
                  bitian = false

                  break
                }
                // else if (arrbt[i].attribute == '第三人') {
                //   if (
                //     (arrbt[i].name == '' || arrbt[i].name == null) &&
                //     (arrbt[i].isClient === '' ||
                //       arrbt[i].isClient == null) &&
                //     (arrbt[i].isUnit === '' || arrbt[i].isUnit == null)
                //   ) {
                //   } else {
                //     this.$message.error(
                //       '请完善第三人信息或从列表中移除！'
                //     )
                //     bitian = false
                //     this.loading = false
                //     break
                //   }
                // }
              }
            }
          } else if (this.form.ajstatus == '行政复议') {
            if (
              !this.dialogLitigant.some(
                (item) => item.attribute == '复议申请人'
              )
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加复议申请人！')
            }
            if (
              !this.dialogLitigant.some(
                (item) => item.attribute == '复议被申请人'
              )
            ) {
              this.loading = false
              this.dianji = false
              return this.$message.error('请添加复议被申请人！')
            }

            for (let i = 0; i < arrbt.length; i++) {
              if (
                arrbt[i].name == '' ||
                arrbt[i].name == null ||
                arrbt[i].isClient === '' ||
                arrbt[i].isClient == null ||
                arrbt[i].isUnit === '' ||
                arrbt[i].isUnit == null
              ) {
                if (arrbt[i].attribute == '复议申请人') {
                  this.$message.error('请完善复议申请人信息！')
                  bitian = false

                  break
                } else if (arrbt[i].attribute == '复议被申请人') {
                  this.$message.error('请完善复议被申请人信息！')
                  bitian = false

                  break
                }
                // else if (arrbt[i].attribute == '第三人') {
                //   if (
                //     (arrbt[i].name == '' || arrbt[i].name == null) &&
                //     (arrbt[i].isClient === '' ||
                //       arrbt[i].isClient == null) &&
                //     (arrbt[i].isUnit === '' || arrbt[i].isUnit == null)
                //   ) {
                //   } else {
                //     this.$message.error(
                //       '请完善第三人信息或从列表中移除！'
                //     )
                //     bitian = false
                //     this.loading = false
                //     break
                //   }
                // }
              }
            }
          }
        } else if (this.numType == 4) {
          if (
            !this.dialogLitigant.some((item) => item.attribute == '申请执行人')
          ) {
            this.loading = false
            this.dianji = false
            return this.$message.error('请添加申请执行人！')
          }
          if (
            !this.dialogLitigant.some((item) => item.attribute == '被执行人')
          ) {
            this.loading = false
            this.dianji = false
            return this.$message.error('请添加被执行人！')
          }
          for (let i = 0; i < arrbt.length; i++) {
            if (
              arrbt[i].name == '' ||
              arrbt[i].name == null ||
              arrbt[i].isClient === '' ||
              arrbt[i].isClient == null ||
              arrbt[i].isUnit === '' ||
              arrbt[i].isUnit == null
            ) {
              if (arrbt[i].attribute == '申请执行人') {
                this.$message.error('请完善申请执行人信息！')
                bitian = false
                break
              } else if (arrbt[i].attribute == '被执行人') {
                this.$message.error('请完善被执行人信息！')
                bitian = false

                break
              }
              // else if (arrbt[i].attribute == '第三人') {
              //   if (
              //     (arrbt[i].name == '' || arrbt[i].name == null) &&
              //     (arrbt[i].isClient === '' ||
              //       arrbt[i].isClient == null) &&
              //     (arrbt[i].isUnit === '' || arrbt[i].isUnit == null)
              //   ) {
              //   } else {
              //     this.$message.error(
              //       '请完善第三人信息或从列表中移除！'
              //     )
              //     bitian = false
              //     this.loading = false
              //     break
              //   }
              // }
            }
          }
        } else if (this.numType == 5 || this.numType == 6) {
          if (!this.dialogLitigant.some((item) => item.attribute == '申请人')) {
            this.loading = false
            this.dianji = false
            return this.$message.error('请添加申请人！')
          }
          if (
            !this.dialogLitigant.some((item) => item.attribute == '被申请人')
          ) {
            this.loading = false
            this.dianji = false
            return this.$message.error('请添加被申请人！')
          }
          for (let i = 0; i < arrbt.length; i++) {
            if (
              arrbt[i].name == '' ||
              arrbt[i].name == null ||
              arrbt[i].isClient === '' ||
              arrbt[i].isClient == null ||
              arrbt[i].isUnit === '' ||
              arrbt[i].isUnit == null
            ) {
              if (arrbt[i].attribute == '申请人') {
                this.$message.error('请完善申请人信息！')
                bitian = false

                break
              } else if (arrbt[i].attribute == '被申请人') {
                this.$message.error('请完善被申请人信息！')
                bitian = false

                break
              }
              // else if (arrbt[i].attribute == '第三人') {
              //   if (
              //     (arrbt[i].name == '' || arrbt[i].name == null) &&
              //     (arrbt[i].isClient === '' ||
              //       arrbt[i].isClient == null) &&
              //     (arrbt[i].isUnit === '' || arrbt[i].isUnit == null)
              //   ) {
              //   } else {
              //     this.$message.error(
              //       '请完善第三人信息或从列表中移除！'
              //     )
              //     bitian = false
              //     this.loading = false
              //     break
              //   }
              // }
            }
          }
        }

        for (let i = 0; i < arrbt.length; i++) {
          if (
            arrbt[i].name == '' ||
            arrbt[i].name == null ||
            arrbt[i].isUnit === '' ||
            arrbt[i].isUnit === null
          ) {
            if (
              arrbt[i].attribute == '第三人' ||
              arrbt[i].attribute == '原审第三人' ||
              arrbt[i].attribute == '原审原告' ||
              arrbt[i].attribute == '原审被告' ||
              arrbt[i].attribute == '执行异议人' ||
              arrbt[i].attribute == '案外人'
            ) {
              if (
                (arrbt[i].name == '' || arrbt[i].name == null) &&
                (arrbt[i].isClient !== '' || arrbt[i].isClient !== null) &&
                (arrbt[i].isUnit === '' || arrbt[i].isUnit === null)
              ) {
                this.form.tableData.splice(i, 1)
              } else if (
                arrbt[i].name != '' ||
                arrbt[i].name != null ||
                arrbt[i].isUnit !== '' ||
                arrbt[i].isUnit !== null
              ) {
                if (
                  arrbt[i].name == '' ||
                  arrbt[i].name == null ||
                  arrbt[i].isUnit === '' ||
                  arrbt[i].isUnit === null
                ) {
                  bitian = false
                  this.$message.error('请完善' + arrbt[i].attribute + '信息！')
                  break
                }
              }
            }
          }
        }

        if (bitian == false) {
          this.loading = false
          this.dianji = false
          return
        }

        this.dialogLitigant = this.dialogLitigant.filter(
          (item) =>
            item.name != '' &&
            item.name != null &&
            item.isClient !== '' &&
            item.isClient !== null &&
            item.isUnit !== '' &&
            item.isUnit !== null
        )

        var att = ''

        this.dialogLitigant.forEach((value, index, array) => {
          if (value.isClient) {
            att = value.attribute
          }
        })
        await caseConflictApi({
          listLitigant_param: this.dialogLitigant,
          CaseId: this.form.id,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            // 弹出案件冲突
            this.loading = false
            this.dianji = false
            this.conflictList = res.data.data
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.loading = false
            this.dianji = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        await caseAdviserApi({
          listLitigant_param: this.dialogLitigant,
          CaseId: null,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            this.loading = false
            this.dianji = false
            this.lvShiConflict = res.data.data
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.loading = false
            this.dianji = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        await BanruptcykConflictApi({
          listLitigant_param: this.dialogLitigant,
          CaseId: null,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            this.loading = false
            this.dianji = false
            this.BanruptcykConflict = res.data.data
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.loading = false
            this.dianji = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        if (this.lvShiConflict.length > 0 || this.conflictList.length > 0||this.BanruptcykConflict.length>0) {
          this.caseConflict = true
        } else {
          await changeLitigant({
            caseid: this.form.id,
            listLitigant_param: this.dialogLitigant
          })
            .then((res) => {
              if (res.data.status == '0') {
                this.$message.success(res.data.message)
                this.loading = false
                this.dianji = false
                setTimeout(() => {
                  this.$router.go(-this.times)
                }, 100)
              } else if (
                res.data.status == '401' ||
                res.data.status == '402' ||
                res.data.status == '403'
              ) {
                this.loading = false
                this.dianji = false
                this.$message.error(res.data.message)
                window.sessionStorage.removeItem('token')
                window.sessionStorage.removeItem('hasRoles')
                this.$router.push('/login')
                return
              } else {
                this.loading = false
                this.dianji = false
                this.$message.error(res.data.message)
              }
            })
            .catch((err) => {
              this.loading = false
              this.dianji = false
              this.$message.error(err)
            })
          this.litigantClose()
        }
      } else if (this.numType == 9) {
        if (this.dialogLitigant.length == 0) {
          this.loading = false
          this.dianji = false
          return this.$message.error('请录入案件当事人!')
        }

        var clientBool = false
        arrbt.forEach((v) => {
          if (v.isClient == true) {
            clientBool = true
            return
          }
        })
        if (!clientBool) {
          this.loading = false
          this.dianji = false
          return this.$message.error('请选择代理方！')
        }
        if (!this.dialogLitigant.some((item) => item.attribute == '客户名称')) {
          this.loading = false
          this.dianji = false
          return this.$message.error('请添加客户名称！')
        }
        if (
          !this.dialogLitigant.some((item) => item.attribute == '对方当事人')
        ) {
          this.loading = false
          this.dianji = false
          return this.$message.error('请添加对方当事人！')
        }
         for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null
                      ) {
                        if (arrbt[i].Attribute == '客户名称') {
                          bitian = false
                          this.$message.error('请完善客户信息！')
                          return
                        } else if (arrbt[i].Attribute == '对方当事人') {
                          bitian = false
                          this.$message.error('请完善对方当事人信息！')
                          return
                        }
                      }
                    }
        this.dialogLitigant = this.dialogLitigant.filter(
          (item) =>
            item.name != '' &&
            item.name != null &&
            item.isClient !== '' &&
            item.isClient !== null &&
            item.isUnit !== '' &&
            item.isUnit !== null
        )

        var att = ''

        this.dialogLitigant.forEach((value, index, array) => {
          if (value.isClient) {
            att = value.attribute
          }
        })
        await caseConflictApi({
          listLitigant_param: this.dialogLitigant,
          CaseId: this.form.id,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            // 弹出案件冲突
            this.loading = false
            this.dianji = false
            this.conflictList = res.data.data
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.loading = false
            this.dianji = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        await caseAdviserApi({
          listLitigant_param: this.dialogLitigant,
          CaseId: null,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            this.loading = false
            this.dianji = false
            this.lvShiConflict = res.data.data
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.loading = false
            this.dianji = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        await BanruptcykConflictApi({
          listLitigant_param: this.dialogLitigant,
          CaseId: null,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            this.loading = false
            this.dianji = false
            this.BanruptcykConflict = res.data.data
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.loading = false
            this.dianji = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })

        if (this.lvShiConflict.length > 0 || this.conflictList.length > 0||this.BanruptcykConflict.length>0) {
          this.caseConflict = true
        } else {
          await changeLitigant({
            caseid: this.form.id,
            listLitigant_param: this.dialogLitigant
          })
            .then((res) => {
              if (res.data.status == '0') {
                this.loading = false
                this.dianji = false

                this.$message.success(res.data.message)
                setTimeout(() => {
                  this.$router.go(-this.times)
                }, 100)
              } else if (
                res.data.status == '401' ||
                res.data.status == '402' ||
                res.data.status == '403'
              ) {
                this.loading = false
                this.dianji = false
                this.$message.error(res.data.message)
                window.sessionStorage.removeItem('token')
                window.sessionStorage.removeItem('hasRoles')
                this.$router.push('/login')
                return
              } else {
                this.loading = false
                this.dianji = false
                this.$message.error(res.data.message)
              }
            })
            .catch((err) => {
              this.loading = false
              this.dianji = false
              this.$message.error(err)
            })
          this.litigantClose()
        }
      }
    },
    litigantClose() {
      this.litigantDialog = false
      this.dialogLitigant = []
    },
    changeLitigantclick() {
      // this.dialogLitigant = [...this.form.tableData]
      // this.form.tableData.forEach((v) => {
      //   this.dialogLitigant.push(v)
      // })
      this.dialogLitigant = JSON.parse(JSON.stringify(this.form.tableData))
      this.litigantDialog = true
    },
    async getLitigants() {
      var newAtt = []
      if(this.form.tableData.length>0&&this.$route.query.status){
        this.form.tableData.forEach((v) => {
          newAtt.push(v.attribute)
        })
        newAtt = [...new Set(newAtt)]
        await getLitigant({
          casetype: this.$route.query.status,
          attribute: newAtt
        })
          .then((res) => {
            this.allrestaurants = res.data.data
          })
          .catch((err) => {
            console.log('错误', err)
          })
        }
    },
    handleSelect(item, row, dlog) {
      // console.log('dlog', dlog)
      row.attribute = item.att
      row.isClient = item.client
      row.isUnit = item.unit
      row.name = item.value
      if (dlog == 'dialog') {
        this.clientChangeDialog(row)
      } else {
        this.clientChange(row)
      }
    },
    querySearch(queryString, cb, row) {
      const attCount = this.allrestaurants.length

      if (attCount > 0) {
        this.restaurants = []
        for (let i = 0; i < attCount; i++) {
          if (this.allrestaurants[i][0] != undefined) {
            if (this.allrestaurants[i][0].key.att == row.attribute) {
              this.allrestaurants[i].forEach((v) => {
                this.restaurants.push(v.key)
              })
            }
          }
        }
      }
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handle(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    sfbt(a) {
      if (
        a == '原告' ||
        a == '被告' ||
        a == '上诉人' ||
        a == '被上诉人' ||
        a == '申请人' ||
        a == '被申请人' ||
        a == '债务人' ||
        a == '被告人' ||
        a == '犯罪嫌疑人' ||
        a == '自诉人' ||
        a == '公诉机关' ||
        a == '复议申请人' ||
        a == '复议被申请人' ||
        a == '申请执行人' ||
        a == '被执行人' ||
        a == '客户名称' ||
        a == '对方当事人'
      ) {
        return '是'
      } else {
        return '否'
      }
    },
    // 代理改变事件
    clientChange(row) {
      // 民事
      if (this.numType == 1) {
        if (this.form.ajstatus == '一审') {
          if (row.attribute == '原告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '原告') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审') {
          if (row.attribute == '上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被上诉人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '上诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审'||this.form.ajstatus=='申请撤销裁决') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审听证'||this.form.ajstatus == '强制清算') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '破产申报') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '债务人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '债务人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        }else if (this.form.ajstatus == '破产申请') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '执行') {
          if (row.attribute == '申请执行人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被执行人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被执行人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请执行人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '审判监督(再审)') {
          if (row.attribute == '再审申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '再审被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '再审被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '再审申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '公示催告') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '支付人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '支付人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '督促') {
          if (row.attribute == '债权人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '债务人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '债务人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '债权人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '选民资格案件(特别)') {
          if (row.attribute == '起诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '选举委员会') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '选举委员会') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '起诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '认定财产无主案件(特别)') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '原财产所有人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '原财产所有人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (
          this.form.ajstatus == '制定遗产管理人案件(特别)' ||
          this.form.ajstatus == '确认调解协议案件(特别)' ||
          this.form.ajstatus == '实现担保物权案件(特别)' ||
          this.form.ajstatus == '宣告失踪、宣告死亡案件(特别)' ||
          this.form.ajstatus == '认定公民无民事行为能力、限制行为能力案件(特别)'
        ) {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        }
      }
      // 刑事
      else if (this.numType == 2) {
        if (
          this.form.ajstatus == '侦查' ||
          this.form.ajstatus == '审查起诉'
        ) {
          if (row.attribute == '犯罪嫌疑人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被害人') {
                  v.isClient = false
                }
              })
            }
          } else  if (row.attribute == '被害人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '犯罪嫌疑人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '公诉机关') {
            if (row.isClient) {
              row.isClient = false
              this.$message.error('不能代理' + row.attribute)
            }
          }
        } else if (this.form.ajstatus == '法院审理(一审)') {
          if (row.attribute == '被告人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被害人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被害人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告人') {
                  v.isClient = false
                }
              })
            }
          }else if (row.attribute == '公诉机关') {
            if (row.isClient) {
              row.isClient = false
              this.$message.error('不能代理' + row.attribute)
            }
          }
        } else if (this.form.ajstatus == '被告人上诉(二审)') {
          if (row.attribute == '上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被害人') {
                  v.isClient = false
                }
              })
            }
          } if (row.attribute == '被害人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '上诉人') {
                  v.isClient = false
                }
              })
            }
          }else if (row.attribute == '检察机关') {
            if (row.isClient) {
              row.isClient = false
              this.$message.error('不能代理检察机关')
            }
          }
        } else if (this.form.ajstatus == '检察机关抗诉(二审)') {
          if (row.attribute == '抗诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                // if (v.attribute == '被抗诉人') {
                //   v.isClient = false
                // }
                if (v.attribute == '原审被告人') {
                  v.isClient = false
                }
              })
            }
          }
          else if (row.attribute == '原审被告人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '抗诉人') {
                  v.isClient = false
                }
              })
            }
          }
          //  else if (row.attribute == '被抗诉人') {
          //   if (row.isClient) {
          //     this.form.tableData.forEach((v) => {
          //       if (v.attribute == '抗诉人') {
          //         v.isClient = false
          //       }
          //     })
          //   }
          // }
        } else if (this.form.ajstatus == '再审') {
          if (row.attribute == '再审申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '再审被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '再审被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '再审申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '自诉案件') {
          if (row.attribute == '自诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被告人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '自诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '刑事附带民事诉讼') {
          if (row.attribute == '刑事附带民事诉讼原告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '刑事附带民事诉讼被告') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '刑事附带民事诉讼被告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '刑事附带民事诉讼原告') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '涉及单位犯罪') {
          if (row.attribute == '被告人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '控诉人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '控诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (
          this.form.ajstatus ==
            '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序' ||
          this.form.ajstatus == '依法不负刑事责任的精神病人的强制医疗程序'
        ) {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        }
      }
      // 行政
      else if (this.numType == 3) {
        if (this.form.ajstatus == '一审') {
          if (row.attribute == '原告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审') {
          if (row.attribute == '上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被上诉人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '上诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政裁决') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政复议') {
          if (row.attribute == '复议申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '复议被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '复议被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '复议申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '一审(行政诉讼)') {
          if (row.attribute == '原告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '原告') {
                  v.isClient = false
                }
              })
            }
          }else if (row.attribute == '请求人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '权利人') {
                  v.isClient = false
                }
              })
            }
          }else if (row.attribute == '权利人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '请求人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审(行政诉讼)') {
          if (row.attribute == '上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被上诉人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '上诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '申请再审(行政诉讼)') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '执行阶段(行政诉讼)') {
          if (row.attribute == '申请执行人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请执行人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请执行人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请执行人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政处罚') {
          if (row.attribute == '当事人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '行政主体') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '行政主体') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '当事人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政许可') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被许可人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被许可人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政强制') {
          if (row.attribute == '当事人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '行政主体') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '行政主体') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '当事人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '政府信息公开') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请机关') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请机关') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        }
      }
      // 执行
      else if (this.numType == 4) {
        if (row.attribute == '申请执行人') {
          if (row.isClient) {
            this.form.tableData.forEach((v) => {
              if (v.attribute == '被执行人') {
                v.isClient = false
              }
            })
          }
        } else if (row.attribute == '被执行人') {
          if (row.isClient) {
            this.form.tableData.forEach((v) => {
              if (v.attribute == '申请执行人') {
                v.isClient = false
              }
            })
          }
        }
      }
      // 仲裁
      else if (this.numType == 5 || this.numType == 6) {
        if (row.attribute == '申请人') {
          if (row.isClient) {
            this.form.tableData.forEach((v) => {
              if (v.attribute == '被申请人') {
                v.isClient = false
              }
            })
          }
        } else if (row.attribute == '被申请人') {
          if (row.isClient) {
            this.form.tableData.forEach((v) => {
              if (v.attribute == '申请人') {
                v.isClient = false
              }
            })
          }
        }
      }
    },
    // 代理改变事件
    clientChangeDialog(row) {
      // 民事
      if (this.numType == 1) {
        if (this.form.ajstatus == '一审') {
          if (row.attribute == '原告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '原告') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审') {
          if (row.attribute == '上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被上诉人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '上诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审听证'||this.form.ajstatus == '强制清算') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '破产申报') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '债务人'||v.attribute=='债权人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '债务人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人'||v.attribute=='债权人') {
                  v.isClient = false
                }
              })
            }
          }else if (row.attribute == '债权人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人'||v.attribute=='债务人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '执行') {
          if (row.attribute == '申请执行人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被执行人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被执行人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请执行人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '审判监督(再审)') {
          if (row.attribute == '再审申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '再审被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '再审被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '再审申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '公示催告') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '支付人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '支付人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '督促') {
          if (row.attribute == '债权人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '债务人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '债务人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '债权人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '选民资格案件(特别)') {
          if (row.attribute == '起诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '选举委员会') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '选举委员会') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '起诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '认定财产无主案件(特别)') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '原财产所有人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '原财产所有人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (
          this.form.ajstatus == '制定遗产管理人案件(特别)' ||
          this.form.ajstatus == '确认调解协议案件(特别)' ||
          this.form.ajstatus == '实现担保物权案件(特别)' ||
          this.form.ajstatus == '宣告失踪、宣告死亡案件(特别)' ||
          this.form.ajstatus == '认定公民无民事行为能力、限制行为能力案件(特别)'
        ) {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        }
      }
      // 刑事
      else if (this.numType == 2) {
        if (
          this.form.ajstatus == '侦查' ||
          this.form.ajstatus == '审查起诉'
        ) {
          if (row.attribute == '犯罪嫌疑人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被害人') {
                  v.isClient = false
                }
              })
            }
          }if (row.attribute == '被害人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '犯罪嫌疑人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '公诉机关') {
            if (row.isClient) {
              row.isClient = false
              this.$message.error('不能代理' + row.attribute)
            }
          }
        } else if (this.form.ajstatus == '法院审理(一审)') {
          if (row.attribute == '被告人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被害人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被害人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告人') {
                  v.isClient = false
                }
              })
            }
          }else if (row.attribute == '公诉机关') {
            if (row.isClient) {
              row.isClient = false
              this.$message.error('不能代理' + row.attribute)
            }
          }
        } else if (this.form.ajstatus == '被告人上诉(二审)') {
          if (row.attribute == '上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '检察机关') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '检察机关') {
            if (row.isClient) {
              row.isClient = false
              this.$message.error('不能代理检察机关')
            }
          }
        } else if (this.form.ajstatus == '检察机关抗诉(二审)') {
          if (row.attribute == '抗诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '原审被告人') {
                  v.isClient = false
                }
                // if (v.attribute == '被抗诉人') {
                //   v.isClient = false
                // }
              })
            }
          } 
          else if (row.attribute == '原审被告人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '抗诉人') {
                  v.isClient = false
                }
              })
            }
          }
          // else if (row.attribute == '被抗诉人') {
          //   if (row.isClient) {
          //     this.form.tableData.forEach((v) => {
          //       if (v.attribute == '抗诉人') {
          //         v.isClient = false
          //       }
          //     })
          //   }
          // }
        } else if (this.form.ajstatus == '再审') {
          if (row.attribute == '再审申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '再审被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '再审被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '再审申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '自诉案件') {
          if (row.attribute == '自诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被告人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '自诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '刑事附带民事诉讼') {
          if (row.attribute == '刑事附带民事诉讼原告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '刑事附带民事诉讼被告') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '刑事附带民事诉讼被告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '刑事附带民事诉讼原告') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '涉及单位犯罪') {
          if (row.attribute == '被告人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '控诉人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '控诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (
          this.form.ajstatus ==
            '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序' ||
          this.form.ajstatus == '依法不负刑事责任的精神病人的强制医疗程序'
        ) {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        }
      }
      // 行政
      else if (this.numType == 3) {
        if (this.form.ajstatus == '一审') {
          if (row.attribute == '原告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审') {
          if (row.attribute == '上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被上诉人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '上诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政裁决') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '复议被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '复议申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政复议') {
          if (row.attribute == '复议申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '复议被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '复议被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '复议申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '一审(行政诉讼)') {
          if (row.attribute == '原告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被告') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被告') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '原告') {
                  v.isClient = false
                }
              })
            }
          }else if (row.attribute == '请求人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '权利人') {
                  v.isClient = false
                }
              })
            }
          }else if (row.attribute == '权利人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '请求人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审(行政诉讼)') {
          if (row.attribute == '上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被上诉人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被上诉人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '上诉人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '申请再审(行政诉讼)') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '执行阶段(行政诉讼)') {
          if (row.attribute == '申请执行人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请执行人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请执行人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请执行人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政处罚') {
          if (row.attribute == '当事人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '行政主体') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '行政主体') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '当事人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政许可') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被许可人') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被许可人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政强制') {
          if (row.attribute == '当事人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '行政主体') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '行政主体') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '当事人') {
                  v.isClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '政府信息公开') {
          if (row.attribute == '申请人') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '被申请机关') {
                  v.isClient = false
                }
              })
            }
          } else if (row.attribute == '被申请机关') {
            if (row.isClient) {
              this.form.tableData.forEach((v) => {
                if (v.attribute == '申请人') {
                  v.isClient = false
                }
              })
            }
          }
        }
      }
      // 执行
      else if (this.numType == 4) {
        if (row.attribute == '申请执行人') {
          if (row.isClient) {
            this.form.tableData.forEach((v) => {
              if (v.attribute == '被执行人') {
                v.isClient = false
              }
            })
          }
        } else if (row.attribute == '被执行人') {
          if (row.isClient) {
            this.form.tableData.forEach((v) => {
              if (v.attribute == '申请执行人') {
                v.isClient = false
              }
            })
          }
        }
      }
      // 仲裁
      else if (this.numType == 5 || this.numType == 6) {
        if (row.attribute == '申请人') {
          if (row.isClient) {
            this.form.tableData.forEach((v) => {
              if (v.attribute == '被申请人') {
                v.isClient = false
              }
            })
          }
        } else if (row.attribute == '被申请人') {
          if (row.isClient) {
            this.form.tableData.forEach((v) => {
              if (v.attribute == '申请人') {
                v.isClient = false
              }
            })
          }
        }
      }
    },
    handleCheckedCitiesChange() {
      console.log(this.checkedCities)
    },

    changeWidth(e) {
      this.width1 = this.value.length * 15
    },

    // 部门主管改变
    bmzgChange() {
      this.$forceUpdate();
    },

    Successlog() {
      CaseApprover({ CaseId: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.processlogs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    addRedStar(h, { column }) {
      // 给表头加必选标识
      return [
        h('span', { style: 'color: red' }, '*'),
        h('span', ' ' + column.label)
      ]
    },
    Price(rule, value, callback) {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value < 0) {
        callback(new Error('请输入大于等于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    },
    guidang() {
      //归档
      if (this.form.code == '' || this.form.code == null) {
        this.$message.error('案件编号为空,无法归档')
        return
      } else {
        this.archiveDialog = true
        this.dialogarchive.acceptCode = this.form.acceptcode
      }
    },
    closecase() {
      //结案
      if (this.NewFile.length > 0) {
        this.$message.error('请先保存附件')
      } else {
        this.closeCaseDialog = true
      }
    },
    AddInvoiceFile(form) {
      //结案
      this.dialogclose.invoiceFile = this.FileList4.filter(
        (v) => !v.isShow
      ).map((v) => {
        return v.uid
      })
      this.$refs[form].validate((success) => {
        if (success) {
          this.loading = true
          this.dianji = true
          ClosingCase({
            Id: this.form.id,
            FileListId: this.dialogclose.invoiceFile
          }).then((res) => {
            this.loading = false
            this.dianji = false
            if (res.data.status == '0') {
              this.$message.success(res.data.message)
              this.form.status = 2
              this.closeCaseDialog = false
              this.FileList3 = this.FileList4
              this.NewFile = []
            } else {
              this.$message.error(res.data.message)
            }
          })
          this.GetCaseLog()
        }
      })
    },
    AddArchive(form) {
      //归档

      this.$refs[form].validate((success) => {
        if (success) {
          this.loading = true
          this.dianji = true
          Archive({
            Id: this.form.id,
            Quantity: this.dialogarchive.quantity,
            AcceptCode: this.dialogarchive.acceptCode,
            Cause: false
          }).then((res) => {
            this.loading = false
            this.dianji = false
            if (res.data.status == '0') {
              this.$message.success(res.data.message)
              this.form.status = 3
              this.archiveDialog = false
            } else {
              this.$message.error(res.data.message)
            }
          })
          this.GetCaseLog()
        }
      })
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      console.log('预览')
      this.loading = true
      this.dianji = true
      let fileType = item.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          //Image PDF
          YuLan({ Id: item.uid }).then((res) => {
            if (res.data.type.includes('application/json') && res.data.type) {
              this.handlerResponseError(res.data)
            } else {
              this.isWord = false
              this.isExcel = false
              this.isImage = true
              this.dialogVisible = true
              // console.log('yulan123', res.data) //res.data为Blob {size: 0, type: 'text/xml'}这种形式
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          var vm = this
          //WORD

          requestReview({ Id: item.uid })
            .then((res) => {
              // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览
              if (
                res.headers['content-type'] &&
                res.headers['content-type'].includes('application/json')
              ) {
                this.handlerError(res.data)
              } else {
                this.dialogVisible = true
                this.isWord = true
                this.isExcel = false
                this.isImage = false
                mammoth
                  .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                  .then(function (resultObject) {
                    vm.$nextTick(() => {
                      // document.querySelector("#wordView").innerHTML =
                      //   resultObject.value;
                      vm.vHtml = resultObject.value
                    })
                  })
              }
            })
            .catch((err) => {
              console.log('错误：' + err)
            })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          //EXCEL
          requestReview({ Id: item.uid })
            .then((res) => {
              if (
                res.headers['content-type'] &&
                res.headers['content-type'].includes('application/json')
              ) {
                this.handlerError(res.data)
              } else {
                this.dialogVisible = true
                this.isExcel = true
                this.isWord = false
                this.isImage = false
                const workbook = XLSX.read(new Uint8Array(res.data), {
                  type: 'array'
                }) // 解析数据
                var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
                // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
                const sheet2JSONOpts = {
                  /** Default value for null/undefined values */
                  defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
                }
                // 渲染成json
                this.excelData = XLSX.utils.sheet_to_json(
                  worksheet,
                  sheet2JSONOpts
                )
              }
            })
            .catch((err) => {
              console.log('错误：' + err)
            })
        } else {
          this.$message.error('不支持此文件预览')
        }
        // console.log('if结束')
        this.loading = false
        this.dianji = false
      } else {
        this.loading = false
        this.dianji = false
        this.$message.error('不支持此文件预览')
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          } // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      fileReader.readAsText(data)
    },
    async down(item) {
      // console.log('down', item.uid)
      this.loading = true
      this.dianji = true
      //下载
      const res = await requestDownLoadFile({
        Id: item.uid
      })
      // console.log(res)
      if (res.status == '201') {
        this.$message.error('找不到文件')
        this.loading = false
        this.dianji = false
        return
      }
      this.loading = false
      this.dianji = false
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
      }
    },
    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = null
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name + '.' + fileType)
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {}
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {}
      }
      return url
    },
    del(index, type, item) {
      if (type == 1) {
        this.FileList1.splice(index, 1)
      } else if (type == 2) {
        this.FileList2.splice(index, 1)
      } else if (type == 3) {
        this.FileList3.splice(index, 1)
      } else if (type == 4) {
        this.FileList4.splice(index, 1)
      } else if (type == 5) {
        this.FileList5.splice(index, 1)
      }else if (type == 7) {
        this.FileList7.splice(index, 1)
      }
      this.FileList = []
      this.sealForm.sealFile = []
      if (type != 5) {
        this.NewFile.splice(this.NewFile.indexOf(item.uid), 1) //FlieList6没有用的NewFile
      }
    },
    handleRemove(file, type) {
      //删除附件
      if (type == 1) {
        this.FileList1.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 4) {
        this.FileList4.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 5) {
        this.FileList5.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      }else if (type == 7) {
        this.FileList7.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      }
    },
    onProgress(event, file, type) {
      var num = ((event.loaded / event.total) * 100) | 0 //百分比
      if (type == 1) {
        this.FileList1.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 4) {
        this.FileList4.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 5) {
        this.FileList5.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      }else if (type == 7) {
        this.FileList7.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      }
    },
    onChange(file, type) {
      if (file.status == 'fail') {
        if (type == 1) {
          this.FileList1.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 4) {
          this.FileList4.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 5) {
          this.FileList5.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }else if (type == 7) {
          this.FileList7.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }
        return this.$message.error(file.name + '上传失败')
      }
    },
    beforeUpload(file, type) {
      var fileType = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      // console.log('名字:', file.name.split('.')[0])
      //上传验证
      if (type == 1) {
        this.FileList1.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 2) {
        this.FileList2.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }
      // else if (type == 3) {
      //   this.FileList3.push({
      //     uid: file.uid,
      //     name: file.name.split('.')[0],
      //     ftype: fileType,
      //     isShow: true,
      //     curPercentage: 0
      //   }) //添加上传的文件
      // }
      // else if (type == 4) {
      //   this.FileList4.push({
      //     uid: file.uid,
      //     name: file.name.split('.')[0],
      //     ftype: fileType,
      //     isShow: true,
      //     curPercentage: 0
      //   }) //添加上传的文件
      // }
      else if (type == 5) {
        this.FileList5.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } 
      else if (type == 7) {
        this.FileList7.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }
      this.uploadname = file.name
      var type = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isImg =
        '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.doc,.DOC,.docx,.DOCX,.xls,.XLS,.xlsx,.XLSX,.pdf,.PDF,.wps,.WPS'.indexOf(
          type
        ) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf,wps格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    beforeUploadfp(file, type) {
      var fileType = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      //上传验证
      if (type == 4) {
        this.FileList4.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else {
        this.FileList3.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }

      this.uploadname = file.name
      var type = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isImg =
        '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.doc,.DOC,.pdf,.PDF'.indexOf(type) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error('只能上传.jpg,.jpeg,.png,.pdff格式的文件')
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList, type) {
      // 招标文件上传成功
      // var fileid = this.FileList1.map((item) =>
      //   Object.assign({}, { id: item.id })
      // )

      if (res.status == '0') {
        if (type != 4) {
          this.NewFile.push(
            file.response.data.substring(
              file.response.data.lastIndexOf('=') + 1
            )
          )
        }
        if (type == 3 || type == 4) {
          var id = file.response.data.substring(
            file.response.data.lastIndexOf('=') + 1
          )
          axios
            .get('https://glxt.ntlawyer.cc/api/fromfile/getbyid?id=' + id)
            .then((res) => {
              if (res.data.status == '200') {
                // 处理响应数据
                const textArray = res.data.data.map((item) => item.text || '')
                let mergedString = '' // 默认将mergedString设置为空字符串
                if (textArray.length > 0) {
                  mergedString = textArray.join(',') // 将text属性合并成一个字符串，每个text之间用逗号分隔
                }
                if (
                  !mergedString.includes('发票') &&
                  !mergedString.includes('纳税人识别号')
                ) {
                  this.$message.error('您上传的可能不是发票')
                }
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch((error) => {
              // 处理错误
              console.log(error)
            })
            .finally(() => {
              if (type == 3) {
                console.log(type)
                this.FileList3.forEach((value) => {
                  //uid要改成guid,isshow变成false
                  if (value.uid == file.uid) {
                    value.isShow = false
                    value.uid = id
                  }
                })
              } else {
                this.FileList4.forEach((value) => {
                  if (value.uid == file.uid) {
                    value.isShow = false
                    value.uid = id
                  }
                })
              }
            })
        }

        if (type == 1) {
          this.FileList1.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 5) {
          this.FileList5.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        }else if (type == 7) {
          this.FileList7.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        }
        this.FileList = this.FileList1.concat(this.FileList2)
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      } else {
        //删除附件
        if (type == 1) {
          this.FileList1.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 4) {
          this.FileList4.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }else if (type == 7) {
          this.FileList7.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }
        this.$message.error('上传失败！')
      }
    },

    // 用章申请弹窗确认
    addEnter() {
      this.loading = true
      this.dianji = true
      // if (this.FileList.length == 0) {
      //   this.loading = false
      //   this.dianji = false
      //   return this.$message.error('请选择合同用章附件！')
      // }
      if (
        this.numType != 7 &&
        this.numType != 8 &&
        this.numType != 14 &&
        this.numType != 9 &&
        this.numType != 11 &&
        this.numType != 15 &&
        this.form.ajstatus == '无'
      ) {
        this.loading = false
        this.dianji = false
        return this.$message.error(
          '当前案件类型不允许案卷状态为‘无’！请重新选择'
        )
      }
      // 筛选选中的打印材料
      var newCities = []
      var st = []
      // console.log(this.checkedCities,this.cities)
      this.checkedCities.forEach((cv) => {
        this.cities.forEach((cvc) => {
          if (cv == cvc.name) {
            newCities.push(cvc)
            if (cvc.stype != null && cvc.stype != '') {
              st.push(cvc.stype)
            }
          }
        })
      })
      var nst = st
        .flat()
        .filter(Boolean)
        .filter((value, index, self) => self.indexOf(value) === index && value)
        .join(',')
        
      if (this.form.bs_Result == 1&&this.form.result==0) {
        this.YongZhang = false
      } else {
        this.YongZhang = true
      }
      this.sealForm.sealFile = this.FileList.map((v) => {
        return v.uid
      })
      this.ProcessType.push(this.sealForm.sealType)
      this.loading = true
      this.dianji = true
      if (
        this.numType == 7 ||
        this.numType == 8 ||
        this.numType == 14 ||
        // this.numType == 11 ||
        this.numType == 15
      ) {
        this.form.tableData = null
        var khmc=null
        var idnumber=null
        // if(this.numType==11){
        //   khmc = this.form.bcz.procureunit
        //   idnumber = this.form.bcz.idnumber
        // }
      }
       var tableData=this.form.tableData == [] ? null : this.form.tableData
       if(this.numType==11){
        tableData=this.form.bcz.tableData
       }
      if (this.YongZhang) {
        caseUpdateApi({
          // 案件信息
          Id: this.form.id,
          CaseStatus: this.form.casestatus,
          Aid: this.form.assist == null || '' ? false : this.form.assist,
          Title: this.form.title,
          Code: this.form.code,
          TypeId: this.form.typeId,
          Name: this.form.ajstatus,
          EntrustmentTime: this.form.approvaldate,
          Source: this.form.source,
          AcceptUnit: this.form.acceptUnit,
          Cause: this.form.cause,
          LeadLawyer: this.form.leadLawyer,
          Remark: this.form.remark,
          LinkId: this.form.linkId == [] ? null : this.form.linkId[0],
          CoCounsel:
            (this.form.coCounsel == null || this.form.coCounsel=='') ? [] : this.form.coCounsel,
          ApproveId: this.form.level == [] ? null : this.form.level,
          MemberId: (this.form.criminalrisk==null||this.form.criminalrisk=='')?null:this.form.criminalrisk,
          AcceptCode: this.form.acceptcode,
          CaseLeaders: this.form.caseLeaderscase,
          SealLeaders: this.sealForm.sealLeaders,
          //收费信息
          ChargingMethod: this.form.chargingMethod,
          AmountOfSubject:
            this.form.amountOfSubject == '' || null
              ? 0
              : this.form.amountOfSubject,
          SubjectMatter: this.form.subjectMatter,
          Fixed: this.form.fixed == null || this.form.fixed=='' ? 0 : this.form.fixed,
          RiskFixed:
            this.form.riskFixed == null ||this.form.riskFixed== '' ? 0 : this.form.riskFixed,
          RiskRatio:
            this.form.riskRatio == null || this.form.riskRatio=='' ? 0 : this.form.riskRatio,
          BCB_Remark: this.form.bcb_Remark,
          Introduction: this.form.introduction,
          FixedTimes: this.form.bcbdTable.length,
          //收费信息明细
          // listBillingDetail_param:
          //   this.form.bcbdTable == [] ? null : this.form.bcbdTable,
          listBillingDetail_param: null,
          // 案件当事人

          listLitigant_param:
            tableData,

          //所有附件
          biddingSchemes: this.form.biddingSchemes, //合同上传
          ordinaryFiles: this.form.ordinaryFiles, //普通附件
          chujuFiles:this.form.chujuFiles,//拟出具文件
          freeFiles: this.form.freeFiles, //免费凭证
          //其他东西
          ExtInfo: JSON.stringify(this.form.bcz),
          //用章申请
          // SealType: this.sealForm.seal,
          SealType: nst,
          newSealTypes: JSON.stringify(newCities),
          Reason: this.sealForm.reason,
          ApplicantId: this.sealForm.applicant,
          File: this.sealForm.sealFile,
          BS_ApproveId: this.sealForm.leadLawyer2, //二次
          YongZhang: this.YongZhang,
          LP_ProcessType: this.ProcessType,
          ConflictApproval:this.formConflict.conflictApproval==''?null:this.formConflict.conflictApproval,
          khmc:khmc,
          idnumber:idnumber,
        })
          .then((res) => {
            if (res.data.status == '0') {
              // 清空表单
              this.$message.success('编辑成功!')

              this.GetProcess()
              this.loading = false
              this.dianji = false
              setTimeout(() => {
                this.$router.go(-this.times)
              }, 100)
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              // 清空表单
              this.$message.error('编辑失败!')
              setTimeout(() => {
                this.$router.go(-this.times)
              }, 100)
            }
            this.loading = false
            this.dianji = false
          })
          .catch(() => {
            this.$message.error('录入失败！后台错误！')
            setTimeout(() => {
              this.$router.go(-this.times)
            }, 100)
            this.loading = false
            this.dianji = false
          })
      } else {
        caseSealApi({
          // 案件ID
          CaseId: this.form.id,
          //用章申请
          // SealType: this.sealForm.seal,
          SealType: nst,
          newSealTypes: JSON.stringify(newCities),
          Reason: this.sealForm.reason,
          ApplicantId: this.sealForm.applicant,
          Filelist: this.sealForm.sealFile,
          Approver: this.sealForm.leadLawyer2,
          SealLeaders: this.sealForm.sealLeaders
        }).then((res) => {
          if ((res.data.status = 'success')) {
            this.$message.success('用章申请已重新发起审核!')
            this.form.sid = res.data.data.sealId
            this.GetProcess()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error('用章申请发起审核失败!')
          }
        })
        setTimeout(() => {
          this.$router.go(-this.times)
        }, 100)
      }
      this.loading = false
      this.dianji = false
    },

    // 用章申请（案件通过但用章不通过）
    sealApply() {
      this.sealForm.applicant = null
      this.sealForm.leadLawyer2 = null
      this.sealForm.sealFile = []
      this.sealForm.sealLeaders = null
      // console.log(this.FileList1)
      // console.log(this.FileList2)
      this.FileList = this.FileList1.concat(this.FileList2)
      this.sealForm.reason = '申请立项'
    },

    // 附件更新
    fileUpdate() {
      if (this.NewFile.length > 0) {
        this.$confirm('文件上传后将无法删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.loading = true
            this.dianji = true
            // 更新附件接口
            fileUpdateApi({
              CaseId: this.form.id,
              FileId: this.NewFile
            }).then((res) => {
              this.loading = false
              this.dianji = false
              if (res.data.status == 'success') {
                this.$message.success('附件更新成功')
                this.GetCaseLog()
                this.NewFile = []
              } else if (
                res.data.status == '401' ||
                res.data.status == '402' ||
                res.data.status == '403'
              ) {
                this.$message.error(res.data.message)
                window.sessionStorage.removeItem('token')
                window.sessionStorage.removeItem('hasRoles')
                this.$router.push('/login')
              } else {
                this.$message.error('附件更新失败')
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消提交'
            })
          })
      } else {
        this.$message.error('请上传新的附件')
      }
    },

    // 返回
    history() {
      var _this = this
      _this.$router.go(-_this.times)
      // console.log(_this.$store.state.inputstatus)
      // _this.$router.back()
      setTimeout(() => {
        var r = _this.$route
        if (
          _this.$route.path == '/home/case/myCase' ||
          _this.$route.path == '/home/case/allCase' ||
          _this.$route.path == '/home/case/filedCase' ||
          _this.$route.path == '/home/case/casetext'
        ) {
          _this.$store.commit('setinputstatus', 0)
        } else {
          _this.$store.commit('setinputstatus', 1)
          if (r.path == '/home/case/caseinfo') {
            // _this.$router.go(0)
            window.location.reload()
          }
        }
      }, 1000)
    },

    // 案件提交
    editCase(formref) {
      this.loading = true
      this.dianji = true
      var labelArr = []
      var allLawyer = this.form.leadLawyer.concat(this.form.coCounsel)
      allLawyer.forEach((item) => {
        this.Lawyer.forEach((value) => {
          if (item == value.id && value.practice) {
            labelArr.push(item.practice)
          }
        })
      })
      if (labelArr.length == allLawyer.length&&labelArr.length>0) {
        this.$message.error('实习律师不能单独录案件')
        this.loading = false
        this.dianji = false
        return
      }
      this.form.reason = '申请立项'
      this.form.biddingSchemes = this.FileList1.map((v) => {
        return v.uid
      })
      this.form.ordinaryFiles = this.FileList2.map((v) => {
        return v.uid
      })
      this.form.chujuFiles = this.FileList7.map((v) => {
        return v.uid
      })
      this.form.freeFiles = this.FileList5.map((v) => {
        return v.uid
      })
      this.sealForm.sealFile = this.FileList.map((v) => {
        return v.uid
      })
      if(this.form.caseLeaderscase==''||this.form.caseLeaderscase==null){
        this.$message.error('部门主管不能为空')
        this.loading = false
        this.dianji = false
        return
      }
      // console.log('用章', this.sealForm)
      // 验证通过 --> 表单验证
      this.$refs[formref].validate((valid) => {
        if (valid) {
          this.$refs['sealForm'].validate(async (valid) => {
            if (valid) {
              // if (this.form.chargingMethod != '免费') {
              //   if (this.form.bcbdTable.length < 1) {
              //     this.loading = false
              //     return this.$message.error('不免费时至少要有一条收费明细!')
              //   }
              // }
              // 案件冲突校验
              var arrbt = this.form.tableData
              if (
                this.numType == 1 ||
                this.numType == 2 ||
                this.numType == 3 ||
                this.numType == 4 ||
                this.numType == 5 ||
                this.numType == 6
              ) {
                if (this.form.tableData.length == 0) {
                  this.loading = false
                  this.dianji = false
                  return this.$message.error('请录入案件当事人!')
                }

                // console.log(this.form.tableData)
                var bitian = true

                var clientBool = false
                arrbt.forEach((v) => {
                  if (v.isClient == true) {
                    clientBool = true
                    return
                  }
                })
                // console.log('clientBool:', clientBool)
                if (!clientBool) {
                  this.loading = false
                  this.dianji = false
                  return this.$message.error('请选择代理方！')
                }
                if (this.numType == 1) {
                  if (this.form.ajstatus == '一审') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '原告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加原告！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null ||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '原告') {
                          bitian = false
                          this.$message.error('请完善原告信息！')
                          break
                        } else if (arrbt[i].attribute == '被告') {
                          bitian = false
                          this.$message.error('请完善被告信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '二审') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加上诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被上诉人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '上诉人') {
                          bitian = false
                          this.$message.error('请完善上诉人信息！')
                          break
                        } else if (arrbt[i].attribute == '被上诉人') {
                          bitian = false
                          this.$message.error('请完善被上诉人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '再审'||this.form.ajstatus=='申请撤销裁决') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '再审听证'||this.form.ajstatus == '强制清算') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          this.$message.error('请完善被申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '破产申报') {
                    // if (
                    //   !this.form.tableData.some(
                    //     (item) => item.attribute == '申请人'
                    //   )
                    // ) {
                    //   this.loading = false
                    //   this.dianji = false
                    //   return this.$message.error('请添加申请人！')
                    // }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '债务人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加债务人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        // if (arrbt[i].attribute == '申请人') {
                        //   this.$message.error('请完善申请人信息！')
                        //   bitian = false
                        //   break
                        // } else 
                        if (arrbt[i].attribute == '债务人') {
                          this.$message.error('请完善债务人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '破产申请') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } 
                      }
                    }
                  } else if (this.form.ajstatus == '执行') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请执行人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请执行人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被执行人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被执行人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请执行人') {
                          bitian = false
                          this.$message.error('请完善申请执行人信息！')
                          break
                        } else if (arrbt[i].attribute == '被执行人') {
                          bitian = false
                          this.$message.error('请完善被执行人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '审判监督(再审)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '再审申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加再审申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '再审被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加再审被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '再审申请人') {
                          bitian = false
                          this.$message.error('请完善再审申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '再审被申请人') {
                          bitian = false
                          this.$message.error('请完善再审被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '公示催告') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '支付人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加支付人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '支付人') {
                          bitian = false
                          this.$message.error('请完善支付人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '督促') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '债权人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加债权人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '债务人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加债务人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '债权人') {
                          bitian = false
                          this.$message.error('请完善债权人信息！')
                          break
                        } else if (arrbt[i].attribute == '债务人') {
                          bitian = false
                          this.$message.error('请完善债务人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '选民资格案件(特别)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '起诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加起诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '选举委员会'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加选举委员会！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '起诉人') {
                          bitian = false
                          this.$message.error('请完善起诉人信息！')
                          break
                        } else if (arrbt[i].attribute == '选举委员会') {
                          bitian = false
                          this.$message.error('请完善选举委员会信息！')
                          break
                        }
                      }
                    }
                  } else if (
                    this.form.ajstatus == '宣告失踪、宣告死亡案件(特别)'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (
                    this.form.ajstatus ==
                    '认定公民无民事行为能力、限制行为能力案件(特别)'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '认定财产无主案件(特别)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '原财产所有人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加原财产所有人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '原财产所有人') {
                          bitian = false
                          this.$message.error('请完善原财产所有人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '制定遗产管理人案件(特别)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (
                    this.form.ajstatus == '确认调解协议案件(特别)' ||
                    this.form.ajstatus == '实现担保物权案件(特别)'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  }
                } else if (this.numType == 2) {
                  if (
                    this.form.ajstatus == '侦查' ||
                    this.form.ajstatus == '审查起诉'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '犯罪嫌疑人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加犯罪嫌疑人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '公诉机关'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加公诉机关！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '犯罪嫌疑人') {
                          bitian = false
                          this.$message.error('请完善犯罪嫌疑人信息！')
                          break
                        } else if (arrbt[i].attribute == '公诉机关') {
                          bitian = false
                          this.$message.error('请完善公诉机关信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '法院审理(一审)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告人！')
                    }
                    if (
                      !this.form.tableData.some(
                        // (item) => item.attribute == '控诉人'
                        (item) => item.attribute == '公诉机关'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      // return this.$message.error('请添加控诉人！')
                      return this.$message.error('请添加公诉机关！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '被告人') {
                          bitian = false
                          this.$message.error('请完善被告人信息！')
                          break
                        } 
                        else if (arrbt[i].attribute == '公诉机关') {
                          bitian = false
                          this.$message.error('请完善公诉机关信息！')
                          break
                        }
                        // else if (arrbt[i].attribute == '控诉人') {
                        //   bitian = false
                        //   this.$message.error('请完善控诉人信息！')
                        //   break
                        // }
                      }
                    }
                  } else if (this.form.ajstatus == '被告人上诉(二审)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加上诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '检察机关'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加检察机关！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '上诉人') {
                          bitian = false
                          this.$message.error('请完善上诉人信息！')
                          break
                        } else if (arrbt[i].attribute == '检察机关') {
                          bitian = false
                          this.$message.error('请完善检察机关信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '检察机关抗诉(二审)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '抗诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加抗诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        // (item) => item.attribute == '被抗诉人'
                        (item) => item.attribute == '原审被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      // return this.$message.error('请添加被抗诉人！')
                      return this.$message.error('请添加原审被告人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '抗诉人') {
                          bitian = false
                          this.$message.error('请完善抗诉人信息！')
                          break
                        } else if (arrbt[i].attribute == '被抗诉人') {
                          bitian = false
                          this.$message.error('请完善被抗诉人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '刑事申诉') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申诉人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申诉人') {
                          bitian = false
                          this.$message.error('请完善申诉人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '再审') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '再审申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加再审申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '再审被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加再审被申请人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '再审申请人') {
                          bitian = false
                          this.$message.error('请完善再审申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '再审被申请人') {
                          bitian = false
                          this.$message.error('请完善再审被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '自诉案件') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '自诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加自诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '自诉人') {
                          bitian = false
                          this.$message.error('请完善自诉人信息！')
                          break
                        } else if (arrbt[i].attribute == '被告人') {
                          bitian = false
                          this.$message.error('请完善被告人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '刑事附带民事诉讼') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '刑事附带民事诉讼原告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加刑事附带民事诉讼原告！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '刑事附带民事诉讼被告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加刑事附带民事诉讼被告！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (
                          arrbt[i].attribute == '自刑事附带民事诉讼原告诉人'
                        ) {
                          bitian = false
                          this.$message.error(
                            '请完善刑事附带民事诉讼原告信息！'
                          )
                          break
                        } else if (
                          arrbt[i].attribute == '刑事附带民事诉讼被告'
                        ) {
                          bitian = false
                          this.$message.error(
                            '请完善刑事附带民事诉讼被告信息！'
                          )
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '涉及单位犯罪') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '控诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加控诉人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '被告人') {
                          bitian = false
                          this.$message.error('请完善被告人信息！')
                          break
                        } else if (arrbt[i].attribute == '控诉人') {
                          bitian = false
                          this.$message.error('请完善控诉人信息！')
                          break
                        }
                      }
                    }
                  } else if (
                    this.form.ajstatus ==
                      '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序' ||
                    this.form.ajstatus ==
                      '依法不负刑事责任的精神病人的强制医疗程序'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '死刑复核程序') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '被告人') {
                          bitian = false
                          this.$message.error('请完善被告人信息！')
                          break
                        }
                      }
                    }
                  }
                } else if (this.numType == 3) {
                  if (this.form.ajstatus == '一审(行政诉讼)') {
                    if((this.form.tableData.some(
                        (item) => item.attribute == '原告'
                      )|| this.form.tableData.some(
                        (item) => item.attribute == '被告'
                      ))&&(this.form.tableData.some(
                        (item) => item.attribute == '请求人'
                      )|| this.form.tableData.some(
                        (item) => item.attribute == '权利人'
                      ))){
                        this.loading = false
                        this.dianji = false
                        return this.$message.error('原告被告与请求人权利人不能同时存在！')
                      }
                    if( this.form.tableData.some(
                        (item) => item.attribute == '原告'
                      )|| this.form.tableData.some(
                        (item) => item.attribute == '被告'
                      )){
                      if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '原告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加原告！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告！')
                    }
                    }else if (
                      this.form.tableData.some(
                        (item) => item.attribute == '请求人'
                      )|| this.form.tableData.some(
                        (item) => item.attribute == '权利人'
                      )
                    ) {
                      if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '请求人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加请求人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '权利人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加权利人！')
                    }
                    }
                    else{
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加原告或请求人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '原告') {
                          this.$message.error('请完善原告信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '被告') {
                          this.$message.error('请完善被告信息！')
                          bitian = false
                          break
                        }else if (arrbt[i].attribute == '请求人') {
                          this.$message.error('请完善请求人信息！')
                          bitian = false
                          break
                        }else if (arrbt[i].attribute == '权利人') {
                          this.$message.error('请完善权利人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '二审(行政诉讼)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加上诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被上诉人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '上诉人') {
                          this.$message.error('请完善上诉人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '被上诉人') {
                          this.$message.error('请完善被上诉人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '申请再审(行政诉讼)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          this.$message.error('请完善被申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政裁决') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '被申请人') {
                          this.$message.error('请完善被申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政复议') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '复议申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加复议申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '复议被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加复议被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '复议申请人') {
                          this.$message.error('请完善复议申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '复议被申请人') {
                          this.$message.error('请完善复议被申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '执行阶段(行政诉讼)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请执行人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请执行人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请执行人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请执行人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请执行人') {
                          this.$message.error('请完善申请执行人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '被申请执行人') {
                          this.$message.error('请完善被申请执行人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政处罚') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '当事人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加当事人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '行政主体'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加行政主体！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '当事人') {
                          this.$message.error('请完善当事人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '行政主体') {
                          this.$message.error('请完善行政主体信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政许可') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被许可人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被许可人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '被许可人') {
                          this.$message.error('请完善被许可人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政强制') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '当事人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加当事人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '行政主体'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加行政主体！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '当事人') {
                          this.$message.error('请完善当事人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '行政主体') {
                          this.$message.error('请完善行政主体信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '政府信息公开') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.attribute == '被申请机关'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请机关！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].attribute == '被申请机关') {
                          this.$message.error('请完善被申请机关信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  }
                } else if (this.numType == 4) {
                  if (
                    !this.form.tableData.some(
                      (item) => item.attribute == '申请执行人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加申请执行人！')
                  }
                  if (
                    !this.form.tableData.some(
                      (item) => item.attribute == '被执行人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加被执行人！')
                  }
                  for (let i = 0; i < arrbt.length; i++) {
                    if (
                      arrbt[i].name == '' ||
                      arrbt[i].name == null ||
                      arrbt[i].isClient === '' ||
                      arrbt[i].isClient === null ||
                      arrbt[i].isUnit === '' ||
                      arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                    ) {
                      if (arrbt[i].attribute == '申请执行人') {
                        this.$message.error('请完善申请执行人信息！')
                        bitian = false
                        break
                      } else if (arrbt[i].attribute == '被执行人') {
                        this.$message.error('请完善被执行人信息！')
                        bitian = false
                        break
                      }
                    }
                  }
                } else if (this.numType == 5 || this.numType == 6) {
                  if (
                    !this.form.tableData.some(
                      (item) => item.attribute == '申请人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加申请人！')
                  }
                  if (
                    !this.form.tableData.some(
                      (item) => item.attribute == '被申请人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加被申请人！')
                  }
                  for (let i = 0; i < arrbt.length; i++) {
                    if (
                      arrbt[i].name == '' ||
                      arrbt[i].name == null ||
                      arrbt[i].isClient === '' ||
                      arrbt[i].isClient === null ||
                      arrbt[i].isUnit === '' ||
                      arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                    ) {
                      if (arrbt[i].attribute == '申请人') {
                        this.$message.error('请完善申请人信息！')
                        bitian = false
                        break
                      } else if (arrbt[i].attribute == '被申请人') {
                        this.$message.error('请完善被申请人信息！')
                        bitian = false
                        break
                      }
                    }
                  }
                }
                if (bitian == false) {
                  this.loading = false
                  this.dianji = false
                  return
                }
                for (let i = 0; i < arrbt.length; i++) {
                  if (
                    arrbt[i].name == '' ||
                    arrbt[i].name == null ||
                    arrbt[i].isUnit === '' ||
                    arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                  ) {
                    if (
                      arrbt[i].attribute == '第三人' ||
                      arrbt[i].attribute == '原审第三人' ||
                      arrbt[i].attribute == '原审原告' ||
                      arrbt[i].attribute == '原审被告' ||
                      arrbt[i].attribute == '执行异议人' ||
                      arrbt[i].attribute == '案外人' ||
                      arrbt[i].attribute == '利害关系人' ||
                      arrbt[i].attribute == '有关公民' ||
                      arrbt[i].attribute == '代理人' ||
                      arrbt[i].attribute == '继承人' ||
                      arrbt[i].attribute == '遗产管理人' ||
                      arrbt[i].attribute == '被害人' ||
                      arrbt[i].attribute == '执行异议中的利害关系人' ||
                      arrbt[i].attribute == '行政主体' ||
                      arrbt[i].attribute == '其他人员' ||
                      arrbt[i].attribute == '第三方'||arrbt[i].attribute == '债权人'||arrbt[i].attribute == '申请人'||arrbt[i].attribute == '被申请人'
                      ||arrbt[i].attribute == '复议申请人'
                    ) {
                      if (
                        (arrbt[i].name == '' || arrbt[i].name == null) &&
                        (arrbt[i].isClient !== '' ||
                          arrbt[i].isClient !== null) &&
                        (arrbt[i].isUnit === '' || arrbt[i].isUnit === null)
                        &&
                        (arrbt[i].idnumber === '' || arrbt[i].idnumber === null)
                      ) {
                        this.form.tableData.splice(i, 1)
                      } else if (
                        arrbt[i].name != '' ||
                        arrbt[i].name != null ||
                        arrbt[i].isUnit !== '' ||
                        arrbt[i].isUnit !== null||
                        arrbt[i].idnumber !== '' ||
                        arrbt[i].idnumber !== null
                      ) {
                        if (
                          arrbt[i].name == '' ||
                          arrbt[i].name == null ||
                          arrbt[i].isUnit === '' ||
                          arrbt[i].isUnit === null||
                          arrbt[i].idnumber === '' ||
                          arrbt[i].idnumber === null
                        ) {
                          bitian = false
                          this.$message.error(
                            '请完善' + arrbt[i].attribute + '信息！'
                          )
                          break
                        }
                      }
                    }
                  }
                }

                if (bitian == false) {
                  this.loading = false
                  this.dianji = false
                  return
                }

                this.form.tableData = this.form.tableData.filter(
                  (item) =>
                    item.name != '' &&
                    item.name != null &&
                    item.isClient !== '' &&
                    item.isClient !== null &&
                    item.isUnit !== '' &&
                    item.isUnit !== null&&
                    item.idnumber !== '' &&
                    item.idnumber !== null
                )

                var att = ''

                this.form.tableData.forEach((value, index, array) => {
                  if (value.isClient) {
                    att = value.attribute
                  }
                })
                await caseConflictApi({
                  listLitigant_param: this.form.tableData,
                  CaseId: this.form.id,
                  Attribute: att
                }).then((res) => {
                  if (res.data.status == 'success') {
                    // 弹出案件冲突
                    this.loading = false
                    this.dianji = false
                    this.dialogallConflictCase = res.data.data
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.loading = false
                    this.dianji = false
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.$message.error(res.data.message)
                  }
                })
                await caseAdviserApi({
                  listLitigant_param: this.form.tableData,
                  CaseId: null,
                  Attribute: att
                }).then((res) => {
                  if (res.data.status == 'success') {
                    this.loading = false
                    this.dianji = false
                    this.lvShiConflict = res.data.data
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.loading = false
                    this.dianji = false
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.$message.error(res.data.message)
                  }
                })
                await BanruptcykConflictApi({
                  listLitigant_param: this.form.tableData,
                  CaseId: null,
                  Attribute: att
                }).then((res) => {
                  if (res.data.status == 'success') {
                    this.loading = false
                    this.dianji = false
                    this.BanruptcykConflict = res.data.data
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.loading = false
                    this.dianji = false
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.$message.error(res.data.message)
                  }
                })
                if (
                  this.lvShiConflict.length > 0 ||
                  this.dialogallConflictCase.length > 0||this.BanruptcykConflict.length>0
                ) {
                  // this.caseConflict = true
                  this.allConflictCount=0
                  this.formConflict.conflictApproval=null
                  this.conflictShow=false
                  if(this.lvShiConflict.length > 0){
                     this.allConflictCount = this.allConflictCount +this.lvShiConflict.filter(item => item.isClient == 1).length
                  }
                   if(this.BanruptcykConflict.length > 0){
                     this.allConflictCount = this.allConflictCount +this.BanruptcykConflict.filter(item => item.isClient == 1).length
                  }
                  if(this.dialogallConflictCase.length > 0){
                    
                    this.conflictList=this.dialogallConflictCase.filter(item => item.conId == 1)
                    this.allConflictCount  = this.allConflictCount +this.conflictList.length
                    if(this.conflictList.length==0){
                      this.conflictList.push(this.dialogallConflictCase[0])
                    }
                    if(this.dialogallConflictCase.length>this.conflictList.length&&this.dialogallConflictCase.length>1){
                      this.dialoghasMore=true
                    }
                  }
                  // console.log(this.allConflictCount )
                  if(this.allConflictCount>0){
                    await this.GetConflictMember()
                  }else{
                    this.caseConflict = true
                 
                  }
                } else {
                  this.ProcessType = ['case_entry', 'type_seal']
                  this.addEnter()
                }
              } else if (
                this.numType == 7 ||
                this.numType == 8 ||
                this.numType == 14 ||
                this.numType == 9
              ) {
                if (this.numType == 9) {
                  if (this.form.tableData.length == 0) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请录入案件当事人!')
                  }

                  var clientBool = false
                  arrbt.forEach((v) => {
                    if (v.isClient == true) {
                      clientBool = true
                      return
                    }
                  })
                  if (!clientBool) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请选择代理方！')
                  }
                  if (
                    !this.form.tableData.some(
                      (item) => item.attribute == '客户名称'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加客户名称！')
                  }
                  if (
                    !this.form.tableData.some(
                      (item) => item.attribute == '对方当事人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加对方当事人！')
                  }
                  // console.log(arrbt)
                  for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].name == '' ||
                        arrbt[i].name == null ||
                        arrbt[i].isClient === '' ||
                        arrbt[i].isClient === null ||
                        arrbt[i].isUnit === '' ||
                        arrbt[i].isUnit === null||
                        arrbt[i].idnumber === '' ||
                        arrbt[i].idnumber === null
                      ) {
                        if (arrbt[i].attribute == '客户名称') {
                          this.loading = false
                          this.dianji = false
                          this.$message.error('请完善客户信息！')
                          return
                        } else if (arrbt[i].attribute == '对方当事人') {
                          this.loading = false
                          this.dianji = false
                          this.$message.error('请完善对方当事人信息！')
                          return
                        }
                      }
                    }
                  this.form.tableData = this.form.tableData.filter(
                    (item) =>
                      item.name != '' &&
                      item.name != null &&
                      item.isClient !== '' &&
                      item.isClient !== null &&
                      item.isUnit !== '' &&
                      item.isUnit !== null&&
                      item.idnumber !== '' &&
                      item.idnumber !== null
                  )

                  var att = ''

                  this.form.tableData.forEach((value, index, array) => {
                    if (value.isClient) {
                      att = value.attribute
                    }
                  })
                  await caseConflictApi({
                    listLitigant_param: this.form.tableData,
                    CaseId: this.form.id,
                    Attribute: att
                  }).then((res) => {
                    if (res.data.status == 'success') {
                      // 弹出案件冲突
                      this.loading = false
                      this.dianji = false
                      this.conflictList = res.data.data
                    } else if (
                      res.data.status == '401' ||
                      res.data.status == '402' ||
                      res.data.status == '403'
                    ) {
                      this.loading = false
                      this.dianji = false
                      this.$message.error(res.data.message)
                      window.sessionStorage.removeItem('token')
                      window.sessionStorage.removeItem('hasRoles')
                      this.$router.push('/login')
                      return
                    } else {
                      this.$message.error(res.data.message)
                    }
                  })
                  await caseAdviserApi({
                    listLitigant_param: this.form.tableData,
                    CaseId: null,
                    Attribute: att
                  }).then((res) => {
                    if (res.data.status == 'success') {
                      this.loading = false
                      this.dianji = false
                      this.lvShiConflict = res.data.data
                    } else if (
                      res.data.status == '401' ||
                      res.data.status == '402' ||
                      res.data.status == '403'
                    ) {
                      this.loading = false
                      this.dianji = false
                      this.$message.error(res.data.message)
                      window.sessionStorage.removeItem('token')
                      window.sessionStorage.removeItem('hasRoles')
                      this.$router.push('/login')
                      return
                    } else {
                      this.$message.error(res.data.message)
                    }
                  })
                await BanruptcykConflictApi({
                  listLitigant_param: this.form.tableData,
                  CaseId: null,
                  Attribute: att
                }).then((res) => {
                  if (res.data.status == 'success') {
                    this.loading = false
                    this.dianji = false
                    this.BanruptcykConflict = res.data.data
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.loading = false
                    this.dianji = false
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.$message.error(res.data.message)
                  }
                })
                  if (
                    this.lvShiConflict.length > 0 ||
                    this.conflictList.length > 0||this.BanruptcykConflict.length>0
                  ) {
                    // this.caseConflict = true
                    this.caseConflict = true
                    this.allConflictCount=0
                    this.formConflict.conflictApproval=null
                    if(this.lvShiConflict.length > 0){
                      this.allConflictCount = this.allConflictCount +this.lvShiConflict.filter(item => item.isClient == 1).length
                    }
                     if(this.BanruptcykConflict.length > 0){
                      this.allConflictCount = this.allConflictCount +this.BanruptcykConflict.filter(item => item.isClient == 1).length
                    }
                    if(this.conflictList.length > 0){
                      this.allConflictCount  = this.allConflictCount +this.conflictList.filter(item => item.conId == 1).length
                    }
                    if(this.allConflictCount>0){
                      await this.GetConflictMember()
                      
                    }else{
                      this.caseConflict = true
                    }
                  } else {
                    this.ProcessType = ['case_entry', 'type_seal']
                    this.addEnter()
                  }
                } else {
                  if (this.form.level.length != 2) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('风控委必须选择两人！')
                  } else {
                    // 确认新增
                    this.ProcessType = ['case_entry', 'type_seal']
                    this.addEnter()
                  }
                }
              }//专项服务合同
              else if(this.numType==11){
                  await caseConflictApi({
                     listLitigant_param:  this.form.bcz.tableData,
                    // listLitigant_param:  [{IsUnit: false, Name: this.form.bcz.procureunit, IsClient: true, Attribute: "客户名称",Idnumber:this.form.bcz.idnumber}],
                    CaseId: this.form.id,
                    Attribute: "客户名称"
                  }).then((res) => {
                    if (res.data.status == 'success') {
                      // 弹出案件冲突
                      this.conflictList = res.data.data
                    } else if (
                      res.data.status == '401' ||
                      res.data.status == '402' ||
                      res.data.status == '403'
                    ) {
                      this.$message.error(res.data.message)
                      window.sessionStorage.removeItem('token')
                      window.sessionStorage.removeItem('hasRoles')
                      this.$router.push('/login')
                      return
                    } else {
                      this.$message.error(res.data.message)
                    }
                    this.loading = false
                    this.dianji = false
                  })

                  if (
                    // this.lvShiConflict.length > 0 ||
                    this.conflictList.length > 0
                  ) {
                    this.caseConflict = true
                    this.allConflictCount=0
                    this.formConflict.conflictApproval=null
                    // if(this.lvShiConflict.length > 0){
                    //   this.allConflictCount = this.allConflictCount +this.lvShiConflict.filter(item => item.conId == 1).length
                    // }
                    if(this.conflictList.length > 0){
                      this.allConflictCount  = this.allConflictCount +this.conflictList.filter(item => item.conId == 1).length
                    }
                    if(this.allConflictCount>0){
                      await this.GetConflictMember()
                      
                    }else{
                      this.caseConflict = true
                    }
                  } else {
                    // 确认新增
                    this.ProcessType = ['case_entry', 'type_seal']
                    // this.FileList = this.FileList1.concat(this.FileList2)
                    this.addEnter()
                  }
                } else {
                this.ProcessType = ['case_entry', 'type_seal']
                this.addEnter()
              }
            } else {
              this.$nextTick(() => {
                const errorField = this.$el.querySelector(
                  '.el-form-item.is-error'
                )
                if (errorField) {
                  errorField.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                  })
                }
              })
              this.loading = false
              this.dianji = false
              this.$message.error('请检查用章信息填写错误!')
            }
          })
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.loading = false
          this.dianji = false
          this.$message.error('请检查案件信息填写错误!')
        }
      })
    },
    // 继续录入
    conflict(formref) {
     

      this.$refs[formref].validate((valid) => {
        if (valid) {
          // 确认新增
          this.ProcessType = ['case_entry', 'type_seal']
          this.caseConflict = false // 冲突
          this.addEnter()
        }else{
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
        }
      }
      )
       // this.loading = true
      // this.dianji = true
      // this.caseConflict = false // 冲突
      // this.litigantDialog = false
      // if (this.dialogLitigant.length > 0) {
      //   changeLitigant({
      //     caseid: this.form.id,
      //     listLitigant_param: this.dialogLitigant
      //   })
      //     .then((res) => {
      //       if (res.data.status == '0') {
      //         this.loading = false
      //         this.dianji = false

      //         this.$message.success(res.data.message)
      //         setTimeout(() => {
      //           this.$router.go(-this.times)
      //         }, 100)
      //       } else if (
      //         res.data.status == '401' ||
      //         res.data.status == '402' ||
      //         res.data.status == '403'
      //       ) {
      //         this.loading = false
      //         this.dianji = false
      //         this.$message.error(res.data.message)
      //         window.sessionStorage.removeItem('token')
      //         window.sessionStorage.removeItem('hasRoles')
      //         this.$router.push('/login')
      //         return
      //       } else {
      //         this.loading = false
      //         this.dianji = false
      //         this.$message.error(res.data.message)
      //       }
      //     })
      //     .catch((err) => {
      //       this.loading = false
      //       this.dianji = false
      //       this.$message.error(err)
      //     })
      //   this.litigantClose()
      // } else {
      //   this.addEnter()
      // }
    },
    // 取消录入
    edit() {
      this.conflictList = []
      this.lvShiConflict = []
      this.caseConflict = false
      this.dialogshowAllCase=false
      this.dialoghasMore=false
      this.formConflict.conflictApproval=null
    },

    //立项日历
    onMouseOver() {
      if (this.form.approvaldate != undefined && this.form != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },

    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },
    dsrOrder(row) {
      if (this.numType == 2) {
        if (
          row.attribute == '被告人' ||
          row.attribute == '上诉人' ||
          row.attribute == '犯罪嫌疑人'
        ) {
          var nat = this.xingshiArrtibute1.filter(
            (item) => item.label == row.attribute
          )
          row.order = nat[0].order
        } else if (row.attribute == '公诉机关' || row.attribute == '自诉人') {
          var nat = this.xingshiArrtibute2.filter(
            (item) => item.label == row.attribute
          )
          row.order = nat[0].order
        }
      } else if (
        ((this.numType == 1 && this.form.ajstatus == '二审') ||
          (this.numType == 3 && this.form.ajstatus == '二审')) &&
        (row.attribute == '第三人' || row.attribute == '原审第三人')
      ) {
        var nat = this.ershenArrtibute.filter(
          (item) => item.label == row.attribute
        )
        row.order = nat[0].order
      } else {
        var nat = this.ArrtibuteOptions.filter(
          (item) => item.label == row.attribute
        )
        row.order = nat[0].order
      }

if(this.numType == 3&&this.form.ajstatus=='一审(行政诉讼)'){
        //  console.log("变化")
        if(row.attribute=="请求人"||row.attribute=="权利人"){
          this.form.tableData = this.form.tableData.map(row => {
            if (row.attribute === '原告') {
              return { ...row, attribute: '请求人', order: 101 }
            }
            if (row.attribute === '被告') {
              return { ...row, attribute: '权利人', order: 201 }
            }
            return row
          })
        }else if(row.attribute=="原告"||row.attribute=="被告"){
          this.form.tableData = this.form.tableData.map(row => {
            if (row.attribute === '请求人') {
              return { ...row, attribute: '原告', order: 100 }
            }
            if (row.attribute === '权利人') {
              return { ...row, attribute: '被告', order: 200 }
            }
            return row
          })
        }
      }
      if (this.form.tableData.length > 0) {
        this.form.tableData.sort((a, b) => {
          if (a.order === b.order) {
            return a.count - b.count
          } else {
            return a.order - b.order
          }
        })
      }
      if (this.dialogLitigant.length > 0) {
        this.dialogLitigant.sort((a, b) => {
          if (a.order === b.order) {
            return a.count - b.count
          } else {
            return a.order - b.order
          }
        })
      }

      // this.getLitigants()
    },
    // 添加当事人
    addParty(row, t) {
      if (t == 'dialog1_6') {
        var isclient = null
        var isunit = null
        if (row != null) {
          this.addTableData = row.attribute
          isclient = row.isClient
          isunit = row.isUnit
        }
        if (this.addTableData == null || this.addTableData == '') {
          return this.$message.error('请选择当事人身份！')
        }


        // 当前已有的最大count
        let c = Math.max.apply(
          Math,
          this.dialogLitigant.map(function (f) {
            return f.count
          })
        )

        var td
        this.dialogLitigant.forEach((value, index, arr) => {
          if (this.addTableData == value.attribute) {
            td = index
          }
        })

        var order
        this.ArrtibuteOptions.forEach((value) => {
          if (this.addTableData == value.value) {
            return (order = value.order)
          }
        })

        if (td === undefined) {
          if (this.dialogLitigant.length == 0) {
            this.dialogLitigant.push({
              // 表格
              isUnit: isunit,
              name: null,
              isClient: isclient == null ? false : isclient,
              attribute: this.addTableData,
              count: 0,
              order: order,
              idnumber:null,
            })
          } else {
            this.dialogLitigant.splice(td + 1, 0, {
              // 表格
              isUnit: isunit,
              name: null,
              isClient: isclient == null ? false : isclient,
              attribute: this.addTableData,
              count: c + 1,
              order: order,
              idnumber:null,
            })
          }
        } else {
          this.dialogLitigant.splice(td + 1, 0, {
            // 表格
            isUnit: isunit,
            name: null,
            isClient: isclient == null ? false : isclient,
            attribute: this.addTableData,
            count: c + 1,
            order: order,
            idnumber:null,
          })
        }

        this.dialogLitigant.sort((a, b) => {
          return a.order - b.order
        })
      } else {
        var isclient = null
        var isunit = null
        if (row != null) {
          this.addTableData = row.attribute
          isclient = row.isClient
          isunit = row.isUnit
        }
        if (this.addTableData == null || this.addTableData == '') {
          return this.$message.error('请选择当事人身份！')
        }

         if(this.numType == 3&&this.form.ajstatus=='一审(行政诉讼)'){
        //  console.log("变化")
        if(this.addTableData=="请求人"||this.addTableData=="权利人"){
          this.form.tableData = this.form.tableData.map(row => {
            if (row.attribute === '原告') {
              return { ...row, attribute: '请求人', order: 101 }
            }
            if (row.attribute === '被告') {
              return { ...row, attribute: '权利人', order: 201 }
            }
            return row
          })
        }else if(this.addTableData=="原告"||this.addTableData=="被告"){
          this.form.tableData = this.form.tableData.map(row => {
            if (row.attribute === '请求人') {
              return { ...row, attribute: '原告', order: 100 }
            }
            if (row.attribute === '权利人') {
              return { ...row, attribute: '被告', order: 200 }
            }
            return row
          })
        }
      }
        // 当前已有的最大count
        let c = Math.max.apply(
          Math,
          this.form.tableData.map(function (f) {
            return f.count
          })
        )

        var td
        this.form.tableData.forEach((value, index, arr) => {
          if (this.addTableData == value.attribute) {
            td = index
          }
        })

        var order
        this.ArrtibuteOptions.forEach((value) => {
          if (this.addTableData == value.value) {
            return (order = value.order)
          }
        })

        if (td === undefined) {
          if (this.form.tableData.length == 0) {
            this.form.tableData.push({
              // 表格
              isUnit: isunit,
              name: null,
              isClient: isclient == null ? false : isclient,
              attribute: this.addTableData,
              idnumber:null,
              count: 0,
              order: order,
              idnumber:null,
            })
          } else {
            this.form.tableData.splice(td + 1, 0, {
              // 表格
              isUnit: isunit,
              name: null,
              isClient: isclient == null ? false : isclient,
              attribute: this.addTableData,
              count: c + 1,
              idnumber:null,
              order: order,
              idnumber:null,
            })
          }
        } else {
          this.form.tableData.splice(td + 1, 0, {
            // 表格
            isUnit: isunit,
            name: null,
            isClient: isclient == null ? false : isclient,
            attribute: this.addTableData,
            count: c + 1,
            idnumber:null,
            order: order,
              idnumber:null,
          })
        }

        this.form.tableData.sort((a, b) => {
          return a.order - b.order
        })
      }
      this.getLitigants()
    },

    addParty09(row, t) {
      if (t == 'dialog9') {
        if (row != null) {
          this.addTableData = row.attribute
        }
        if (this.addTableData == null || this.addTableData == '') {
          return this.$message.error('请选择当事人身份！')
        }

        var usct
        if (this.addTableData == '客户名称') {
          usct = true
        } else if (this.addTableData == '对方当事人') {
          usct = false
        }
        // 当前已有的最大count
        let c = Math.max.apply(
          Math,
          this.dialogLitigant.map(function (f) {
            return f.count
          })
        )

        var td
        this.dialogLitigant.forEach((value, index, arr) => {
          if (this.addTableData == value.attribute) {
            td = index
          }
        })

        var order
        this.ArrtibuteOptions.forEach((value) => {
          if (this.addTableData == value.value) {
            return (order = value.order)
          }
        })

        if (td === undefined) {
          if (this.dialogLitigant.length == 0) {
            this.dialogLitigant.push({
              // 表格
              isUnit: false,
              name: null,
              isClient: usct,
              attribute: this.addTableData,
              count: 0,
              order: order,
              idnumber:null,
            })
          } else {
            this.dialogLitigant.splice(td + 1, 0, {
              // 表格
              isUnit: false,
              name: null,
              isClient: usct,
              attribute: this.addTableData,
              count: c + 1,
              order: order,
              idnumber:null,
            })
          }
        } else {
          this.dialogLitigant.splice(td + 1, 0, {
            // 表格
            isUnit: false,
            name: null,
            isClient: usct,
            attribute: this.addTableData,
            count: c + 1,
            order: order,
            idnumber:null,
          })
        }

        this.dialogLitigant.sort((a, b) => {
          return a.order - b.order
        })
      } else {
        if (row != null) {
          this.addTableData = row.attribute
        }
        if (this.addTableData == null || this.addTableData == '') {
          return this.$message.error('请选择当事人身份！')
        }

        var usct
        if (this.addTableData == '客户名称') {
          usct = true
        } else if (this.addTableData == '对方当事人') {
          usct = false
        }
        // 当前已有的最大count
        let c = Math.max.apply(
          Math,
          this.form.tableData.map(function (f) {
            return f.count
          })
        )

        var td
        this.form.tableData.forEach((value, index, arr) => {
          if (this.addTableData == value.attribute) {
            td = index
          }
        })

        var order
        this.ArrtibuteOptions.forEach((value) => {
          if (this.addTableData == value.value) {
            return (order = value.order)
          }
        })

        if (td === undefined) {
          if (this.form.tableData.length == 0) {
            this.form.tableData.push({
              // 表格
              isUnit: false,
              name: null,
              isClient: usct,
              attribute: this.addTableData,
              count: 0,
              order: order,
              idnumber:null,
            })
          } else {
            this.form.tableData.splice(td + 1, 0, {
              // 表格
              isUnit: false,
              name: null,
              isClient: usct,
              attribute: this.addTableData,
              count: c + 1,
              order: order,
              idnumber:null,
            })
          }
        } else {
          this.form.tableData.splice(td + 1, 0, {
            // 表格
            isUnit: false,
            name: null,
            isClient: usct,
            attribute: this.addTableData,
            count: c + 1,
            order: order,
            idnumber:null,
          })
        }

        this.form.tableData.sort((a, b) => {
          return a.order - b.order
        })
      }
      // this.getLitigants()
      // console.log('添加排序', this.form.tableData)
    },

    // 减少当事人
    reduceParty(c, t) {
      // if (this.form.tableData.length == 1) {
      //   this.$message.error('至少有一个当事人！')
      // } else {
      //   this.form.tableData.forEach((value, index, array) => {
      //     if (value.count != c) {
      //       this.newtableData.push(array[index])
      //     }
      //   })
      //   this.form.tableData = this.newtableData
      //   this.newtableData = []
      // }

      if (t == 0) {
        this.form.tableData.forEach((value, index, array) => {
          if (value.count != c) {
            this.newtableData.push(array[index])
          }
        })
        this.form.tableData = this.newtableData
        this.newtableData = []
      } else if (t == 1) {
        this.dialogLitigant.forEach((value, index, array) => {
          if (value.count != c) {
            this.newtableData.push(array[index])
          }
        })
        this.dialogLitigant = this.newtableData
        this.newtableData = []
      }
      this.getLitigants()
    },
    // 添加案件（步骤）
    addStep() {
      var l = this.form.link.length
      if (
        this.form.link[l - 1].result == 'process' ||
        this.form.link[l - 1].result == 'error'
      ) {
        this.add = false
      }

      if (!this.add) {
        return this.$message.error('存在未审核或审核未通过与本案关联的案件!')
      }
      if (this.form.bs_Result == 1) {
        return this.$message.error('用章申请未通过！无法添加步骤！')
      }

      this.$store.commit('setinputstatus', 1)
      this.$router.push({
        path: '/home/case/caseinput',
        query: {
          linkid:
            this.form.linkId[0] == null || ''
              ? this.form.id
              : this.form.linkId[0],
          status: this.form.typeId,
          num: this.form.typeId.substring(21, 23),
          sup: true
        }
      })
    },
    // 添加收费明细
    addCharge() {
      if (this.form.bcbdTable.length == 0) {
        this.form.bcbdTable.push({
          id: null,
          name: null,
          amount: null,
          paymentDate: null,
          remark: null,
          status: null,
          count: 1
        })
      } else {
        var c = Math.max.apply(
          Math,
          this.form.bcbdTable.map(function (f) {
            return f.count
          })
        )
        this.form.bcbdTable.push({
          id: null,
          name: null,
          amount: null,
          paymentDate: null,
          remark: null,
          status: null,
          count: c + 1
        })
      }
    },
    // 减少收费明细
    reduceCharge(c) {
      this.form.bcbdTable.forEach((value, index, array) => {
        if (value.count != c) {
          this.newbcbdTable.push(array[index])
        }
      })
      this.form.bcbdTable = this.newbcbdTable
      this.newbcbdTable = []
    },

    // 收费选择
    async SF_chargingMethodstatus(v) {
      if (v == '免费') {
        // 免费
        this.sfxz.fixed = false
        this.sfxz.riskFixed = false
        this.sfxz.riskRatio = false
        this.sfxz.detail = false
        this.sfxz.mfpz = true
      } else if (v == '固定收费') {
        // 固定收费
        this.sfxz.fixed = true
        this.sfxz.riskFixed = false
        this.sfxz.riskRatio = false
        this.sfxz.detail = true
        this.sfxz.mfpz = false
      } else if (v == '风险收费') {
        // 风险收费
        this.sfxz.fixed = false
        this.sfxz.riskFixed = true
        this.sfxz.riskRatio = true
        this.sfxz.detail = true
        this.sfxz.mfpz = false
      }
    },
    //受理按钮
    Accept() {
      CaseAppect({ Id: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.$message.success(res.data.message)
          this.GetCaseLog()
          this.form.casestatus = '受理'
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 当事人copy
    copyParty(row) {
      // var c = Math.max.apply(
      //   Math,
      //   this.form.tableData.map(function (f) {
      //     return f.count
      //   })
      // )
      // this.form.tableData.push({
      //   // 表格
      //   id: null,
      //   isUnit: row.isUnit,
      //   name: row.name,
      //   isClient: row.isClient,
      //   attribute: row.attribute,
      //   count: c + 1
      // })
      // console.log('row', row)
      // 获取最大count
      let c = Math.max.apply(
        Math,
        this.form.tableData.map(function (f) {
          return f.count
        })
      )
      var td
      this.form.tableData.forEach((value, index, arr) => {
        if (row.attribute == value.attribute) {
          td = index
        }
      })

      var order
      this.ArrtibuteOptions.forEach((value) => {
        if (this.addTableData == value.value) {
          return (order = value.order)
        }
      })

      this.form.tableData.splice(td + 1, 0, {
        // 表格
        isUnit: null,
        name: null,
        isClient: false,
        attribute: row.attribute,
        count: c + 1,
        order: order,
        idnumber:null,
      })
    },

    // 收费明细copy
    copyCharge(row) {
      var c = Math.max.apply(
        Math,
        this.form.bcbdTable.map(function (f) {
          return f.count
        })
      )
      this.form.bcbdTable.push({
        id: null,
        name: row.name,
        amount: row.amount,
        paymentDate: row.paymentDate,
        remark: row.remark,
        status: row.status,
        count: c + 1
      })
    },

    // 案件明细查询
    async AllCaseApi() {
      await allCaseApi({
        Id: this.$route.query.guid,
        SelectType: 1 //（0：案件管理，1：案件明细）
      }).then((res) => {
        if (res.data.status == '0') {
          // console.log(res.data.data[0].dl_lvshi[0])
          // console.log(this.$store.state.name)

          var xl = res.data.data[0].xl_lvshi
          // var oldCities = JSON.parse(res.data.data[0].newStype)
          this.sealForm.applicant = res.data.data[0].applicant
          this.sealForm.leadLawyer2 = res.data.data[0].approve
          // if (oldCities != null) {
          //   this.bsNewType = true
          //   if (this.checkedCities.length > 0) {
          //     this.checkedCities = []
          //   }
          //   // console.log('oldCities', oldCities)
          //   // console.log('cities', this.cities)
          //   oldCities.forEach((val) => {
          //     this.checkedCities.push(val.name)
          //     this.cities.forEach((v, index, array) => {
          //       if (v.name == val.name) {
          //         v.stype = val.stype
          //       }
          //     })
          //   })

          //   const cC = new Set(this.checkedCities.map((m) => m))

          //   var bbk = []

          //   if (
          //     res.data.data[0].bs_Result != '1' ||
          //     res.data.data[0].bs_Result == null
          //   ) {
          //     this.cities.forEach((city, index, array) => {
          //       // 不包含
          //       if (!cC.has(city.name)) {
          //         bbk.push(city.name)
          //       }
          //     })
          //     this.cities = this.cities.filter(function (item) {
          //       return !bbk.includes(item.name)
          //     })
          //   } else {
          //     this.cities.forEach((city) => {
          //       // 不包含
          //       if (!cC.has(city.name)) {
          //         city.stype = []
          //       }
          //     })
          //   }
          // } else {
          //   this.bsNewType = false
          // }

          // console.log('cities', this.cities)
          var xlBool = false
          xl.forEach((vle, idx, arr) => {
            if (vle == this.$store.state.name) {
              return (xlBool = true)
            }
          })
          if (
            res.data.data[0].dl_lvshi[0] == this.$store.state.name ||
            xlBool
          ) {
            this.step = true
          } else {
            this.step = false
          }
          // 案件信息
          this.form = res.data.data[0]
          let targetDate = new Date('2024-08-16T00:00:00Z');

          // 之前的直接归档
          // console.log(this.form.approvaldate < targetDate)
          if ( new Date(this.form.approvaldate) < targetDate) {
            this.timeGuidang=true
          }else{
            
            if(this.form.bs_Result == 0 &&this.form.bs_Status == 0){
              this.timeGuidang=true
            }
            
          }
          // console.log("timeGuidang",this.timeGuidang)
          this.form.linkId = this.form.linkId.filter(
            (item) => item != this.$route.query.guid
          )
          if (this.form.id == this.form.linkId[0]) {
            this.form.linkId = null
          }
           if (this.form.result == 1) {
            this.bianji = false
          }
          //其他东西
          this.form.bcz = JSON.parse(res.data.data[0].bcz)
          this.form.bcz.tableData=[];
          
          if(this.numType==11&&this.form.tableData){
            this.$set(this.form, 'bcz', {
              tableData: (this.form.tableData || []).map(item => ({
                id: item.id,
                name: item.name ,
                idnumber: item.idnumber ,
                isUnit: item.isUnit,
                isClient: item.isClient,
                attribute: item.attribute || "客户名称",
                count: item.sort,
                order: item.order,
              }))
            });
            // console.log(this.bianji)
            if(this.form.tableData.length==0&&this.bianji==false){
              
              this.addParty3()
            }
          //   this.form.bcz.tableData = this.form.tableData.map(item => ({
          //     id: item.id,
          //     name: item.name,
          //     isUnit: item.isUnit,
          //     isClient: item.isClient,
          //     attribute: item.attribute,
          //     count: item.sort,
          //     order: item.order,
          //     idnumber:item.idnumber,
          // }));
          }
          // console.log('数组是否为响应式', this.form.bcz.tableData.__ob__)
          // console.log(this.form.bcz.tableData)
          // console.log(this.form.bcz.tableData)
          for (var i = 0; i < this.form.sealFile.length; i++) {
            var name = this.form.sealFile[i].name.split('.')[0]
            var type = this.form.sealFile[i].name.substring(
              this.form.sealFile[i].name.lastIndexOf('.') + 1
            )
            this.FileList.push({
              uid: this.form.sealFile[i].id,
              name: name,
              ftype: type,
              isShow: false,
              curPercentage: 100
            })
          }

          for (var i = 0; i < this.form.biddingSchemes.length; i++) {
            var name = this.form.biddingSchemes[i].name.split('.')[0]
            var type = this.form.biddingSchemes[i].name.substring(
              this.form.biddingSchemes[i].name.lastIndexOf('.') + 1
            )
            this.FileList1.push({
              uid: this.form.biddingSchemes[i].id,
              name: name,
              ftype: type,
              isShow: false,
              curPercentage: 100
            })
          }
          for (var i = 0; i < this.form.ordinaryFiles.length; i++) {
            var name = this.form.ordinaryFiles[i].name.split('.')[0]
            var type = this.form.ordinaryFiles[i].name.substring(
              this.form.ordinaryFiles[i].name.lastIndexOf('.') + 1
            )
            this.FileList2.push({
              uid: this.form.ordinaryFiles[i].id,
              name: name,
              ftype: type,
              isShow: false,
              curPercentage: 100
            })
          }
          for (var i = 0; i < this.form.chujuFiles.length; i++) {
            var name = this.form.chujuFiles[i].name.split('.')[0]
            var type = this.form.chujuFiles[i].name.substring(
              this.form.chujuFiles[i].name.lastIndexOf('.') + 1
            )
            this.FileList7.push({
              uid: this.form.chujuFiles[i].id,
              name: name,
              ftype: type,
              isShow: false,
              curPercentage: 100
            })
          }
          for (var i = 0; i < this.form.freeFiles.length; i++) {
            var name = this.form.freeFiles[i].name.split('.')[0]
            var type = this.form.freeFiles[i].name.substring(
              this.form.freeFiles[i].name.lastIndexOf('.') + 1
            )
            this.FileList5.push({
              uid: this.form.freeFiles[i].id,
              name: name,
              ftype: type,
              isShow: false,
              curPercentage: 100
            })
          }
          for (var i = 0; i < this.form.invoiceFile.length; i++) {
            //发票
            var name = this.form.invoiceFile[i].name.substring(
              0,
              this.form.invoiceFile[i].name.lastIndexOf('.')
            )
            var type = this.form.invoiceFile[i].name.substring(
              this.form.invoiceFile[i].name.lastIndexOf('.') + 1
            )
            this.FileList3.push({
              uid: this.form.invoiceFile[i].id,
              name: name,
              ftype: type,
              isShow: false,
              curPercentage: 100
            })
          }
         
          if (this.form.result == 1 || this.form.bs_Result == 1) {
            this.sealbianji = false
          }
          this.form.link.forEach((value, index, array) => {
            if (value.result == -1) {
              // 流程中
              array[index].result = 'process'
              array[index].name += '(待审核)'
            } else if (value.result == 0) {
              // 审核通过
              array[index].result = 'success'
              array[index].name += '(通过)'
            } else if (value.result == 1) {
              // 审核不通过
              array[index].result = 'error'
              array[index].name += '(不通过)'
            }
          })
          this.form.bcbdTable.forEach((value, index, array) => {
            array[index].count = index + 1
          })
          this.form.tableData.forEach((value, index, array) => {
            array[index].count = index + 1
          })
          this.FileList = this.FileList1.concat(this.FileList2)
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 获取案件日志
    async GetCaseLog() {
      await caseLogApi({
        Id: this.$route.query.guid,
        type: 'case'
      }).then((res) => {
        if (res.data.status == 'success') {
          this.logs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 时间格式转换
    formatTime(row, b) {
      if(row==''||row==null){
        return ''
      }
      const date = new Date(row)
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      if (b == 1) {
        return (
          year +
          '-' +
          month +
          '-' +
          day +
          ' ' +
          hours +
          ':' +
          minutes +
          ':' +
          seconds
        )
      } else {
        return (
          year + '-' + month + '-' + day
          //  +
          // ' ' +
          // hours +
          // ':' +
          // minutes +
          // ':' +
          // seconds
        )
      }
    },

    // 步骤条点击事件
    step_click(item) {
      if (item == this.$route.query.guid) {
        return
      }
      this.$store.commit('setmenustatus', 1)
      this.$router.push({
        path: '/home/case/caseinfo',
        query: {
          guid: item,
          status: this.form.typeId,
          caseType: this.form.typeId.substring(21, 23),
          mystatus: this.$route.query.mystatus
        }
      })
      // this.$router.go(0)
      window.location.reload()
    },

    // 获取代理律师
    async GetLawyer() {
      await caseLawyerApi({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data
          if (!this.bianji) {
            this.sealForm.applicant = res.data.data[0].uid
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 代理律师 改变 --> 获取二次审批人
    async LeadLawyerChange(lvshi) {
      await this.GetLevel(lvshi[0])
      await this.GetFKW(lvshi[0])
      await this.GetCriminal(lvshi[0])
      await this.GetDepartmentLeaders(lvshi[0])
    },

    // 获取案件审核部门主管
    async GetDepartmentLeaders(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      
      await caseDepartmentLeadersApi({
        Id: lvshi
      }).then((res) => {
        if (res.data.status == '0') {
          this.CaseLeaders = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 风控委
    async GetFKW(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      // if (this.form.result != 1 || this.form.bs_Result != 1) {
      //   this.form.level = null
      // }
      await caseLawyerApi({
        Id: lvshi,
        apporver: null,
        risk_controler: true,
        criminal_risk_controler: null
      }).then((res) => {
        if (res.data.status == 'success') {
          this.FKW = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 刑事风险控制人
    async GetCriminal(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      // if (this.form.result != 1 || this.form.bs_Result != 1) {
      //   this.form.criminalrisk = null
      // }
      // this.form.criminalrisk = null
      await caseLawyerApi({
        Id: lvshi,
        apporver: null,
        risk_controler: null,
        criminal_risk_controler: true
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Criminal = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 案件二次审批人
    async GetLevel(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      // this.form.level = ''
      // console.log(this.form.level )
      // if (this.form.result != 1 || this.form.bs_Result != 1) {
      //   this.form.level = []
      // }

      await caseLawyerApi({
        Id: lvshi,
        apporver: 'case_' + this.$route.query.status,
        risk_controler: null,
        criminal_risk_controler: null
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Level = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 用章二次审批人
    async GetSealLevel() {
      if (this.sealForm.applicant == '' || this.sealForm.applicant == null) {
        return
      }
      this.sealForm.leadLawyer2 = null
      var newSeal = []
      this.cities.forEach((value) => {
        if (value.stype.length > 0) {
          newSeal.push(value.stype.join(','))
        }
      })
      var uniqueArr = [
        ...new Map(newSeal.map((item) => [item, item])).values()
      ].join(',')

      // console.log('applicant', this.sealForm.applicant)
      // console.log('uniqueArr', uniqueArr)
      await caseLawyerApi({
        Id: this.sealForm.applicant,
        apporver: uniqueArr,
        risk_controler: null,
        criminal_risk_controler: null
      }).then((res) => {
        if (res.data.status == 'success') {
          this.SealLevel = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 用章二次审批人改变
    async SealLawyer() {
      if (this.sealForm.applicant == '' || this.sealForm.applicant == null) {
        return
      }
      this.sealForm.sealType = null
      this.sealForm.sealLeaders = null
      this.sealForm.leadLawyer2 = null
      await caseDepartmentLeadersApi({
        Id: this.sealForm.applicant
      }).then((res) => {
        if (res.data.status == '0') {
          this.SealLeaders = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 获取所有关联案件Link
    async GetCaseLink(casetitle) {
      this.caseLinkloading = true
      // console.log('casetitle', casetitle)
      await getCaseLinkApi({
        CaseTypeId: this.$route.query.status,
        CaseTitle: casetitle
        // Id: this.$route.query.guid
      })
        .then((res) => {
          if (res.data.status == '0') {
            this.Caselevel = res.data.data
            this.caseLinkloading = false
            // console.log('GetCaseLink_GetCaseLink', this.Caselevel)
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.caseLinkloading = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.caseLinkloading = false
            this.$message.error('关联案件Link获取失败!')
          }
        })
        .catch((err) => {
          this.caseLinkloading = false
          console.log('cl', err)
          this.$message.error('错误!')
        })
    },

    async GetCaseInfoLink() {
      await getCaseInfoLinkApi({
        CaseTypeId: this.$route.query.status,
        CaseGuid: this.form.linkId
      })
        .then((res) => {
          if (res.data.status == '0') {
            var v1 = res.data.data
            var v2 = this.Caselevel
            v1.forEach((v) => {
              if (v2.filter((item) => item.value == v.value).length == 0) {
                this.Caselevel.push(v)
              }
            })

            // console.log('ccc', this.Caselevel)
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.caseLinkloading = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.caseLinkloading = false
            this.$message.error('关联案件Link获取失败!')
          }
        })
        .catch((err) => {
          this.caseLinkloading = false
          // console.log('cinl', err)
          this.$message.error('错误!')
        })
    },

    arrToString(arr) {
      return arr.join(' , ')
    },

    // 案件冲突查看
    conflictClick(row) {
      //this.$store.commit('setmenustatus', 1)
      // this.$router.push({
      //   path: '/home/case/caseinfo',
      //   query: {
      //     guid: row.id,
      //     status: row.typeId,
      //     caseType: row.typeId.substring(21, 23)
      //   }
      // })
      // this.$router.go(0)
      // const windowFeatures = "left=100,top=200,width=1100,height=520";
      // window.open(
      //    "http://localhost:5276/#/home/case/caseinfo?guid="+row.id+"&status="+row.typeId+"&caseType="+row.typeId.substring(21, 23),
      //   // "http://localhost:5276/#/login",
      //   "mozillaWindow",
      //   windowFeatures,
      // );

      this.chongCaseType = row.typeId.substring(21, 23)
      allCaseApi({
        Id: row.id,
        SelectType: 1 //（0：案件管理，1：案件明细）
      }).then((res) => {
        if (res.data.status == '0') {
          // 案件信息
          this.CTform = res.data.data[0]
          this.CTform.bcz = Object.assign({}, this.CTform.bcz, JSON.parse(res.data.data[0].bcz));
          this.CTform.bcz.tableData=[]
          // console.log(this.numType,this.numType==11,this.CTform.tableData)
           if(this.chongCaseType==11&&this.CTform.tableData){
            this.$set(this.CTform, 'bcz', {
              tableData: (this.CTform.tableData || []).map(item => ({
                id: item.id,
                name: item.name ,
                idnumber: item.idnumber ,
                isUnit: item.isUnit,
                isClient: item.isClient,
                attribute: item.attribute || "客户名称",
                count: item.sort,
                order: item.order,
              }))
            });
           }
          //  console.log(this.CTform.bcz.tableData)
          //其他东西
          // this.CTform.bcz = JSON.parse(res.data.data[0].bcz)
          for (var i = 0; i < this.CTform.biddingSchemes.length; i++) {
            var name = this.CTform.biddingSchemes[i].name.split('.')[0]
            var type = this.CTform.biddingSchemes[i].name.substring(
              this.CTform.biddingSchemes[i].name.lastIndexOf('.') + 1
            )
          }
          this.isChong = true
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    closChong() {
      this.isChong = false
    },
    //冲突
    async selectChontu() {
      if (
        this.numType == 1 ||
        this.numType == 2 ||
        this.numType == 3 ||
        this.numType == 4 ||
        this.numType == 5 ||
        this.numType == 6 ||
        this.numType == 9 ||
        this.numType == 11
      ) {
        // console.log('tableData', this.form.tableData)
        this.form.tableData = this.form.tableData.filter(
          (item) =>
            item.name != '' &&
            item.name != null &&
            item.isClient !== '' &&
            item.isClient !== null &&
            item.isUnit !== '' &&
            item.isUnit !== null
        )

        var att = ''
        this.form.tableData.forEach((value, index, array) => {
          if (value.isClient) {
            att = value.attribute
          }
        })
        await caseConflictApi({
          listLitigant_param: this.form.tableData,
          CaseId: this.form.id,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            if (res.data.data.length > 0) {
              this.allConflictCase = res.data.data
              this.conflictTable = this.allConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
              if(this.conflictTable.length==0){//没有冲突案件
                this.conflictTable.push(this.allConflictCase[0])
              } 
              if(this.allConflictCase.length>this.conflictTable.length&&this.allConflictCase.length>1){
                this.hasMore=true
              }
              // console.log("this.hasMore",this.hasMore)
             
            }
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })

        await BanruptcykConflictApi({
          listLitigant_param: this.form.tableData,
          CaseId: this.form.id,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            if (res.data.data.length > 0) {
              this.BanruptcykConflictTable = res.data.data
            }
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
          await caseAdviserApi({
          listLitigant_param: this.form.tableData,
          CaseId: this.form.id,
          Attribute: att
        }).then((res) => {
          if (res.data.status == 'success') {
            if (res.data.data.length > 0) {
              this.lvShiConflictTable = res.data.data
            }
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },

    // 按钮过滤
    buttonFliter() {
      var type = this.$route.query.mystatus
      // 我的
      if (type == 1) {
        if (this.$store.state.rolesname.includes('myDetail_caseinput')) {
          this.Detail_caseinput = true
        }
        if (this.$store.state.rolesname.includes('myDetail_update')) {
          this.Detail_update = true
        }
        if (this.$store.state.rolesname.includes('myDetail_down')) {
          this.Detail_down = true
        }
        if (this.$store.state.rolesname.includes('myDetail_enter')) {
          this.Detail_enter = true
        }
        if (this.$store.state.rolesname.includes('myDetail_ja')) {
          this.Detail_ja = true
        }
        if (this.$store.state.rolesname.includes('myDetail_gd')) {
          this.Detail_gd = true
        }
        if (this.$store.state.rolesname.includes('myDetail_look')) {
          this.Detail_look = true
        }
        if (this.$store.state.rolesname.includes('myDetail_lawyer')) {
          this.Detail_lawyer = true
        }
        if (this.$store.state.rolesname.includes('myDetail_litigant')) {
          this.Detail_litigant = true
        }
      }
      // 全部
      else if (type == 2) {
        if (this.$store.state.rolesname.includes('allDetail_caseinput')) {
          this.Detail_caseinput = true
        }
        if (this.$store.state.rolesname.includes('allDetail_update')) {
          this.Detail_update = true
        }
        if (this.$store.state.rolesname.includes('allDetail_down')) {
          this.Detail_down = true
        }
        if (this.$store.state.rolesname.includes('allDetail_enter')) {
          this.Detail_enter = true
        }
        if (this.$store.state.rolesname.includes('allDetail_ja')) {
          this.Detail_ja = true
        }
        if (this.$store.state.rolesname.includes('allDetail_gd')) {
          this.Detail_gd = true
        }
        if (this.$store.state.rolesname.includes('allDetail_look')) {
          this.Detail_look = true
        }
        if (this.$store.state.rolesname.includes('allDetail_lawyer')) {
          this.Detail_lawyer = true
        }
        if (this.$store.state.rolesname.includes('allDetail_litigant')) {
          this.Detail_litigant = true
        }
      }
      // 已归档
      else if (type == 5) {
        if (this.$store.state.rolesname.includes('filedDetail_caseinput')) {
          this.Detail_caseinput = true
        }
        if (this.$store.state.rolesname.includes('filedDetail_update')) {
          this.Detail_update = true
        }
        if (this.$store.state.rolesname.includes('filedDetail_down')) {
          this.Detail_down = true
        }
        if (this.$store.state.rolesname.includes('filedDetail_enter')) {
          this.Detail_enter = true
        }
        if (this.$store.state.rolesname.includes('filedDetail_ja')) {
          this.Detail_ja = true
        }
        if (this.$store.state.rolesname.includes('filedDetail_gd')) {
          this.Detail_gd = true
        }
        if (this.$store.state.rolesname.includes('filedDetail_look')) {
          this.Detail_look = true
        }
      }
    },

    // 案件当事人背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.isClient||row.IsClient) {
        return 'isclient-row'
      } else {
        return ''
      }
    },

    // 可选律师
    updateDifferenceSet(currentSelectValue) {
      //计算每个下拉菜单的可以选中的选项
      let remainingOption = this.Lawyer.filter((item) => {
        return (
          this.form.leadLawyer.indexOf(item.id) == -1 ||
          currentSelectValue.indexOf(item.id) != -1
        )
      })
      return remainingOption
    },

    //更换律师
    updateLawyer() {
      // this.dialoglawyer.coCounsel =JSON.parse(JSON.stringify(this.form.coCounsel))
      this.dialoglawyer.coCounsel = JSON.parse(
        JSON.stringify(this.form.coCounsel)
      )
      this.lawyerDialog = true
    },
    UpdateCo() {
      if (
        this.dialoglawyer.coCounsel.sort().toString() ==
        this.form.coCounsel.sort().toString()
      ) {
        this.lawyerDialog = false
        // this.$message.info("取消操作")
      } else {
        UpdateLawyer({
          Id: this.form.id,
          CoCounsel: this.dialoglawyer.coCounsel
        }).then((res) => {
          if (res.data.status == 'success') {
            this.$message.success(res.data.message)
            this.form.coCounsel = this.dialoglawyer.coCounsel
            this.GetCaseLog()
            this.lawyerDialog = false
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.lawyerDialog = false
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
            this.lawyerDialog = false
          }
        })
      }
    },
    // 未审核
    GetProcess() {
      if (
        this.form.status == 0 &&
        this.form.result == 0 &&
        this.form.bs_Status == 1
      ) {
        CaseProcess({ SealId: this.form.bid }).then((res) => {
          if (res.data.status == 'success') {
            this.Process = res.data.data
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      } else {
        CaseProcess({ CaseId: this.form.id }).then((res) => {
          if (res.data.status == 'success') {
            this.Process = res.data.data
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      }
    },
    getRandomColor1(show) {
      if (show==1) return '#e86e30'
      else return 'blue'
    },
    getRandomColor(item, show) {
      if (show) return '#e86e30'
      else if (item) return 'blue'
    },

    // getword({Id:id}).then((res)=>{
    //   if(res.data.status==200){
    //     console.log(res.data.data)
    //   }else{
    //     this.$message.error(res.data.message)
    //   }
    // })

    // 电子归档
    // http://localhost:5276/api/Filer/PcGet?Id=
    async etext() {
      this.loading = true
      this.dianji = true
      getEText({ caseId: this.form.id }).then(async (res) => {
        // console.log('res', res.data.data)
        var et = res.data.data
        const zip = new JSZip()
        const promises = []
        et.map(async (item, index) => {
          // var fname = item.name.substring(0, item.name.indexOf('.') - 1)
          // var ftype = item.name.substring(
          //   item.name.indexOf('.'),
          //   item.name.length
          // )
          let fileName = item.name
          const promise = this.getFile(item.id).then((data) => {
            if (!!zip.files[fileName]) {
              //文件重名处理
              fileName = this.handleDuplicationName(zip.files, fileName)
            }

            zip.file(fileName, data, { binary: true }) //文件名、文件流、是否为二进制
          })
          promises.push(promise)
        })
        // console.log('promises', promises)
        Promise.all(promises)
          .then(() => {
            this.loading = false
            this.dianji = false
            zip.generateAsync({ type: 'blob' }).then((content) => {
              const link = document.createElement('a')
              link.href = URL.createObjectURL(content)
              link.download = '电子归档.zip'
              link.click()
              this.GetCaseLog()
            })
          })
          .catch((err) => {
            this.$message.error(err)
          })
      })
    },

    getFile(url) {
      return new Promise((resolve, reject) => {
        YuLan({ Id: url })
          .then(async (res) => {
            resolve(res.data) // 将下载的文件返回
            // console.log('将下载的文件返回', res.data)
          })
          .catch((err) => {
            reject(err)
            // console.log('下载错误', err)
          })
      })
    },

    handleDuplicationName(files, fileName) {
      let name = fileName

      if (!!files[name]) {
        let splitName = name.split('.')

        //文件名存在，从后往前找是否有括号，没有的话从（1）开始
        if (name.lastIndexOf('(') <= 0 || name.lastIndexOf(')') <= 0) {
          name = splitName[0] + '(' + 1 + ')' + '.' + splitName[1]
        } else {
          //如果文件名存在（含括号的文件名）就截取括号中的值，并替换
          let num = name.slice(name.indexOf('(') + 1, name.indexOf(')'))
          // name = splitName[0]+ "("+ (++num) +")" +'.'+splitName[1];
          name = name.replace(num, ++num)
        }

        //递归，没有的再给返回
        name = this.handleDuplicationName(files, name)
      }

      return name
    },

    // 案件状态改变 已经不用了
    async inputType(ajs, param) {
      // console.log("案件昨天")
      this.addTableData = null
      this.form.caseType = this.$route.query.status
      this.Chargestatus=this.Chargestatus1
      if (this.form.caseType == '00000000-0000-0000-0001-000000000000') {
        this.Ajstatus = [
          { label: '一审', value: '一审' },
          { label: '二审', value: '二审' },
          { label: '再审', value: '再审' },
          { label: '破产申报', value: '破产申报' },
          { label: '破产申请', value: '破产申请' },
          { label: '再审听证', value: '再审听证' },
          { label:'强制清算',value:'强制清算'},
          { label: '执行', value: '执行' },
          { label: '审判监督', value: '审判监督' },
          { label: '公示催告', value: '公示催告' },
          { label: '督促', value: '督促' },
          { label: '选民资格案件(特别)', value: '选民资格案件(特别)' },
          {
            label: '宣告失踪、宣告死亡案件(特别)',
            value: '宣告失踪、宣告死亡案件(特别)'
          },
          {
            label: '认定公民无民事行为能力、限制行为能力案件(特别)',
            value: '认定公民无民事行为能力、限制行为能力案件(特别)'
          },
          { label: '认定财产无主案件(特别)', value: '认定财产无主案件(特别)' },
          {
            label: '制定遗产管理人案件(特别)',
            value: '制定遗产管理人案件(特别)'
          },
          { label: '确认调解协议案件(特别)', value: '确认调解协议案件(特别)' },
          { label: '实现担保物权案件(特别)', value: '实现担保物权案件(特别)' },
          { label: '申请撤销裁决', value: '申请撤销裁决' },
        ]
        if (ajs == '一审') {
          this.ArrtibuteOptions = [
            { value: '原告', label: '原告', order: 100 },
            { value: '被告', label: '被告', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '二审') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '被上诉人', label: '被上诉人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 },
            { value: '原审第三人', label: '原审第三人', order: 400 },
            { value: '原审原告', label: '原审原告', order: 500 },
            { value: '原审被告', label: '原审被告', order: 600 }
          ]
        } else if (ajs == '再审'||ajs=="申请撤销裁决") {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '再审听证'||ajs=='强制清算') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '破产申报') {
          this.ArrtibuteOptions = [
            // { value: '申请人', label: '申请人', order: 100 },
            { value: '债务人', label: '债务人', order: 200 },
            // { value: '第三人', label: '第三人', order: 300 },
            { value: '债权人', label: '债权人', order: 400 },
          ]
        }else if (ajs == '破产申请') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
          ]
        }  else if (ajs == '执行') {
          this.ArrtibuteOptions = [
            { value: '申请执行人', label: '申请执行人', order: 100 },
            { value: '被执行人', label: '被执行人', order: 200 },
            { value: '利害关系人', label: '利害关系人', order: 300 },
            { value: '案外人', label: '案外人', order: 400 }
          ]
        } else if (ajs == '审判监督') {
          this.ArrtibuteOptions = [
            { value: '再审申请人', label: '再审申请人', order: 100 },
            { value: '再审被申请人', label: '再审被申请人', order: 200 }
          ]
        } else if (ajs == '公示催告') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '支付人', label: '支付人', order: 200 },
            { value: '利害关系人', label: '利害关系人', order: 300 }
          ]
        } else if (ajs == '督促') {
          this.ArrtibuteOptions = [
            { value: '债权人', label: '债权人', order: 100 },
            { value: '债务人', label: '债务人', order: 200 }
          ]
        } else if (ajs == '选民资格案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '起诉人', label: '起诉人', order: 100 },
            { value: '选举委员会', label: '选举委员会', order: 200 },
            { value: '有关公民', label: '有关公民', order: 300 }
          ]
        } else if (ajs == '宣告失踪、宣告死亡案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        } else if (ajs == '认定公民无民事行为能力、限制行为能力案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '代理人', label: '代理人', order: 300 }
          ]
        } else if (ajs == '认定财产无主案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '原财产所有人', label: '原财产所有人', order: 200 },
            { value: '继承人', label: '继承人', order: 300 }
          ]
        } else if (ajs == '制定遗产管理人案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '遗产管理人', label: '遗产管理人', order: 300 }
          ]
        } else if (
          ajs == '确认调解协议案件(特别)' ||
          ajs == '实现担保物权案件(特别)'
        ) {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        }
      } else if (this.form.caseType == '00000000-0001-0001-0002-000000000000') {
        this.Chargestatus=this.Chargestatus2
        this.Ajstatus = [
          { label: '侦查', value: '侦查' },
          { label: '审查起诉', value: '审查起诉' },
          { label: '法院审理(一审)', value: '法院审理(一审)' },
          { label: '被告人上诉(二审)', value: '被告人上诉(二审)' },
          { label: '检察机关抗诉(二审)', value: '检察机关抗诉(二审)' },
          { label: '刑事申诉', value: '刑事申诉' },
          { label: '再审', value: '再审' },
          { label: '自诉案件', value: '自诉案件' },
          { label: '刑事附带民事诉讼', value: '刑事附带民事诉讼' },
          // { label: '涉及单位犯罪', value: '涉及单位犯罪' },
          { label: '死刑复核程序', value: '死刑复核程序' },
          {
            label: '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序 ',
            value: '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序 '
          },
          {
            label: '依法不负刑事责任的精神病人的强制医疗程序',
            value: '依法不负刑事责任的精神病人的强制医疗程序'
          }
        ]
        if (ajs == '侦查' || ajs == '审查起诉') {
          this.ArrtibuteOptions = [
            { value: '犯罪嫌疑人', label: '犯罪嫌疑人', order: 100 },
            { value: '公诉机关', label: '公诉机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '法院审理(一审)') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 },
            // { value: '控诉人', label: '控诉人', order: 200 },
            { value: '公诉机关', label: '公诉机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '被告人上诉(二审)') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '检察机关', label: '检察机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '检察机关抗诉(二审)') {
          this.ArrtibuteOptions = [
            { value: '抗诉人', label: '抗诉人', order: 100 },
            // { value: '被抗诉人', label: '被抗诉人', order: 200 },
            { value: '原审被告人', label: '原审被告人', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '刑事申诉') {
          this.ArrtibuteOptions = [
            { value: '申诉人', label: '申诉人', order: 100 }
          ]
        } else if (ajs == '再审') {
          this.ArrtibuteOptions = [
            { value: '再审申请人', label: '再审申请人', order: 100 },
            { value: '再审被申请人', label: '再审被申请人', order: 200 }
          ]
        } else if (ajs == '自诉案件') {
          this.ArrtibuteOptions = [
            { value: '自诉人', label: '自诉人', order: 100 },
            { value: '被告人', label: '被告人', order: 200 }
          ]
        } else if (ajs == '刑事附带民事诉讼') {
          this.ArrtibuteOptions = [
            {
              value: '刑事附带民事诉讼原告',
              label: '刑事附带民事诉讼原告',
              order: 100
            },
            {
              value: '刑事附带民事诉讼被告',
              label: '刑事附带民事诉讼被告',
              order: 200
            }
          ]
        } else if (ajs == '涉及单位犯罪') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 },
            { value: '控诉人', label: '控诉人', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '死刑复核程序') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 }
          ]
        } else if (
          ajs == '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序' ||
          ajs == '依法不负刑事责任的精神病人的强制医疗程序'
        ) {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        }
      } else if (this.form.caseType == '00000000-0002-0002-0003-000000000000') {
        this.Ajstatus = [
          { label: '一审(行政诉讼)', value: '一审(行政诉讼)' },
          { label: '二审(行政诉讼)', value: '二审(行政诉讼)' },
          { label: '申请再审(行政诉讼)', value: '申请再审(行政诉讼)' },
          { label: '执行阶段(行政诉讼)', value: '执行阶段(行政诉讼)' },
          { label: '行政裁决', value: '行政裁决' },
          { label: '行政复议', value: '行政复议' },
          { label: '行政处罚', value: '行政处罚' },
          { label: '行政许可', value: '行政许可' },
          { label: '行政强制', value: '行政强制' },
          { label: '政府信息公开', value: '政府信息公开' }
        ]

        if (ajs == '一审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '原告', label: '原告', order: 100 },
            { value: '请求人', label: '请求人', order: 101 },
            { value: '被告', label: '被告', order: 200 },
            { value: '权利人', label: '权利人', order: 201 },
            { value: '第三人', label: '第三人', order: 300 },
          ]
        } else if (ajs == '二审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '被上诉人', label: '被上诉人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 },
            { value: '原审第三人', label: '原审第三人', order: 300 },
            { value: '原审原告', label: '原审原告', order: 300 },
            { value: '原审被告', label: '原审被告', order: 300 }
          ]
        } else if (ajs == '申请再审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '原审第三人', label: '原审第三人', order: 300 }
          ]
        } else if (ajs == '行政裁决') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        }else if (ajs == '行政复议') {
          this.ArrtibuteOptions = [
            { value: '复议申请人', label: '复议申请人', order: 100 },
            { value: '复议被申请人', label: '复议被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '执行阶段(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '申请执行人', label: '申请执行人', order: 100 },
            { value: '被申请执行人', label: '被申请执行人', order: 200 },
            {
              value: '执行异议中的利害关系人',
              label: '执行异议中的利害关系人',
              order: 300
            },
            { value: '案外人', label: '案外人', order: 400 }
          ]
        } else if (ajs == '行政处罚') {
          this.ArrtibuteOptions = [
            { value: '当事人', label: '当事人', order: 100 },
            { value: '行政主体', label: '行政主体', order: 200 },
            {
              value: '利害关系人',
              label: '利害关系人',
              order: 300
            }
          ]
        } else if (ajs == '行政许可') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被许可人', label: '被许可人', order: 200 },
            {
              value: '行政主体',
              label: '行政主体',
              order: 300
            },
            {
              value: '利害关系人',
              label: '利害关系人',
              order: 400
            }
          ]
        } else if (ajs == '行政强制') {
          this.ArrtibuteOptions = [
            { value: '当事人', label: '当事人', order: 100 },
            { value: '行政主体', label: '行政主体', order: 200 },
            {
              value: '其他人员',
              label: '其他人员',
              order: 300
            }
          ]
        } else if (ajs == '政府信息公开') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请机关', label: '被申请机关', order: 200 },
            {
              value: '第三方',
              label: '第三方',
              order: 300
            }
          ]
        }
      } else if (this.form.caseType == '00000000-0003-0003-0004-000000000000') {
        this.ArrtibuteOptions = [
          { value: '申请执行人', label: '申请执行人', order: 100 },
          { value: '被执行人', label: '被执行人', order: 200 },
          { value: '执行异议人', label: '执行异议人', order: 300 },
          { value: '案外人', label: '案外人', order: 400 },
          { value: '复议申请人', label: '复议申请人', order: 500 },
        ]
      } else if (this.form.caseType == '00000000-0004-0004-0005-000000000000') {
        this.ArrtibuteOptions = [
          { value: '申请人', label: '申请人', order: 100 },
          { value: '被申请人', label: '被申请人', order: 200 },
          { value: '第三人', label: '第三人', order: 300 }
        ]
      } else if (this.form.caseType == '00000000-0005-0005-0006-000000000000') {
        this.ArrtibuteOptions = [
          { value: '申请人', label: '申请人', order: 100 },
          { value: '被申请人', label: '被申请人', order: 200 },
          { value: '第三人', label: '第三人', order: 300 }
        ]
      } else if (this.form.caseType == '00000000-0006-0006-0007-000000000000') {
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
        this.ArrtibuteOptions = [
          { value: '客户名称', label: '客户名称', order: 100 },
          { value: '对方当事人', label: '对方当事人', order: 200 }
        ]
        // this.form.tableData = [
        //   {
        //     // 表格
        //     isUnit: false,
        //     name: null,
        //     isClient: true,
        //     attribute: '客户名称',
        //     count: 0,
        //     order: 100
        //   },
        //   {
        //     // 表格
        //     isUnit: false,
        //     name: null,
        //     isClient: false,
        //     attribute: '对方当事人',
        //     count: 1,
        //     order: 200
        //   }
        // ]
      } else if (this.form.caseType == '00000000-0007-0007-0008-000000000000') {
        this.ArrtibuteOptions = []
        this.form.tableData = []
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
      } else if (this.form.caseType == '00000000-0013-0013-0014-000000000000') {
        this.ArrtibuteOptions = []
        this.form.tableData = []
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
      } else if (this.form.caseType == '00000000-0008-0008-0009-000000000000') {
        this.ArrtibuteOptions = [
          { value: '客户名称', label: '客户名称', order: 100 },
          { value: '对方当事人', label: '对方当事人', order: 200 }
        ]
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
        // this.form.tableData = [
        //   {
        //     // 表格
        //     isUnit: false,
        //     nname: null,
        //     isClient: true,
        //     attribute: '客户名称',
        //     count: 0,
        //     order: 100
        //   },
        //   {
        //     // 表格
        //     isUnit: false,
        //     name: null,
        //     isClient: false,
        //     attribute: '对方当事人',
        //     count: 1,
        //     order: 200
        //   }
        // ]
        
      } else if (this.form.caseType == '00000000-0009-0009-0010-000000000000') {
        this.ArrtibuteOptions = []
        this.form.tableData = []
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
      } else if (this.form.caseType == '00000000-0010-0010-0011-000000000000') {
        this.ArrtibuteOptions = []
        this.form.tableData = []
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
      } else if (this.form.caseType == '00000000-0014-0014-0015-000000000000') {
        this.ArrtibuteOptions = []
        this.form.tableData = []
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
      }

      if (param != 'loading') {
        this.form.tableData = []
        this.ArrtibuteOptions.forEach((v) => {
          // 当前已有的最大count
          let c = Math.max.apply(
            Math,
            this.form.tableData.map(function (f) {
              return f.count
            })
          )

          var td
          this.form.tableData.forEach((value, index, arr) => {
            if (v.value == value.Attribute) {
              td = index
            }
          })

          var order
          this.ArrtibuteOptions.forEach((value) => {
            if (v.value == value.value) {
              return (order = value.order)
            }
          })

          if (td === undefined) {
            if (this.form.tableData.length == 0) {
              this.form.tableData.push({
                // 表格
                isUnit: null,
                name: null,
                isClient: false,
                attribute: v.value,
                count: 0,
                order: order,
                idnumber:null,
              })
            } else {
              this.form.tableData.splice(td + 1, 0, {
                // 表格
                isUnit: null,
                name: null,
                isClient: false,
                attribute: v.value,
                count: c + 1,
                order: order,
                idnumber:null,
              })
            }
          } else {
            this.form.tableData.splice(td + 1, 0, {
              // 表格
              isUnit: null,
              name: null,
              isClient: false,
              attribute: v.value,
              count: c + 1,
              order: order,
              idnumber:null,
            })
          }


          this.form.tableData.sort((a, b) => {
            return a.order - b.order
          })

        })

         if(this.form.caseType == '00000000-0002-0002-0003-000000000000'&&ajs == '一审(行政诉讼)'){
          //去掉101和201
          this.form.tableData = this.form.tableData.filter(item => item.order !== 101 && item.order !== 201)
        }
      }
      // this.getLitigants()
    },
    // 用章数据与文档数据加载
    async repeatType() {
      this.form.caseType = this.$route.query.status
      if (this.form.caseType == '00000000-0000-0000-0001-000000000000') {
        this.cities = [
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          },
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['law_seal'] // 用章类型
          },
          {
            name: '律师出庭函', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '听证出庭函', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0001-0001-0002-000000000000') {
        this.cities = [
          
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['law_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '律师事务所函（侦查）', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '律师会见在押犯罪嫌疑人的函（侦查）', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '律师事务所函（检、审）', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '委托协议（辩护）', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '为犯罪嫌疑人提供帮助的委托协议', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书（侦查）', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书（检、审）', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '会见专用介绍信（嫌疑人 被告人）', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '取保候审申请书', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '刑事案件代理委托协议（诉讼代理人）', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书（刑事附带民事）', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书（诉讼代表人）', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '调查取证申请书', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '延期审理申请书', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '解除强制措施申请书', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '提请收集、调取证据申请书', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '通知证人出庭申请书', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '申请取保候审保证书', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
              name: '刑事案件事务所函', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
          },
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0002-0002-0003-000000000000') {
        this.cities = [
          
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['law_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '律师出庭函', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '行政复议出庭函', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0003-0003-0004-000000000000') {
        this.cities = [
         
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['law_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '律师出庭函', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0004-0004-0005-000000000000') {
        this.cities = [
          
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['law_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '律师出庭函', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0005-0005-0006-000000000000') {
        this.cities = [
          
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['law_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '律师出庭函', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(单位)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
          {
            name: '执行授权委托书(个人)', // 模板名
            type: 1, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          },
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0006-0006-0007-000000000000') {
        this.cities = [
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['law_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0007-0007-0008-000000000000') {
        this.cities = [
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['law_seal','official_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0010-0010-0011-000000000000') {
        this.cities = [
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0013-0013-0014-000000000000') {
        this.cities = [
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0014-0014-0015-000000000000') {
        this.cities = [
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0008-0008-0009-000000000000') {
        this.cities = [
          {
            name: '法律意见书审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)

            stype: ['law_seal'] // 用章类型
          },
          {
            name: '单独出具律师函审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['legal_letter_seal'] // 用章类型
          }
        ]

        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0009-0009-0010-000000000000') {
        this.cities = [
          // {
          //   name: '法律意见书审批单', // 模板名
          //   type: 2, // 类型(1:导出，2:打印)
          //   stype: ['law_seal'] // 用章类型
          // },
          // {
          //   name: '单独出具律师函审批单', // 模板名
          //   type: 2, // 类型(1:导出，2:打印)
          //   stype: ['legal_letter_seal'] // 用章类型
          // },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0010-0010-0011-000000000000') {
        this.cities = [
          // {
          //   name: '法律意见书审批单', // 模板名
          //   type: 2, // 类型(1:导出，2:打印)
          //   stype: ['law_seal'] // 用章类型
          // },
          // {
          //   name: '单独出具律师函审批单', // 模板名
          //   type: 2, // 类型(1:导出，2:打印)
          //   stype: ['legal_letter_seal'] // 用章类型
          // },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      } else if (this.form.caseType == '00000000-0014-0014-0015-000000000000') {
        this.cities = [
          // {
          //   name: '法律意见书审批单', // 模板名
          //   type: 2, // 类型(1:导出，2:打印)
          //   stype: ['law_seal'] // 用章类型
          // },
          // {
          //   name: '单独出具律师函审批单', // 模板名
          //   type: 2, // 类型(1:导出，2:打印)
          //   stype: ['legal_letter_seal'] // 用章类型
          // },
          {
            name: '案件审批单', // 模板名
            type: 2, // 类型(1:导出，2:打印)
            stype: ['official_seal'] // 用章类型
          }
        ]
        if (this.checkedCities.length > 0) {
          this.checkedCities = []
        }
        this.cities.forEach((value) => {
          this.checkedCities.push(value.name)
        })
      }
    },

    // 是否能编辑
    wenti() {
      var bj = this.$route.query.bianji
      if (bj) {
        this.bianji = false
      }
    },
    tableRowClass({ row, rowIndex }){
      // console.log("isoth",row.isOther)
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    }
  },

  async created() {
    this.GetLit()
    this.wenti()
    // console.log(this.$route.query.caseType)
    await this.repeatType()
    // console.log('这里是created')
    this.numType = Number(this.$route.query.caseType)
    this.$store.commit('setinputstatus', 0)
    await this.GetCaseLink()
    this.buttonFliter()
    await this.AllCaseApi() //查看明细
    await this.GetLawyer()
    await this.GetCaseLog()
    await this.selectChontu()
    await this.SF_chargingMethodstatus(this.form.chargingMethod)

    if (this.form.leadLawyer.length > 0) {
      await this.LeadLawyerChange(this.form.leadLawyer)
    }
    if (this.sealForm.applicant != null || this.sealForm.applicant != '') {
      await this.SealLawyer()
    }
    this.GetProcess()
    this.Successlog()
    await setTimeout(() => {
      this.loading = false
      this.dianji = false
    }, 100)
    await this.GetSealLevel()

    await this.inputType(this.form.ajstatus, 'loading')
    await this.GetCaseInfoLink()
    // await this.getLitigants()
  }

  // watch: {
  //   'form.tableData': {
  //     handler(newValue, oldValue) {
  //       console.log('form.tableData变化！')
  //       if (newValue.length > 0 && oldValue.length == 0) {

  //       }
  //     },
  //     deep: true
  //   }
  // }
}
</script>
  
<style lang="less" scoped>
// .del_btn {
//   color: #fe964a;
//   border: none;
// }

//  一审、二审
.Top {
  margin: 20px 0;
  // margin-left: 40px;
  display: flex; //把盒子在一行显示
  flex-wrap: wrap; //超出自动换行
  justify-content: center;
  margin: 20px 0;
  margin-left: 58px;
}

/deep/ .el-step__head.is-finish {
  color: #fe964a;
  border-color: #fe964a;
}

/deep/ .el-step__title.is-finish {
  color: #fe964a;
}

/deep/ .el-step__description.is-finish {
  color: #fe964a;
}

/deep/.is-wait .el-step__line {
  background-color: #fe964a;
}

::v-deep .el-input.is-disabled .el-input__inner {
  color: #606266 !important;
}

::v-deep .el-tag.el-tag--info {
  color: #606266 !important;
}

.el-steps--horizontal {
  width: 50%;
}

.Timeline {
  display: flex;
}

.timeaxis {
  display: flex;
  width: 1rem;
  flex-direction: column;
  align-items: center;
}

.title {
  color: #3077e6;
  font-size: 1rem;
  width: 5rem;
  word-break: break-all;
}

.circular {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 0.0625rem solid #3077e6;
}

.tianjiachengxu {
  .timeaxis-xian {
    width: calc(100% - 1rem);

    height: 0.0625rem;
    border-bottom: 0.0625rem solid #fe964a;
    margin-top: 0.4375rem;
    min-width: 6.25rem;
  }

  .el-icon-plus {
    width: 100%;
    color: #fe964a;
    cursor: pointer;
  }

  display: flex;
}

//主体
.text {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}

.icon {
  width: 0.25rem;
  height: 1.125rem;
  background: #3077e6;
  border-radius: 0.5625rem;
  margin-right: 0.3125rem;
}

.el-upload__tip {
  font-size: 14px;
  font-weight: 400;
  color: rgba(182, 182, 182, 1);
  margin-left: 10px;
}

.contain {
  width: 100%;
}

.divider {
  width: calc(100% - 3.125rem);
  float: right;
  border-top: 0.0625rem solid rgba(238, 239, 242, 1);
  margin-bottom: 2rem;
  margin-top: 0.625rem;
}

// 日历
::v-deep .el-input__prefix {
  display: none;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 0.9375rem;
}

// 表格
.party {
  margin-bottom: 55px;
  width: 100%;
  margin: auto;
  margin-left: 5%;
  ::v-deep .isclient-row {
    background: #fff1dc;
  }

  ::v-deep .el-table__body tr:hover > td {
    background-color: transparent !important;
  }

  //::v-deep .el-input__inner {
  //  border: none;
  //}
}

.right {
  width: 80%;
  margin: auto;
  margin-top: 3.125rem;
}

::v-deep .el-timeline-item {
  position: relative;
  padding-bottom: 1.25rem;
  min-height: 6.25rem;
}

.time {
  color: #909399;
}

//按钮
.footer {
  width: 100%;
  text-align: center;
  margin-top: 3.125rem;
  margin-bottom: 1.25rem;
}

.history {
  border: 0.0625rem solid rgb(199, 186, 5);
  color: rgb(199, 186, 5);
}

.submit {
  border: 0.0625rem solid rgba(43, 200, 135, 1);
  color: rgba(43, 200, 135, 1);
}

.fileUpdate {
  border: 0.0625rem solid rgb(19, 92, 228);
  color: rgb(19, 92, 228);
}

//表格
.detail::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}

.btn_warning {
  margin-left: 77%;
}

.top {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}

.addrow {
  margin: 0px 0px 10px 60%;
  display: flex;
  ::v-deep .el-input__inner {
    width: 150px !important;
    margin-right: 10px !important;
  }

  .el-icon-plus {
    color: #fe964a;
    cursor: pointer;
  }
}

.addcase {
  margin: 0rem 0rem 0.625rem 88%;

  .el-icon-plus {
    color: #fe964a;
    cursor: pointer;
  }
}

.el-icon-date {
  position: absolute;
  top: 50%;
  right: 0.625rem;
  z-index: 9;
  color: #c0c4cc;
  font-size: 0.875rem;
  transform: translateY(-50%);
}
.chakanCase {
  color: #3077e6;
  border: none;
}
.copy {
  font-size: 20px;
}
.del_btn {
  font-size: 20px;
}

.del {
  color: #fe964a;
  border: none;
}

.guanlian {
  margin-left: 2%;
}

.fj_text {
  border: 1px solid rgba(48, 119, 230, 1);
  font-size: 16px;
  font-weight: 400;
  color: rgba(48, 119, 230, 1);
}

.fjimg {
  width: 16%;
  margin-bottom: 0.625rem;
}

.input img {
  width: 100%;
  height: 100%;
}

.look {
  color: #fe964a;
  cursor: pointer;
}

.down {
  color: #2bc887;
  margin-left: 0.625rem;
  cursor: pointer;
}

.word {
  line-height: 1.125rem;
  cursor: default;
}

.fname {
  display: inline-flex;
  flex-direction: column;
  padding-left: 0.625rem;
}

// 附件回显
#caseinfo .upload_file {
  width: 360px;
}

#caseinfo .file_show {
  width: 360px;
}

#caseinfo .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#caseinfo img {
  width: 100%;
  height: 100%;
}

#caseinfo .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}

#caseinfo .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#caseinfo .word {
  line-height: 24px;
  cursor: default;
}

#caseinfo /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#caseinfo .look {
  color: #fe964a;
}

#caseinfo .down {
  color: #2bc887;
  margin-left: 10px;
}

#caseinfo .del {
  color: hsl(356, 93%, 50%);
  margin-left: 10px;
}

//进度条
#caseinfo .uploadprocess {
  width: 360px;
}

#caseinfo .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#caseinfo .jdtext {
  width: 360px;
  display: flex;
}

#caseinfo .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}

.conflictTable {
  width: 100%;
}

.ct_table {
  width: 95%;
  margin-left: 2%;
}

.litigant-container {
  // text-align: left;
}

.yz_input {
  ::v-deep .el-input__inner {
    width: 300px !important;
  }
}

::v-deep .el-table--border th.el-table__cell,
::v-deep .el-table td.el-table__cell {
  border-bottom: none !important;
}

::v-deep .el-table--border .el-table__cell {
  border-right: none !important;
}

::v-deep .el-table td.el-table_cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px solid #ebeef5 !important;
}

.el-table:before {
  height: 0px;
}
::v-deep .el-form-item {
  margin-bottom: 16px !important;
}

#caseinfo {
  overflow-x: hidden;
}

.dialog_addrow {
  margin: 0px 0px 10px 35%;
  display: flex;
  ::v-deep .el-input__inner {
    width: 260px !important;
    margin-right: 10px !important;
  }

  .el-icon-plus {
    color: #fe964a;
    cursor: pointer;
  }
}
/deep/.beig-row{
      background: #e6e5e4 !important;
  }
</style>


<style lang="less">
.custom-popper {
  width: 1000px;
}
.input_autocomplete{
  width:100%;
}
</style>popper {
  width: 1000px;
}
</style>

多线程的http